export const sk = {
    addDatabase: {
        addDatabase: "PridaÅ¥ databÃ¡zu",
        addFromFile: "PridaÅ¥ zo sÃºboru",
        analyse: "Analyse",
        analysingYourData: "Analysing your data",
        createFromExcel: "Create from Excel",
        databaseImport: "Database import",
        databaseNotImported: "Import has finished with errors",
        databasePrepared: "Database successfully prepared",
        excelFile: "Excel file",
        fileInformation: "File information",
        fixErrors: "To continue please fix following errors and retry",
        importingYourData: "Importing your data",
        productFilesPath: "Product files path",
        productImagesPath: "Product images path"
    },
    availablePrice: {
        allPackage: "VÅ¡etky balenia",
        onePackage: "Jedno balenie",
        priceType: "Typ ceny",
        setPriceVatVisibility: "NastaviÅ¥ viditeÄ¾nosÅ¥ DPH",
        setVisibilityAndOrder: "NastaviÅ¥ viditeÄ¾nosÅ¥ a poradie typov cien",
        withAndWithoutVat: "S aj bez DPH",
        withVat: "Iba s DPH",
        withoutVat: "Iba bez DPH"
    },
    barvis: {
        base: "NÃ¡zov bÃ¡ze",
        bigCanSize: "VeÄ¾kÃ© plechovky",
        coating: "NÃ¡tery",
        identifier: "IdentifikÃ¡tor",
        laboratory: "LaboratÃ³rium",
        orderOverview: "PrehÄ¾ad objednÃ¡vky",
        rank: "HodnosÅ¥",
        smallCanSize: "MalÃ© plechovky"
    },
    basicSetup: {
        alreadyLoggedIn: "Ste prihlÃ¡senÃ½ ako %{login}.",
        askSupplier: " PoÅ¾iadajte dodÃ¡vateÄ¾a softvÃ©ru o pridanie novÃ½ch licenciÃ­.",
        asterisk: "PoloÅ¾ky oznaÄenÃ© hviezdiÄkou musia byÅ¥ vyplnenÃ©.",
        identificationKeys: "IdentifikaÄnÃ© kÄ¾ÃºÄe",
        importCustomData:
            "Ak je to poÅ¾adovanÃ©, mÃ´Å¾ete importovaÅ¥ vlastnÃ© dÃ¡ta z predchÃ¡dzajÃºceho tÃ³novacieho softvÃ©ru.",
        learnIdentification: "IdentifikaÄnÃ© Ãºdaje VÃ¡m poskytne dodÃ¡vateÄ¾ softvÃ©ru.",
        login: "NasledujÃºce kroky prvotnÃ©ho nastavenia si vyÅ¾adujÃº administrÃ¡torskÃ© oprÃ¡vnenie.",
        noDatabase: "ZatiaÄ¾ nebola vloÅ¾enÃ¡ Å¾iadna databÃ¡za. AspoÅ jedna musÃ­ byÅ¥ prÃ­tomnÃ¡.",
        offlineLicensing: "Offline licencovanie",
        productSelection: "VÃ½ber produktu",
        registrationForm: "RegistraÄnÃ½ formulÃ¡r",
        seeQuestionMark: "Aby ste sa dozvedeli o nastavenÃ­ viac, vÅ¡imnite si malÃ½ otÃ¡zknik pri danom nastavenÃ­.",
        selectDefaultPrinter: "ZvoÄ¾te predvolenÃº tlaÄiareÅ a prispÃ´sobte si dodatoÄnÃ© nastavenia.  ",
        selectDefaultTemplate:
            "ZvoÄ¾te predvolenÃº Å¡ablÃ³nu pre tlaÄ z uÅ¾ existujÃºcich, vytvorte novÃº Å¡ablÃ³nu alebo nahrajte vlastnÃº.",
        selectDispenser: "ZvoÄ¾te typ stroja, ktorÃ½ pouÅ¾Ã­vate.",
        selectLanguage: "ZvoÄ¾te jazyk softvÃ©ru.",
        selectProducts: "ZvoÄ¾te jeden z dostupnÃ½ch produktov, ktorÃ½ si prajete aktivovaÅ¥.",
        selectSpectroType: "ZvoÄ¾te typ spektrometra, ktorÃ½ pouÅ¾Ã­vate.",
        setAdditionalPrinterOptions: "Nastavte dodatoÄnÃ© moÅ¾nosti tlaÄiarne.",
        setAutomaticUpdates: "Nastavte automatickÃ© aktualizÃ¡cie.",
        setCustomItems:
            "Nastavte vlastnÃ© poloÅ¾ky a urÄite, ktorÃ© Ãºdaje sa majÃº vyobraziÅ¥. PosuÅte sa v menu niÅ¾Å¡ie, aby ste videli ÄalÅ¡ie moÅ¾nosti.",
        setEnvironment:
            "Nastavte vÅ¡eobecnÃ© prostredie softvÃ©ru. PosuÅte sa v menu niÅ¾Å¡ie, aby ste videli ÄalÅ¡ie moÅ¾nosti.",
        setFormulaRepresentation:
            "Nastavte vyobrazenie receptÃºry. PosuÅte sa v menu niÅ¾Å¡ie, aby ste videli ÄalÅ¡ie moÅ¾nosti.",
        summary:
            "Tieto nastavenia mÃ´Å¾ete kedykoÄ¾vek zmeniÅ¥. SoftvÃ©r ponÃºka viac moÅ¾nostÃ­ nastavenÃ­, ktorÃ© sÃº VÃ¡m prÃ­stupnÃ©. Å½elÃ¡me VÃ¡m prÃ­jemnÃ© pouÅ¾Ã­vanie softvÃ©ru %{name}!",
        summarySuccess: "VÅ¡etko mÃ¡te nastavenÃ©!"
    },
    beforeDispenseColorantBatch: {
        batchNumber: "Batch number: %{batchNumber}",
        colorantIsDefective: "The canister is filled with a defective batch of colorant. Do not use this batch.",
        defectiveInfoLine1: "Please do not use colorant",
        defectiveInfoLine2: "with this batch number.",
        emptyQuickTint: "Empty the canister using Quick tint.",
        warningInfoLine1: "Colorant",
        warningInfoLine2: "with this batch number may be damaged."
    },
    canisterLevel: {
        canisterLevel: "Hladina kolorantu v kanistri",
        criticalLevelCanister: "KritickÃ¡ hladina kolorantu",
        fillToMax: "DoplniÅ¥ do maxima",
        maxDispenseLevel: "Maximum tÃ³novania",
        otherCanisters: "ÄalÅ¡ie kanistre",
        warningLevelCanister: "VarovnÃ¡ hladina kolorantu"
    },
    canisterRefillHistoryModal: {
        batchNumberOfFilling: "Batch number of filling",
        ufiCodeStatus: "UFI code status"
    },
    canistersTab: {
        availableServiceActions: "DostupnÃ© servisnÃ© Ãºkony",
        canisterInformation: "InformÃ¡cie o kanistri",
        canisterPreview: "NÃ¡hÄ¾ad kanistra",
        currentLevel: "AktuÃ¡lna hladina",
        errors: "Chyby",
        fillState: "Stav kapacity",
        fillToMax: "DoplniÅ¥ do maxima",
        fillingAmount: "MnoÅ¾stvo plnenia",
        finalLevel: "KoncovÃ½ stav",
        minimumAmount: "MinimÃ¡lne mnoÅ¾stvo",
        minimumLevel: "MinimÃ¡lna hladina",
        moveTableToRefill: "PosunÃºÅ¥ stÃ´l na pozÃ­ciu plnenia",
        refillNoAmount: "Nie je zadanÃ© Å¾iadne mnoÅ¾stvo",
        refillOverLimit: "ZadanÃ© mnoÅ¾stvo presahuje maximÃ¡lnu kapacitu kanistra",
        refillSummary: "%{amount} %{unit} pigmentu %{colorant} sa doplnÃ­ do kanistra %{canisterId}.",
        systemWarningAmount: "VarovnÃ© mnoÅ¾stvo",
        warningAmount: "VarovnÃ© mnoÅ¾stvo"
    },
    changeDatabase: {
        changeDatabase: "Zmena databÃ¡zy",
        databaseWarning: "Database %{databaseName} cannot be used due to"
    },
    changelog: {
        allVersion: "All versions",
        changelog: "Changelog",
        link: "Link",
        links: "Links",
        version: "Version",
        versionFilter: "Version filter"
    },
    checkBeforeDispensing: {
        checkBeforeDispensingModal: "There is not enough colorant in the canisters for %{numOfPackages} packages.",
        fillAdditionally: "Fill additionally",
        refillToMax: "Refill to max"
    },
    cleanChannels: {
        cleanAllChannels: "VyÄistiÅ¥ vÅ¡etky okruhy",
        cleanChannels: "VyÄistiÅ¥ okruhy",
        cleaningTime: "Trvanie Äistenia",
        selectChannels: "VybraÅ¥ okruhy",
        startCleaning: "ZahÃ¡jiÅ¥ Äistenie"
    },
    clientServerSettings: {
        activeServer: "AktÃ­vny server",
        addNewServer: "PridaÅ¥ novÃ½ server",
        availableServers: "ÄalÅ¡ie dostupnÃ© servery",
        clientIdentifier: "IdentifikÃ¡tor klienta",
        clientServerSettings: "Nastavenie klienta/serveru",
        disabledStatus: "ZruÅ¡enÃ½",
        editServer: "UpraviÅ¥ server",
        fillRequiredFields: "PovinnÃ© polÃ­Äka musia byÅ¥ vyplnenÃ©.",
        noOtherServers: "Nie sÃº dostupnÃ© Å¾iadne ÄalÅ¡ie servery",
        offlineStatus: "Offline",
        onlineStatus: "Online",
        port: "Port",
        serverName: "NÃ¡zov serveru",
        serverNameMissing: "NÃ¡zov servera musÃ­ byÅ¥ vyplnenÃ½.",
        stabileConnection: "PouÅ¾itÃ­m statickej IP adresy sa zabezpeÄÃ­ stabilnÃ© spojenie.",
        wrongFormatIp: "NesprÃ¡vny formÃ¡t IP adresy"
    },
    colorSearchTab: {
        notEveryItemSelected: "One or more items are not selected"
    },
    colorTab: {
        colorTone: "FarebnÃ½ tÃ³n",
        fandeckPosition: "PozÃ­cia vzorkovnice",
        moreInfoIcons: "Ikonky s viac dÃ¡tami",
        notExistingFormula: "NeexistujÃºce recepÃºry",
        orderBy: "ZoradiÅ¥ podÄ¾a",
        selectYourGrid: "MrieÅ¾ka",
        showInPanel: "VyobraziÅ¥",
        warningIcon: "VarovnÃ¡ ikonka pre neexistujÃºce"
    },
    colorantBatchNumberSettings: {
        batchNumberByPercentage: "Use Batch numbers by percentage",
        batchNumberFromLastFilling: "Use Batch numbers from the last filling",
        defectiveBatchOfColorant: "Defective Batch of colorant",
        enableBatchNumber: "Enable colorant Batch numbers",
        possibleDamagedBatchOfColorant: "Possibly damaged Batch of colorant",
        scanOrTypeBatchNumber: "Scan or type Batch number"
    },
    colorantPanel: {
        manualMachine: "machine"
    },
    colorantsTable: {
        numberOfColorants: "PoÄet kolorantov:",
        preview: "NÃ¡hÄ¾ad",
        prices: "Ceny"
    },
    currencySettings: {
        addNewCurrency: "PridaÅ¥ novÃº menu",
        codePlaceholder: "KÃ³d meny",
        currencySettings: "Nastavenie mien",
        namePlaceholder: "NÃ¡zov",
        ratePlaceholder: "Kurz",
        setDecimalPlaces: "NastaviÅ¥ poÄet desatinnÃ½ch miest",
        setMainCurrency: "NastaviÅ¥ hlavnÃº menu",
        setRounding: "NastaviÅ¥ zaokrÃºhÄ¾ovanie",
        symbolPlaceholder: "Znak"
    },
    customFandecks: {
        customFandecks: "VlastnÃ¡ vzorkovnica",
        deleteButtonWarning: "VÅ¡etky receptÃºry vo vzorkovnici sa vymaÅ¾Ãº s Åou.",
        deleteCustomFandeck:
            "SkutoÄne chcete vymazaÅ¥ tÃºto vlastnÃº vzorkovniu? VÅ¡etky receptÃºry vo vzorkovnici sa vymaÅ¾Ãº s Åou.",
        disableStandardFandecks: "Show only custom fandecks",
        enableStandardFandecks: "Show standard fandecks",
        fandeckName: "NÃ¡zov vzorkovnice"
    },
    customRedlike: {
        addColorantFromBrand: "PridaÅ¥ kolorat zo znaÄky %{brandName}",
        addNewCustomer: "PridaÅ¥ novÃ©ho zÃ¡kaznÃ­ka",
        addNewNote: "PridaÅ¥ novÃº poznÃ¡mku",
        addedDate: "PridaÅ¥ dÃ¡tum",
        addedQuantity: "PridanÃ© mnoÅ¾stvo",
        availableMachine: "Stroj k dispozÃ­cii",
        brand: "ZnaÄka",
        brandPlease: "ProsÃ­m, zvoÄ¾te znaÄku",
        cancelCustomer: "ZruÅ¡iÅ¥ zÃ¡kaznÃ­ka",
        colorPlease: "ProsÃ­m, zvoÄ¾te farbu",
        confirmCustomerData: "PotvrdiÅ¥ Ãºdaje o zÃ¡kaznÃ­kovi",
        confirmNoteData: "PotvrdiÅ¥ poznÃ¡mku",
        confirmSelectedUser: "SkutoÄne chcete priradiÅ¥ zÃ¡kaznÃ­ka %{customerName} k tejto objednÃ¡vke.",
        confirmed: "PotvrdenÃ©",
        controlData: "PoslednÃ¡ kontrola Ãºdajov",
        customerCellNumber: "Mobil zÃ¡kaznÃ­ka",
        customerFilter: "FiltrovaÅ¥ zÃ¡kaznÃ­kov",
        customerName: "Meno zÃ¡kaznÃ­ka",
        customerPhone: "TelefÃ³n zÃ¡kaznÃ­ka",
        customerPlease: "ProsÃ­m, zvoÄ¾te zÃ¡kaznÃ­ka",
        dateFilter: "FiltrovaÅ¥ dÃ¡tum",
        enterPin: "VloÅ¾te PIN kÃ³d",
        enterTheNumberOfPackages: "VloÅ¾te mnoÅ¾stvo balenÃ­",
        existingCustomer: "PouÅ¾Ã­vateÄ¾ uÅ¾ existuje",
        fandeckPlease: "ProsÃ­m, zvoÄ¾te vzorkovnicu",
        fillCanisterHistory: "HistÃ³ria plnenia kanistra",
        findCustomer:
            "ProsÃ­m, naskenujte ÄiarovÃ½ kÃ³d alebo vyhÄ¾adajte emailovÃº adresu, aby ste priradili vernostnÃº kartu.",
        findCustomerByEmail: "FiltrovaÅ¥ zÃ¡kaznÃ­kov podÄ¾a emailu alebo ÄiarovÃ©ho kÃ³du",
        finishPreviousStep: "(ProsÃ­m, dokonÄite predchÃ¡dzajÃºce kroky)",
        formulaUnit: "Jednotka receptÃºry",
        getBackToList: "VrÃ¡tiÅ¥ sa na zoznam zÃ¡kaznÃ­kov",
        historyOfOrders: "HistÃ³ria objednÃ¡vok",
        insertNote: "PrejsÅ¥ na vloÅ¾enie poznÃ¡mky",
        loadHistoryOrder: "Chcete naÄÃ­taÅ¥ zvolenÃº objednÃ¡vku?",
        loyaltyCards: "VernostnÃ© karty",
        machineIsAvailable: "STROJ JE K DISPOZÃCII",
        machineIsUnavailable: "STROJ NIE JE K DISPOZÃCII",
        newLoyaltyCard: "NovÃ¡ vernostnÃ¡ karta",
        noAvailableMachine: "Stroj nie je k dispozÃ­cii",
        noCustomerSelected: "Nie je vybranÃ½ Å¾iaden zÃ¡kaznÃ­k. Chcete pokraÄovaÅ¥?",
        notePlease: "ProsÃ­m, vloÅ¾te poznÃ¡mku",
        openHistory: "OtvoriÅ¥ histÃ³riu",
        orAdd: "alebo pridajte zÃ¡kaznÃ­ka",
        orSelect: "alebo zvoÄ¾te zÃ¡kaznÃ­ka",
        orderModification: "PÃ´vodnÃ¡ objednÃ¡vka sa upravÃ­. Chcete pokraÄovaÅ¥?",
        orderOverview: "PrehÄ¾ad objednÃ¡vky",
        orderToMachine: "POSLAÅ¤ OBJEDNÃVKU NA STROJ",
        ordersHistory: "HistÃ³ria objednÃ¡vok",
        packagePlease: "ProsÃ­m, zvoÄ¾te balenie",
        pleaseSelectBrand: "ProsÃ­m, zvoÄ¾te znaÄku",
        previewImage: "nÃ¡hÄ¾ad obrÃ¡zku",
        previewPackage: "NÃ¡hÄ¾ad balenia",
        productPlease: "ProsÃ­m, zvoÄ¾te produkt",
        resetFilters: "ResetovaÅ¥ vÅ¡etky filtre",
        searchForHistoricalOrders: "Alebo nÃ¡jdite historickÃº objednÃ¡vku",
        selectBrand: "ProsÃ­m, zvoÄ¾te znaÄku",
        selectColor: "PrejsÅ¥ na voÄ¾bu farby",
        selectCustomer: "PrejsÅ¥ na voÄ¾bu zÃ¡kaznÃ­ka",
        selectExistingCustomer: "VybraÅ¥ existujÃºceho zÃ¡kaznÃ­ka",
        selectFandeck: "PrejsÅ¥ na voÄ¾bu vzorkovnice",
        selectManually: "If you want to use this color in %{brandNames} brand, please select it manually.",
        selectPackage: "PrejsÅ¥ na voÄ¾bu balenia",
        selectProduct: "PrejsÅ¥ na voÄ¾bu produktu",
        shotsCoefficient: "Koeficient shotu",
        showDetail: "ZobraziÅ¥ podrobnosti",
        showHideEshopName: "UkÃ¡zaÅ¥/skryÅ¥ nÃ¡zov odtieÅa z e-shopu v samostatnom stÄºpci",
        showKeyboard: "ZobraziÅ¥ klÃ¡vesnicu",
        skipCustomerButton: "PreskoÄiÅ¥ vÃ½ber zÃ¡kaznÃ­ka",
        skipCustomerText: "PreskoÄte, ak nechcete vloÅ¾iÅ¥ zÃ¡kaznÃ­ka",
        skipNote: "PreskoÄiÅ¥ poznÃ¡mku a zobraziÅ¥ zhrnutie",
        spectroBrand: "HÄ¾adÃ¡m v znaÄke %{brandName}",
        statusAccepted: "PrijatÃ©",
        statusCanceled: "ZruÅ¡enÃ©",
        statusCreated: "VytvorenÃ©",
        statusDone: "Hotovo",
        statusPartlyDone: "ÄiastoÄne hotovo",
        statusPreparing: "Pripravuje sa",
        summaryChosenBase: "BÃ¡za",
        summaryChosenBrand: "ZnaÄka",
        summaryChosenCanSize: "VeÄ¾kosÅ¥ plechovky",
        summaryChosenColor: "Farba",
        summaryChosenColorCard: "Vzorkovnica",
        summaryChosenProduct: "Produkt",
        summaryChosenQuantity: "MnoÅ¾stvo",
        summaryColorPreview: "NÃ¡hÄ¾ad farby",
        summaryCustomNote: "VlastnÃ¡ poznÃ¡mka",
        summaryCustomerNumber: "ÄÃ­slo zÃ¡kaznÃ­ka",
        summaryFormula: "ReceptÃºra",
        summaryFormulaNote: "PoznÃ¡mka k receptÃºre",
        summaryNote: "PoznÃ¡mka",
        sureAboutSend: "UrÄite chcete poslaÅ¥ objednÃ¡vku?",
        useCustomerInOrder: "Chcete priradiÅ¥ nasledujÃºcu objednÃ¡vku k zÃ¡kaznÃ­kovi %{customerName}?",
        uuid: "Uuid",
        viewSummary: "ZobraziÅ¥ zhrnutie",
        volume: "Objem"
    },
    customRedlikeAnother: {
        pinOrderConfirmation: "Potvrdenie objednÃ¡vky PIN kÃ³dom",
        pinScreenSaverConfirmation: "Potvrdenie nastavenia PIN kÃ³du Å¡etriÄa obrazovky",
        pinSettingsConfirmation: "Potvrdenie nastavenia PIN kÃ³du",
        printAuto: "PovoliÅ¥ automatickÃº tlaÄ",
        printerSettings: "Nastavenie tlaÄe",
        selectColorWithFandeck: "VÃ½ber farby so vzorkovnicou",
        setKeyboard: "NastaviÅ¥ klÃ¡vesnicu",
        setKioskMode: "NastaviÅ¥ reÅ¾im kiosku",
        setLanguage: "NastaviÅ¥ jazyk",
        setModule: "NastaviÅ¥ modul",
        setQuickSelect: "NastaviÅ¥ rÃ½chly vÃ½ber",
        setScreensaverTimeout: "NastaviÅ¥ ÄasovaÄ Å¡etriÄu obrazovky",
        setUnit: "NastaviÅ¥ jednotku"
    },
    customRedlikeMachine: {
        action: "Akcia",
        additionalPrint: "DodatoÄnÃ¡ tlaÄ",
        brand: "ZnaÄka",
        brandAccess: "PouÅ¾Ã­vateÄ¾ '%{userName}' nemÃ´Å¾e pristupovaÅ¥ k dÃ¡tam zo znaÄky '%{brandName}'",
        can: "UmiestnenÃ¡ plechovka",
        canistersLevel: "PrehÄ¾ad hladiny kanistrov",
        closeDetailInformation: "ZatvoriÅ¥ detail",
        colorantsAmount: "MnoÅ¾stvo kolorantov",
        confirmRefill: "PotvrdiÅ¥ doplnenie kolorantu",
        deleteOrder: "ZmazaÅ¥ objednÃ¡vku",
        dialogNoMachine: "Stroj nie je pripojenÃ½",
        dialogNoRcc: "RCC nie je pripojenÃ©",
        dispense: "TÃ³novanie",
        dispenserInErrorState: "TÃ³novacÃ­ stroj je v chybnom stave",
        dispensingIsOk: "TÃ³novacÃ­ stroj je OK",
        emergencyButtonPressed: "NÃºdzovÃ© tlaÄÃ­tko stlaÄenÃ©",
        errorCode: "KÃ³d chyby",
        errorEvents: "Chyby tÃ³novacieho stroja",
        errorReset: "ReÅ¡tartovanie chyby",
        explanation: "Vysvetlenie",
        imageNotAvailable: "ObrÃ¡zok nie je dostupnÃ½",
        incorrectCanister: "NaskenovanÃ½ nesprÃ¡vny kanister",
        incorrectColorant: "CHYBA: NaskenovanÃ½ nesprÃ¡vny kolorant. ProsÃ­m, naskenujte sprÃ¡vny!",
        lastEvents: "PoslednÃ© udalosti",
        machineActions: "Status tÃ³novacieho stroja",
        machineConfiguration: "KonfigurÃ¡cia tÃ³novacieho stroja.",
        machineError: "Chyba na stroji",
        machineIsBusy: "Stroj je zaneprÃ¡zdnenÃ½",
        machineNotAvailable: "Stroj nie je k dispozÃ­ciÃ­",
        machineTinting: "ProsÃ­m poÄkajte, stroj tÃ³nuje...",
        manualScan: "RuÄnÃ½ sken",
        notEnoughSpace: "CHYBA: Nedostatok miesta pre toto balenie kolorantu",
        numberOfCanistersUnderCriticalLevel: "PoÄet kanistrov s kritickou hladinou je %{0}",
        numberOfCanistersUnderWarningLevel: "PoÄet kanistrov s varovnou hladinou je %{0}",
        offlinePressed: "StlaÄenÃ© tlaÄÃ­tko Offline",
        orderSettings: "Nastavenia objednÃ¡vky",
        otherOrderInformation: "Detail objednÃ¡vky",
        packageCount: "PoÄet balenÃ­",
        packageWithSeparator: "Balenie",
        received: "PrijatÃ©",
        receivedOrders: "PrijatÃ© objednÃ¡vky",
        receivedTime: "Äas prijatia",
        recirculation: "RecirkulÃ¡cia",
        refillInformation: "Kolorant: %{0}, Plnenie %{1}, Kanister: %{2}",
        resetErrors: "ResetovanÃ© chyby",
        scanCanister: "NaskenovaÅ¥ tento kanister",
        scanColorantPackage: "Naskenujte sprÃ¡vne balenie kolorantu",
        selectedOrder: "ZvolenÃ¡ objednÃ¡vka",
        shelfMovingDown: "StÃ´l sa posÃºva nadol",
        shelfMovingUp: "StÃ´l sa posÃºva nahor",
        solution: "RieÅ¡enie",
        startDispensing: "ZaÄaÅ¥ tÃ³novaÅ¥",
        stirring: "Prebieha premieÅ¡avanie",
        touchToStartFilling: "StlaÄte pre zaÄatie plnenia kolorantu",
        unknownBrand: "NeznÃ¡ma znaÄka"
    },
    customRedlikeSettings: {
        addPos: "InformÃ¡cie o predajni",
        addServer: "PridaÅ¥ server",
        adminOperations: "Ãkony administrÃ¡tora",
        adminSettings: "Nastavenia admina",
        another: "InÃ©",
        aslOrService: "ASL alebo servis",
        availableMachines: "DostupnÃ© stroje",
        barcode: "ÄiarovÃ½ kÃ³d",
        basicOperations: "ZÃ¡kladnÃ© operÃ¡cie",
        canisterBarcodes: "ÄiarovÃ© kÃ³dy kanistrov",
        canisterLevels: "Hladiny kanistrov",
        closeConnection: "UzatvoriÅ¥ spojenie",
        closeRedlike: "ZatvoriÅ¥ %{name}",
        databaseList: "DatabÃ¡zy",
        disabledStatus: "zakÃ¡zanÃ©",
        dispenseLogicType: "Typ logiky tÃ³novania",
        dropServers: "ZahodiÅ¥ servery",
        editServer: "UpraviÅ¥ server",
        lastEvent: "PoslednÃ¡ akcia",
        logOut: "OdhlÃ¡siÅ¥ sa",
        machineConfiguration: "KonfigurÃ¡cia",
        maxDispenseAmount: "MaximÃ¡lne vytÃ³novateÄ¾nÃ© mnoÅ¾stvo",
        offlineStatus: "offline",
        onlineStatus: "online",
        openFrondesk: "OtvoriÅ¥ frontdesk",
        print: "Nastavenia tlaÄe",
        rebootPC: "ReÅ¡tart PC",
        restartRedlike: "ReÅ¡tart %{name}",
        restoreConnection: "ObnoviÅ¥ spojenie",
        scanCanisterBarcode: "NaskenovaÅ¥ ÄiarovÃ½ kÃ³d kanistru",
        scanOrDeleteCanisterBarcode: "Naskenujte alebo vymaÅ¾te ÄiarovÃ½ kÃ³d",
        setCanisterBarcode: "NastaviÅ¥ ÄiarovÃ½ kÃ³d kanistra",
        swVersion: "Verzia softvÃ©ru",
        systemFunctions: "SystÃ©movÃ© funkcie",
        userSettings: "Nastavenia pouÅ¾Ã­vateÄ¾a"
    },
    customTab: {
        cifCombinationCheck:
            "The color %{colorName} already exists in fandeck %{fandeckName}, but it contains different spectral data. Would you like to overwrite existing data?",
        editColor: "UpraviÅ¥ farbu",
        editColorant: "UpraviÅ¥ kolorant",
        emptyColorant: "Kolorant nemÃ¡ zadanÃ© mnoÅ¾stvo",
        formulaCombinationCheck:
            'The formula with the color name "%{colorName}" already exists. Would you like to overwrite existing formula with the new one?',
        formulaForMasterProduct: "ReceptÃºra pre master produkt",
        formulaForMasterProductWithParam: "ReceptÃºra pre master produkt %{productName}",
        isNotAvailable: "Nie je dostupnÃ©",
        noBaseSelected: "Nie je vybranÃ¡ bÃ¡za",
        noColorantsSelected: "Nie sÃº vybranÃ© Å¾iadne koloranty",
        noFandeckSelected: "Nie je vybranÃ¡ vzorkovnica",
        noNameOrCode: "PotrebnÃ© zadaÅ¥ nÃ¡zov a kÃ³d farby",
        noProductSelected: "Nie je vybranÃ½ Å¾iadny produkt",
        productPreview: "NÃ¡hÄ¾ad produktu",
        saveCustomRecipe: "UloÅ¾iÅ¥ vlastnÃº receptÃºru",
        saveIsNotAvailable: "NedÃ¡ sa uloÅ¾iÅ¥",
        showSiblingProducts: "UkÃ¡zaÅ¥ prÃ­buznÃ© produkty",
        siblingProducts: "PrÃ­buznÃ© produkty podÄ¾a master produktu"
    },
    customersTab: {
        addCustomer: "PridaÅ¥ zÃ¡kaznÃ­ka",
        additionalSettings: "ÄalÅ¡ie nastavenia",
        adress: "Adresa",
        createAndSelect: "VytvoriÅ¥ a zvoliÅ¥",
        createNewCustomer: "VytvoriÅ¥ novÃ©ho zÃ¡kaznÃ­ka",
        editCustomer: "UpraviÅ¥ zÃ¡kaznÃ­ka",
        expiration: "Customer %{name} will expire in %{dayCount} days",
        identificationNumber: "IdentifikaÄnÃ© ÄÃ­slo",
        information: "InformÃ¡cie o kontakte",
        listOfCustomers: "Zoznam zÃ¡kaznÃ­kov",
        rabat: "Rabat",
        selectCustomer: "ZvoliÅ¥ zÃ¡kaznÃ­ka",
        spentLastMonth: "UtratenÃ© minulÃ½ mesiac",
        spentMoney: "UtratenÃ© peniaze",
        typeOfMargin: "Typ marÅ¾e",
        zipCode: "PSÄ"
    },
    dialog: {
        cheaperColorSearch: "Prebieha vyhÄ¾adÃ¡vanie lacnejÅ¡ieho odtieÅa",
        competitiveColorSearch: "Prebieha vyhÄ¾adÃ¡vanie konkurenÄnÃ½ch odtieÅov",
        reallyChangeModule: "Naozaj chcete zmeniÅ¥ modul?",
        reallyCloseRedlike:
            "SkutoÄne chcete zatvoriÅ¥ %{name}? VÅ¡etky panely %{name} sa zatvoria a neuloÅ¾enÃ© zmeny budÃº stratenÃ©.",
        reallyDeleteOrder: "Naozaj chcete zmazaÅ¥ tÃºto objednÃ¡vku? VÅ¡etky dÃ¡ta s Åou spojenÃ© budÃº stratenÃ©.",
        reallyRebootPC:
            "Naozaj chcete reÅ¡tartovaÅ¥ tento poÄÃ­taÄ? VÅ¡etky panely %{name} sa zatvoria a neuloÅ¾enÃ© zmeny budÃº stratenÃ©.",
        reallyRestartRedlike:
            "SkutoÄne chcete reÅ¡tartovaÅ¥ %{name}? VÅ¡etky %{name} panely budÃº zatvorenÃ© a neuloÅ¾enÃ© zmeny sa stratia.",
        reallyShutdownPc:
            "SkutoÄne chcete vypnÃºÅ¥ poÄÃ­taÄ? VÅ¡etky panely %{name} sa zatvoria a neuloÅ¾enÃ© zmeny budÃº stratenÃ©.",
        unlockComputer: "Computer will be unlocked."
    },
    dispenseLogicTypes: {
        1: "TÃ³novaÅ¥ iba maximÃ¡lne vytÃ³novateÄ¾nÃ© mnoÅ¾stvo",
        2: "PovoliÅ¥ ruÄnÃ© tÃ³novanie pomocou stupnice pre mnoÅ¾stvo presahujÃºce maximÃ¡lne tÃ³novateÄ¾nÃ© mnoÅ¾stvo",
        3: "Plnenie poÄas tÃ³novania (rozdelenie mnoÅ¾stva na menÅ¡ie Äasti)",
        4: "Force manual dispensing using scale only in case of custom package"
    },
    editCustomFandeck: {
        fandeckName: "NÃ¡zov vzorkovnice"
    },
    editFormulaRgbModal: {
        apply: "UpraviÅ¥",
        blue: "ModrÃ¡",
        green: "ZelenÃ¡",
        modalLabel: "UpraviÅ¥ farbu",
        red: "ÄervenÃ¡",
        tryGenerateRgb: "PokÃºsiÅ¥ sa generovaÅ¥ RGB podÄ¾a mnoÅ¾stva kolorantov"
    },
    environmentsSettings: {
        allowAutoCloseTab: "AutomatickÃ© zatvorenie karty receptÃºry",
        allowBarcodes: "PovoliÅ¥ ÄiarovÃ© kÃ³dy",
        allowBuildingSitePanel: "Allow building site specification",
        allowCustomers: "PovoliÅ¥ zÃ¡kaznÃ­kov",
        allowDeleteConfirmation: "PovoliÅ¥ potvrdenie pri mazanÃ­",
        allowDiskSpaceNotification: "Allow disk space notification",
        allowDispensing: "PovoliÅ¥ tÃ³novanie",
        allowFileTransfer: "PovoliÅ¥ automatickÃ½ prenos sÃºborov",
        allowFormulaModificationPanel: "Allow formula modification panel",
        allowFormulaStatusPanel: "PovoliÅ¥ panel stavu receptÃºry",
        allowInternalNotes: "PovoliÅ¥ internÃ© poznÃ¡mky",
        allowLight: "PovoliÅ¥ %{name}",
        allowOrderNotificationModal: "ZobraziÅ¥ upozornenia na novÃ© objednÃ¡vky",
        allowOrdering: "PovoliÅ¥ objednÃ¡vky",
        allowPricing: "PovoliÅ¥ ceny",
        allowPrint: "PovoliÅ¥ tlaÄ",
        allowProductPreviewImage: "PovoliÅ¥ pri tÃ³novanÃ­ nÃ¡hÄ¾ad obrÃ¡zku produktu",
        allowQualityControl: "Allow quality control",
        allowSearchCheaperColors: "PovoliÅ¥ vyhÄ¾adÃ¡vanie lacnejÅ¡Ã­ch odtieÅov",
        allowSound: "PovoliÅ¥ zvukovÃ© upozornenia",
        allowSpectro: "PovoliÅ¥ spektrometer",
        allowTabs: "PovoliÅ¥ karty",
        applyZoom: "PotvrdiÅ¥",
        automaticLogout: "AutomatickÃ© odhlÃ¡senie",
        barcodeScan: "Sken ÄiarovÃ©ho kÃ³du",
        canisterBarcode: "ÄiarovÃ© kÃ³dy kanistrov",
        canisterLevel: "Hladiny kanistrov",
        changelog: "Changelog",
        closeTab: "ZavrieÅ¥ zÃ¡loÅ¾ku",
        colorDifference: "Color difference",
        colorPanelNavItem: "Paleta farieb",
        competitiveColorSearch: "VyhÄ¾adÃ¡vanie konkurenÄnÃ½ch odtieÅov",
        customBanner: "VlastnÃ½ banner",
        customCurrencyFormat: "FormÃ¡t meny",
        customDateFormat: "FormÃ¡t dÃ¡tumu",
        customNumberFormat: "FormÃ¡t ÄÃ­sel",
        customTimeFormat: "FormÃ¡t Äasu",
        deltaA: "Delta A",
        deltaB: "Delta B",
        deltaE: "Delta E",
        deltaL: "Delta L",
        deltaMetamerism: "Delta metamerism",
        discount: "ZobraziÅ¥ zÄ¾avu",
        dispensingHistory: "HistÃ³ria tÃ³novania",
        dispensingNotes: "PovoliÅ¥ poznÃ¡mky k tÃ³novaniu",
        enableCustomers: "NastaviÅ¥ zÃ¡kaznÃ­kov",
        enableDeleteConfirmation: "NastaviÅ¥ potvrdenie pri mazanÃ­",
        enableDispensing: "NastaviÅ¥ tÃ³novanie",
        enableLight: "NastaviÅ¥ %{name}",
        enableMarginMarkup: "NastaviÅ¥ marÅ¾u alebo obchodnÃº prirÃ¡Å¾ku",
        enableNotes: "NastaviÅ¥ poznÃ¡mky",
        enableOrdering: "NastaviÅ¥ objednÃ¡vky",
        enableProductPreviewImage: "NastaviÅ¥ nÃ¡hÄ¾ad obrÃ¡zku produktu",
        enableSpectro: "NastaviÅ¥ spektrometer",
        enableVirtualKeyboard: "PovoliÅ¥ virtuÃ¡lnu klÃ¡vesnicu",
        environmentsSettings: "Nastavenie prostredia",
        exportTranslationKeys: "Export prekladovÃ½ch kÄ¾ÃºÄov",
        formulaNotes: "PovoliÅ¥ poznÃ¡mky k receptÃºre",
        hintTooltips: "NÃ¡poveda",
        image: "ObrÃ¡zok",
        keyboardShortcuts: "KlÃ¡vesovÃ© skratky",
        languageBased: "ZaloÅ¾enÃ© na jazyku",
        lockYourComputer: "UzamknÃºÅ¥ poÄÃ­taÄ",
        machineReset: "Reset stroja",
        manageTranslations: "SpravovaÅ¥ preklady",
        margin: "Iba marÅ¾a",
        markup: "Iba obchodnÃ¡ prirÃ¡Å¾ka",
        matchingRowCount: "Set number of results found",
        maxNumberTabs: "MaximÃ¡lny poÄet zÃ¡loÅ¾iek s receptÃºrou",
        memoryTabs: "Store recently opened tabs",
        moreInfo: "OdtieÅ + obrÃ¡zok + viac info",
        navigationItems: "Nastavenie navigaÄnÃ½ch poloÅ¾iek",
        newTab: "NovÃ¡ zÃ¡loÅ¾ka",
        numberOfPriceGroups: "PoÄet cenovÃ½ch skupÃ­n",
        order: "ObjednÃ¡vka",
        orderId: "ID objednÃ¡vky",
        ordersHistory: "HistÃ³ria objednÃ¡vok",
        overwriteLastTab: "PrepÃ­saÅ¥ poslednÃº kartu receptÃºry",
        priceCalculation: "CenovÃ¡ kalkulÃ¡cia",
        priceDefBothPurchasePrimary: "PouÅ¾iÅ¥ obe ceny, uprednostniÅ¥ nÃ¡kupnÃ©",
        priceDefBothSellPrimary: "PouÅ¾iÅ¥ obe ceny, uprednostniÅ¥ predajnÃ©",
        priceDefPurchaseOnly: "Iba nÃ¡kupnÃ© ceny",
        priceDefSellOnly: "Iba predajnÃ© ceny",
        priceDefinition: "DefinÃ­cia ceny",
        priceGroupsEnabled: "PovoliÅ¥ cenovÃ© skupiny",
        runLightAtStartUp: "SpustiÅ¥ %{light} pri Å¡tarte",
        screenSaverTimeout: "ÄasovÃ½ limit Å¡etriÄa obrazovky",
        selectedSpectro: "Selected %{spectro} spectro.",
        selectedSpectroNone: "No spectro selected.",
        setAutomaticClientStart: "SpustiÅ¥ %{name} po Å¡tarte poÄÃ­taÄa",
        setCustomHomeButton: "NastaviÅ¥ vlastnÃ© tlaÄÃ­tko v navigaÄnÃ½ch poloÅ¾kÃ¡ch",
        setDecimalPlaces: "NastaviÅ¥ poÄet desatinnÃ½ch miest",
        setFormulaPreview: "NastaviÅ¥ nÃ¡hÄ¾ad receptÃºry",
        setFormulaUnit: "NastaviÅ¥ mernÃº jednotku receptÃºry",
        setFts: "PouÅ¾iÅ¥ vyhÄ¾adÃ¡vanie celÃ©ho textu",
        setInfoItemInRgb: "NastaviÅ¥ informÃ¡ciu viditeÄ¾nÃº v nÃ¡hÄ¾ade farby",
        setKeyboardShortcuts: "NastaviÅ¥ klÃ¡vesovÃ© skratky",
        setKioskMode: "NastaviÅ¥ reÅ¾im kiosku",
        setKioskModeOff: "VypnÃºÅ¥ reÅ¾im kiosku",
        setKioskModeOn: "ZapnÃºÅ¥ reÅ¾im kiosku",
        setNavigationItems: "NastaviÅ¥ navigaÄnÃ© poloÅ¾ky",
        setNavigationItemsList: "NastaviÅ¥ viditeÄ¾nosÅ¥ a poradie navigaÄnÃ½ch poloÅ¾iek",
        setOrderSearchItems: "NastaviÅ¥ parametre pre vyhÄ¾adÃ¡vanie objednÃ¡vok",
        setRounding: "NastaviÅ¥ zaokrÃºhÄ¾ovanie",
        setSearchParameters: "NastaviÅ¥ parametre pre vyhÄ¾adÃ¡vanie receptÃºr",
        setTabLimit: "NastaviÅ¥ limit zÃ¡loÅ¾ek",
        setYourLanguage: "NastaviÅ¥ jazyk",
        setZoom: "NastaviÅ¥ priblÃ­Å¾enie",
        showLocalPrices: "ZobraziÅ¥ navrhovanÃ© ceny",
        skipPlaceCanDialogEnabled:
            "Toto nastavenie nemÃ´Å¾e byÅ¥ zmenenÃ©, pretoÅ¾e dialÃ³g pre umiestnenie plechovky bol deaktivovanÃ½ v Nastaveniach stroja.",
        sortItems: "ZoradiÅ¥ navigaÄnÃ© poloÅ¾ky",
        startDispensing: "ZaÄaÅ¥ tÃ³novaÅ¥",
        stir: "PremieÅ¡anie"
    },
    error: {
        errorDetail: "Detail chyby",
        errorOccurred:
            "Objavila sa neoÄakÃ¡vanÃ¡ chyba. Kontaktujte, prosÃ­m, naÅ¡u podporu na %{0}, ozveme se VÃ¡m hneÄ ako to bude moÅ¾nÃ©.",
        hideDetail: "SkryÅ¥ detail"
    },
    favoritesTab: {
        addFolder: "PridaÅ¥ zloÅ¾ku",
        closeTabToLoadFormula:
            "Zatvorte, prosÃ­m, jednu z receptÃºr, aby ste mohli otvoriÅ¥ novÃº zÃ¡loÅ¾ku. Dosiahli ste maximÃ¡lny poÄet zÃ¡loÅ¾iek.",
        deleteFolder: "ZmazaÅ¥ zloÅ¾ku",
        editFolder: "UpraviÅ¥ zloÅ¾ku",
        favoriteFormulas: "ObÄ¾ÃºbenÃ© receptÃºry",
        formulaNotes: "PoznÃ¡mky k receptÃºre",
        message: {
            formulasFromFolder: "ReceptÃºry zo zloÅ¾ky",
            moveAllFormulas: "PresunÃºÅ¥ vÅ¡etky receptÃºry z tejto zloÅ¾ky do nadradenej zloÅ¾ky",
            removeAllFormulas: "OdstrÃ¡niÅ¥ vÅ¡etky receptÃºry z tejto zloÅ¾ky",
            wantToDeleteFolder: "SkutoÄne chcete zmazaÅ¥ tÃºto zloÅ¾ku?"
        },
        newFolder: "NovÃ¡ zloÅ¾ka",
        packages: "Balenie",
        pricePerPackage: "Cena za balenie",
        regularPrice: "BeÅ¾nÃ¡ cena",
        removeFromFavorites: "OdstrÃ¡niÅ¥ z obÄ¾ÃºbenÃ½ch",
        specialPriceOff: "Å peciÃ¡lna cena %{number}% z",
        specialPriceVIP: "Å peciÃ¡lna cena VIP"
    },
    fileTransfer: {
        afterImport: "Po importe",
        alreadyExists: "Ãloha pre danÃ½ typ a formÃ¡t uÅ¾ existuje",
        customFormulaSimple: "Custom formula simple",
        direction: "Smer",
        exportTask: "Ãloha exportu sÃºboru",
        fileTransferNotification: "Upozornenie prenosu sÃºborov",
        flashMessage: "Vyskakovacia hlÃ¡Å¡ka",
        importTask: "Ãloha importu sÃºboru",
        noInformation: "Å½iadne informÃ¡cie",
        protocol: {
            folder: "PrieÄinok",
            ftp: "Protokol FTP",
            ftps: "Protokol FTPS",
            redlikeStorage: "%{softwareName} FTP ÃºloÅ¾nÃ½ protokol",
            sftp: "SFTP protocol"
        },
        protocolDescription: {
            folder: "Protokol kontroluje sÃºbory v definovanom priÄinku.",
            ftp: "Protokol kontroluje sÃºbory vo vzdialenom prieÄinku FTP za pouÅ¾itia beÅ¾nÃ©ho spojenia FTP.",
            ftps: "Protokol kontroluje sÃºbory vo vzdialenom prieÄinku servera FTPS (FTP-SSL/FTP Secure) za pouÅ¾itia spojenia FTP.",
            redlikeStorage: "Protokol kontroluje sÃºbory v ÃºloÅ¾isku %{softwareName}."
        },
        remoteFolder: "VzdialenÃ½ prieÄinok",
        startType: "SpÃ´sob spustenia",
        statusbar: "InformÃ¡cia o stavovom riadku",
        testConnection: "Test pripojenia",
        xMoreLeft: "(%{amount} more left)",
        xmlImporting: "XML file is being imported"
    },
    filtering: {
        consumptionType: "Typ spotreby",
        filter: "Filter",
        from: "Od",
        to: "Do"
    },
    findText: {
        findTextTitle: "NÃ¡jsÅ¥ text",
        removeMarks: "OdstrÃ¡niÅ¥ znaÄky",
        search: "HÄ¾adaÅ¥ slovo"
    },
    flashMessage: {
        VMNotAllowed: "VirtuÃ¡lny stroj nie je povolenÃ½",
        addedToStock: "Successfully added items to stock",
        allRecordsDeleted: "All imported records were successfully deleted",
        autologinFailed: "AutomatickÃ© prihlasovanie do databÃ¡ze bolo neÃºspeÅ¡nÃ©.",
        autotaskDuplicateName:
            "Chyba integrity databÃ¡zy: %{0} poloÅ¾ka s %{1} %{2} uÅ¾ existuje, prosÃ­m, pouÅ¾ite inÃ½ %{3}",
        barcodeIsUsed: "ÄiarovÃ½ kÃ³d sa uÅ¾ pouÅ¾Ã­va.",
        barcodeNotFound: "ÄiarovÃ½ kÃ³d nebol nÃ¡jdenÃ½",
        bugReportSent: "VaÅ¡e hlÃ¡senie o chybe bolo odoslanÃ©.",
        cannoctConnectToServer: "Nie je moÅ¾nÃ© pripojiÅ¥ sa k serveru",
        cannotWriteLicense: "Nie je moÅ¾nÃ© zapÃ­saÅ¥ licenciu",
        clientConnectionRejected: "Spojenie odmietnutÃ©",
        clientNotLoggedIn: "Klient nie je prihlÃ¡senÃ½",
        colorFromInactiveDatabase: "Color is from inactive database %{0}.",
        colorantPackageRemovedStock: "Colorant package successfully removed from stock.",
        competitiveSearchEmpty:
            "NenaÅ¡li sa Å¾iadne konkurenÄnÃ© odtiene. ZmeÅte parametre vyhÄ¾adÃ¡vania alebo vyberte inÃ½ odtieÅ.",
        competitiveSearchSelectProduct: "Please select product to start competitive color search.",
        computerBackdated: "Äas na poÄÃ­taÄi bol posunutÃ½ dozadu",
        connectionFailed: "Test pripojenia zlyhal: %{0}",
        connectionSuccess: "Test pripojenia prebehol ÃºspeÅ¡ne",
        corruptedLicenseFile: "LicenÄnÃ½ sÃºbor je poÅ¡kodenÃ½",
        customFormulaCreated: "Custom formula successfully created.",
        customFormulaCreationError: "Error while creating custom formula.",
        customFormulaFromXmlCreationError:
            "Error while creating custom formula with colorants '%{colorants}' for combination of product '%{product}', fandeck '%{fandeck}', color '%{color}' and base '%{base}'.",
        customerNotFound: "ZÃ¡kaznÃ­k nebol nÃ¡jdenÃ½",
        dataNotAvailable: "Server sa nemÃ´Å¾e pripojiÅ¥ k databÃ¡ze",
        datacolorMatching: {
            couldNotConnect: "Could not connect to Datacolor Matching, either server down or PC is offline.",
            disabled: "Datacolor Matching disabled.",
            internalError: "Datacolor Matching internal error: '%{0}'",
            invalidCredentials: "No or invalid credentials for Datacolor Matching provided, contact database provider.",
            noCansAvailable: "No cans available for selected color file (product line), contact database provider."
        },
        defaultMessage: "PoÄas poslednej akcie nastala neoÄakÃ¡vanÃ¡ chyba",
        deleteAll: "VymazaÅ¥ vÅ¡etko",
        deletingImportedData: "Deleting imported records.",
        disableWinterPlugin:
            "ZimnÃ½ plugin mÃ´Å¾ete zakÃ¡zaÅ¥ pomocou rozbalovacej ponuky na pravej strane navigÃ¡cie spustenÃ½ch zÃ¡loÅ¾iek",
        duplicateBarcode: "DuplicitnÃ½ ÄiarovÃ½ kÃ³d uÅ¾ existuje.",
        duplicateName: "Toto meno uÅ¾ existuje",
        emptyFandeck: "Selected fandeck is empty.",
        emptyStock: "There are no records in stock for the item you have used.",
        expiredLicense: "Licencia vyprÅ¡ala",
        exportSuccess: "DÃ¡ta boli ÃºspeÅ¡ne exportovanÃ©",
        fandeckExist: "TakÃ½to nÃ¡zov vzorkovnice uÅ¾ existuje.",
        featureNotAutorized: "Funkcia nie je oprÃ¡vnenÃ¡",
        fileExportComplete: "SÃºbor bol ÃºspeÅ¡ne exportovanÃ½.",
        fileExportError: "An error occurred during file export.",
        fileSaveComplete: "File was successfully saved.",
        fileSaveError: "An error occurred during file saving.",
        fileTransferCustomFormulaRecordsAdded: "New custom formula records were added from the received file.",
        fileTransferCustomFormulaRecordsNotFullyProcessed:
            "Could not fully process custom formula data in file: '%{0}', see error log files for more info.",
        fileTransferCustomFormulaRecordsProcessed:
            "The new custom formula records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferCustomerRecordsAdded: "New customer records were added from the received file.",
        fileTransferCustomerRecordsNotFullyProcessed:
            "Could not fully process customer data in file: '%{0}', see error log files for more info.",
        fileTransferCustomerRecordsProcessed:
            "The new customer records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferFileNotProvided: "File not provided or is empty.",
        fileTransferHistoryRecordsAdded: "New dispensing history records were added from the received file.",
        fileTransferHistoryRecordsNotFullyProcessed:
            "Could not fully process dispensing history data in file: '%{0}', see error log files for more info.",
        fileTransferHistoryRecordsProcessed:
            "The new history records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferInvalidFile: "Could not process data in file, file is not valid.",
        fileTransferOrderRecordsAdded: "New order records were added from the received file.",
        fileTransferOrderRecordsNotFullyProcessed:
            "Could not fully process order data in file: '%{0}', see error log files for more info.",
        fileTransferOrderRecordsProcessed:
            "The new order records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferUnknownVersion: "Could not detect version of file.",
        filetransferNoData: "No database connection, check settings",
        formulaDataUnavailable: "Ãdaje o receptÃºre nie sÃº k dispozÃ­cii",
        helperDefaultMessage: "PoÄas poslednejakcie na Helper serveri sa objavila neoÄakÃ¡vana chyba.",
        helperServerError: "Chyba na Helper serveri",
        importAborted: "Import bol preruÅ¡enÃ½",
        importSuccess: "DÃ¡ta boli ÃºspeÅ¡ne importovanÃ©",
        incompatibleBaseCan: "Plechovka bÃ¡zy nie je zhodnÃ¡ so zvolenÃ½m produktom, bÃ¡zou a balenÃ­m",
        incorrectPassword: "VaÅ¡e starÃ© heslo je nesprÃ¡vne. ProsÃ­m, zadajte sprÃ¡vne!",
        invalidCurrency: "KÃ³d meny nie je platnÃ½. Euro je zvolenÃ© ako predvolenÃ¡ mena.",
        invalidDatabaseName: "NÃ¡zov databÃ¡zy nie je platnÃ½",
        invalidEmail: "VÃ¡Å¡ e-mail nie je platnÃ½",
        invalidFormulaColorants:
            "There is the software issue in the formula. Formula could be wrong! Contact your support!",
        invalidLicenseCompanyUserKey: "NeplatnÃ½ kÄ¾ÃºÄ firmy alebo pouÅ¾Ã­vateÄ¾a (company-user key).",
        invalidLicenseFile: "NeplatnÃ½ licenÄnÃ½ sÃºbor",
        invalidLicenseIdentificationKeys: "VaÅ¡e licenÄnÃ© kÄ¾ÃºÄe nie sÃº platnÃ©",
        invalidLicenseKey: "VÃ¡Å¡ licenÄnÃ½ kÄ¾ÃºÄ nie je platnÃ½",
        invalidLicenseProduct: "LicenÄnÃ½ sÃºbor sa nezhoduje s produktom",
        invalidRccResponse: "PoÄas spracovania poslednej odpovede RCC sa vyskytla neoÄakÃ¡vanÃ¡ chyba",
        invalidServerResponse: "Nastala neoÄakÃ¡vanÃ¡ chyba poÄas spracovania poslednej odpovede zo serveru",
        invalidUrl: "URL nie je platnÃ©",
        itemNotFound: "PoloÅ¾ka nebola nÃ¡jdenÃ¡",
        keyboardShortcutUsedInModal:
            "TÃ¡to klÃ¡vesovÃ¡ skratka nemÃ´Å¾e byÅ¥ pouÅ¾itÃ¡ v modÃ¡lnom okne. ProsÃ­m, zatvorte modÃ¡lne okno.",
        keyboardShortcutValidation: "Nie je moÅ¾nÃ© maÅ¥ rovnakÃº klÃ¡vesovÃº skratku na dve rozliÄnÃ© akcie",
        licenseHasBeenRevoked:
            "VaÅ¡a licencia bola odobratÃ¡. Aby ste ju obnovili, prosÃ­m, kontaktujte VÃ¡Å¡ho dodÃ¡vateÄ¾a softvÃ©ru.",
        licenseProlongationNeeded:
            "Je potrebnÃ© predÄºÅ¾enie licencie. Pripojte poÄÃ­taÄ na internet, aby ste obdrÅ¾ali novÃº licenciu.",
        licenseUpToDate: "Your license is up to date. No update necessary.",
        licenseUpdateUnsuccessful: "Could not update license.",
        licenseUpdated: "License has been successfully updated.",
        licensedOnDifferentComputer: "PÃ´vodne licencovanÃ© na inom poÄÃ­taÄi",
        logFileArchiveDownloadComplete: "SÅ¥ahovanie archÃ­vu logu bolo ÃºspeÅ¡ne dokonÄenÃ©",
        loginError: "PoÄas prihlasovania nastala neoÄakÃ¡vanÃ¡ chyba",
        logoutError: "PoÄas odhlasovania nastala neoÄakÃ¡vanÃ¡ chyba",
        machineIsConnecting: "Stroj sa pripÃ¡ja, poÄkajte prosÃ­m",
        machineIsNotConnected: "VÃ¡Å¡ stroj nie je pripojenÃ½ k RCC. ProsÃ­m, skontrolujte konfigurÃ¡ciu RCC.",
        malformedFormula: "Formula is malformed.",
        matching: {
            correctionNotPossible: "Correction cannot be done, use reformulation.",
            forbidden: "Request '%{0}' failed: forbidden.",
            internalServerError: "Internal server error.",
            invalidBase: "Invalid base in product.",
            invalidBipp: "Invalid base in product package.",
            invalidColorantId: "Invalid colorant with ID: %{0}.",
            invalidColorantName: "Invalid colorant with name: %{0}.",
            invalidColorfile: "Invalid color file with ID: %{0} for product with ID: %{1}.",
            invalidIlluminant: "Invalid illuminant: %{0}",
            invalidProduct: "Invalid product with ID: %{0}.",
            invalidSpectralCurve: "Invalid spectral curve.",
            noColorfiles: "No color files defined for product with ID: %{0}.",
            notAuthorized: "Request '%{0}' failed: unauthorized.",
            notFound: "Request '%{0}' failed: not found.",
            reformulationNotPossible: "Reformulation cannot be done.",
            unknownError: "Unknown error.",
            validationError: "Request '%{0}' failed due to validation errors: %{0}."
        },
        maxFileSizeExceeded: "Maximum file size of %{0} MB exceeded",
        maxTabs: "Bol dosiahnutÃ½ maximÃ¡lny poÄet zÃ¡loÅ¾iek, zatvorte jednu, prosÃ­m.",
        noTemplate: "TlaÄ nie je moÅ¾nÃ¡, pretoÅ¾e nie je k dispozÃ­cii Å¾iadna tlaÄovÃ¡ Å¡ablÃ³na.",
        openNewTab: "ProsÃ­m, ak chcete naÄÃ­taÅ¥ receptÃºru pomocu ÄiarovÃ©ho kÃ³du, otvorte novÃ½ panel receptÃºr.",
        orderAlreadyAcquired: "ObjednÃ¡vka uÅ¾ bola prebratÃ¡, najskÃ´r sa musÃ­ uvoÄ¾niÅ¥",
        orderCreated: "ObjednÃ¡vka bola ÃºspeÅ¡ne odoslanÃ¡",
        passwordIsNotUnique: "NovÃ© heslo sa musÃ­ lÃ­Å¡iÅ¥ od starÃ©ho hesla.",
        printCannotBeCarriedOut: "TlaÄ nie je moÅ¾nÃ¡, pretoÅ¾e nÃ¡zov tlaÄiarne je neplatnÃ½.",
        problemWithFileExport: "NaneÅ¡Å¥astie, pri ukladanÃ­ sÃºboru na disk sa objavil problÃ©m.",
        productFileWarning: "ProduktovÃ½ sÃºbor je dostupnÃ½ iba online.",
        productNotLicensed: "Produkt nie je licencovanÃ½",
        rccDefaultMessage: "PoÄas poslednej akcie RCC nastala neoÄakÃ¡vanÃ¡ chyba",
        rccError: "Chyba RCC",
        rccNeedRestart: "ProsÃ­m, reÅ¡tartujte RCC",
        restoredSettings: "Nastavenia boli obnovenÃ©.",
        revokedLicense: "Licencia bola odobratÃ¡",
        runningOutOfSpace: "The computer is running out of free space.",
        savedFormulaToHistory: "ReceptÃºra bola ÃºspeÅ¡ne uloÅ¾enÃ¡ do histÃ³rie.",
        savedLogArchive: "ArchÃ­v logu bol ÃºspeÅ¡ne uloÅ¾enÃ½ do VaÅ¡eho adresÃ¡ra.",
        scanning: "Prebieha skenovanie",
        serverError: "Chyba serveru",
        setClientIdentifier: "ProsÃ­m, nastavte identifikÃ¡tor klienta",
        showLess: "UkÃ¡zaÅ¥ menej",
        showMore: "UkÃ¡zaÅ¥ viac",
        spectroIsDisconnecting: "Spektrometer sa odpÃ¡ja, poÄkajte prosÃ­m",
        spectroIsNotConnected: "VÃ¡Å¡ spektrometer momentÃ¡lne nie je pripojenÃ½. ProsÃ­m, skontrolujte konfigurÃ¡ciu RCC.",
        spectroIsNotSelected: "VÃ¡Å¡ spektrometer momentÃ¡lne nie je vybranÃ½. ProsÃ­m, skontrolujte konfigurÃ¡ciu RCC.",
        tmcNotAvailable: "%{tmc} is not available. Please check your %{collector}.",
        tmcNotConnected: "%{tmc} is not connected. Please start your %{collector} and restart server.",
        unknownError: "NeznÃ¡ma chyba: %{0}",
        userAlreadyLoggedIn: "UÅ¾ ste prihlÃ¡senÃ½!",
        versionNotAllowedByLicense: "Software version is too new and is not allowed for your license.",
        webApiConnectionError: "Web Api server - nie je moÅ¾nÃ© pripojiÅ¥ sa",
        webApiInternalError: "Web Api server - internÃ¡ chyba",
        webApiInvalidUser: "Web Api server neplatnÃ½ pouÅ¾Ã­vateÄ¾",
        webApiNoLicenseAvailable: "Web Api server - Å¾iadna voÄ¾nÃ¡ licencia",
        wrongDataSaved: "Wrong data was saved to XML file in the %{0} folder.",
        wrongHelpInput: "NesprÃ¡vny formÃ¡t %{0} vstupu.",
        wrongRccVersion: "ProsÃ­m, skontrolujte verziu VÃ¡Å¡ho RCC. Klient je kompatibilnÃ½ iba s RCC %{0}."
    },
    footer: {
        aboutApplication: "O aplikÃ¡cii",
        activeUser: "AktÃ­vny pouÅ¾Ã­vateÄ¾",
        logOut: "OdhlÃ¡siÅ¥ sa",
        machineErrors: "Chyby na stroji"
    },
    formulaProperties: {
        exterior: "Exterior",
        interior: "Interior",
        invalid: "Invalid",
        solvent: "Solvent based",
        universal: "Universal",
        water: "Water based"
    },
    formulaSettings: {
        allUnits: "VÅ¡etky jednotky dostupnÃ© v databÃ¡ze",
        allowCustomFormulas: "PovoliÅ¥ vlastnÃ© receptÃºry",
        allowCustomPackageSize: "PovoliÅ¥ vlastnÃº veÄ¾kosÅ¥ balenia",
        allowFormulaAutomaticNaming: "PovoliÅ¥ automatickÃ© pomenovÃ¡vanie",
        automaticNaming: "AutomatickÃ© pomenovÃ¡vanie receptÃºr",
        basePanelSize: "NastaviÅ¥ veÄ¾kosÅ¥ panelu bÃ¡ze",
        bippPanelSize: "NastaviÅ¥ veÄ¾kosÅ¥ panelu bÃ¡ze v produktovom balenÃ­",
        blendColorNameAndCode: "SpojiÅ¥ nÃ¡zov a kÃ³d farby",
        buttonBellowMoreInfo: "Show button below formula notes",
        buttonInColorantPanel: "Show button in Colorants panel",
        colorCodePrimary: "KÃ³d farby ako hlavnÃ½",
        colorPanel: "Paleta farieb",
        colorPreviewAsImage: "NÃ¡hÄ¾ad farby ako obrÃ¡zok",
        colorPreviewResizable: "PrispÃ´sobiteÄ¾nÃ¡ veÄ¾kosÅ¥ nÃ¡hÄ¾adu farby",
        competitiveColorSearch: "HÄ¾adanie konkurenÄnÃ½ch odtieÅov",
        customFormula: "Custom formula",
        customFormulaForMasterProduct: "Allow create custom formulas for master product",
        customFormulaForMasterProductDefault: "Checked by default",
        customFormulas: "VlastnÃ© receptÃºry",
        customPackageSettingsUnitGrav: "Nastavenie vlastnÃ©ho balenia gravimetrickÃ½ch jednotiek",
        customPackageSettingsUnitVol: "Nastavenie vlastnÃ©ho balenia volumetrickÃ½ch jednotiek",
        customPackageSize: "VlastnÃ¡ veÄ¾kosÅ¥ balenia",
        customUnits: "Vyberte vlastnÃ© jednotky",
        dropDownCalculate: "Expand the drop down menu to the height of the window",
        editColorants: "Ãprava kolorantov",
        editColorantsAllowed: "PovoliÅ¥ Ãºpravy",
        fandeckPanelSize: "NastaviÅ¥ veÄ¾kosÅ¥ panelu vzorkovnice",
        favoriteFormulas: "ObÄ¾ÃºbenÃ© receptÃºry",
        formulaColorPreview: "NÃ¡hÄ¾ad farby receptÃºry",
        formulaDataSettings: "Nastavenia Ãºdajov o receptÃºre",
        formulaPanel: "Panel receptÃºry",
        formulaPanelSize: "NastaviÅ¥ veÄ¾kosÅ¥ panelu receptÃºry",
        formulaSettings: "Nastavenie receptÃºry",
        generateColorPreview: "GenerovaÅ¥ nÃ¡hÄ¾ad farby",
        gravimetricOnly: "Iba gravimetrickÃ© jednotky",
        hideAlternativeFormulas: "Hide alternative formulas",
        hideFormulaProperties: "Hide formula properties",
        hideHistoricalFormulas: "Hide historical formulas",
        imagesLocal: "PouÅ¾iÅ¥ iba obrÃ¡zok z lokÃ¡lnej databÃ¡ze",
        imagesOnline: "PrimÃ¡rne sa pokÃºsiÅ¥ otvoriÅ¥ obrÃ¡zok online, ak sa nedÃ¡, otvoriÅ¥ lokÃ¡lny obrÃ¡zok",
        infoPanelResizable: "PrispÃ´sobiteÄ¾nÃ¡ veÄ¾kosÅ¥ panelu pre viac info",
        numberOfColorants: "Number of shown colorants",
        orderByDistance: "Order of search results by the distance",
        productDependent: "Jednotka zÃ¡visÃ­ od zvolenÃ©ho produktu",
        productFilesDialog: "UkÃ¡zaÅ¥ okno na otvorenie lokÃ¡lneho sÃºboru alebo online sÃºboru",
        productFilesLocal: "PouÅ¾iÅ¥ iba produktovÃ© sÃºbory z lokÃ¡lnej databÃ¡ze",
        productFilesOnline: "PrimÃ¡rne sa pokÃºsiÅ¥ otvoriÅ¥ produktovÃ½ sÃºbor online, ak sa nedÃ¡, otvoriÅ¥ lokÃ¡lny sÃºbor",
        productPanelSize: "NastaviÅ¥ veÄ¾kosÅ¥ panelu produktu",
        searchPanelQuickSelect: "RÃ½chla voÄ¾ba",
        setAdditionalFormulaPanel: "Nastavenie dodatoÄnÃ©ho panelu receptÃºry",
        setCompetitiveColorSearch: "PovoliÅ¥ hÄ¾adanie konkurenÄnÃ½ch odtieÅov",
        setInitialFormulaPanel: "Nastavenie poÄiatoÄnÃ©ho panelu",
        setMaxToleranceForCompetitiveColors: "NastaviÅ¥ maximÃ¡lnu toleranciu pre hÄ¾adanie konkurenÄnÃ½ch odtieÅov",
        setNumberOfCompetitiveColors: "NastaviÅ¥ poÄet konkurenÄnÃ½ch master odtieÅov",
        setSearchPanel: "NastaviÅ¥ panel vyhÄ¾adÃ¡vania",
        setVisibilityAndOrder: "Nastavenie viditeÄ¾nosti a poradia rÃ´znych Ãºdajov o receptÃºrach",
        setVisibleUnit: "Nastavenie zobrazenia jednotiek",
        showColorPreview: "UkÃ¡zaÅ¥ nÃ¡hÄ¾ad farby",
        showInFormulaStatusPanel: "Show in formula status panel",
        showInMoreInfoPanel: "Show in formula notes",
        sorting: "Zoradenie panelu kolorantov",
        useBase: "PouÅ¾iÅ¥ vÃ½ber bÃ¡ze",
        useBaseInProductPackage: "PouÅ¾iÅ¥ vÃ½ber balenia bÃ¡ze produktu",
        useColorCode: "PouÅ¾iÅ¥ kÃ³d barvy",
        useColorName: "PouÅ¾iÅ¥ nÃ¡zov barvy",
        useFandeckGroups: "Use fandeck groups",
        useProduct: "PouÅ¾iÅ¥ vÃ½ber produktu",
        useProductCode: "PouÅ¾iÅ¥ kÃ³d produktu",
        useProductGroups: "PouÅ¾iÅ¥ produktovÃ© skÃºpiny",
        volumetricOnly: "Iba objemovÃ© jednotky"
    },
    general: {
        accepted: "Accepted",
        active: "PoslednÃ¡ aktivita",
        actual: "AktuÃ¡lne",
        actualLevel: "AktuÃ¡lna hladina",
        add: "PridaÅ¥",
        addColorant: "PridaÅ¥ kolorant",
        addColorantForPackage: "PridaÅ¥ kolorant pre balenie",
        addFile: "PridaÅ¥ sÃºbor",
        all: "VÅ¡etko",
        amount: "MnoÅ¾stvo",
        applyNow: "Apply now",
        attachments: "PrÃ­lohy",
        automaticCorrection: "Automatic correction",
        automatically: "Automaticky",
        available: "DostupnÃ©",
        back: "SpÃ¤Å¥",
        base: "BÃ¡za",
        baseInProductPackage: "BÃ¡za v produkte a balenÃ­",
        batchNumber: "Batch number",
        bottom: "Spodok",
        buildingSite: "Building site",
        calculate: "Calculate",
        can: "Plechovka",
        canSize: "VeÄ¾kosÅ¥ plechovky",
        cancel: "ZruÅ¡iÅ¥",
        canister: "Kanister",
        canisterId: "ID kanistra",
        canisterIndex: "Index kanistra",
        canisters: "Kanistre",
        cap: "VieÄko zvlhÄovaÄa trysky",
        capacity: "Kapacita",
        channels: "Okruhy",
        choose: "VybraÅ¥",
        city: "Mesto",
        clean: "ÄistiÅ¥",
        clear: "VyÄistiÅ¥",
        client: "Klient",
        close: "ZatvoriÅ¥",
        closeAll: "ZatvoriÅ¥ vÅ¡etko",
        collapseAll: "ZbaliÅ¥ vÅ¡etko",
        color: "OdtieÅ",
        colorCode: "KÃ³d farby",
        colorFile: "Colorfile",
        colorName: "NÃ¡zov farby",
        colorPreview: "NÃ¡hÄ¾ad odtieÅa",
        colorant: "Kolorant",
        colorantBatchNumber: "Colorant Batch number",
        colorantPackage: "Balenie kolorantu",
        colorants: "Koloranty",
        colors: "Colors",
        company: "SpoloÄnosÅ¥",
        competitiveColor: "Competitive color",
        confirm: "PotvrdiÅ¥",
        confirmDeletion: "SkutoÄne chcete tÃºto poloÅ¾ku natrvalo vymazaÅ¥?",
        confirmHelpSettings: "SkutoÄne chcete uloÅ¾iÅ¥ formulÃ¡r a nechaÅ¥ prÃ¡zne polia?",
        connect: "PripojiÅ¥",
        continue: "PokraÄovaÅ¥",
        correction: "Correction",
        country: "Å tÃ¡t",
        created: "VytvorenÃ©",
        creationDateOf: "Creation date of",
        criticalLevel: "KritickÃ¡ hladina",
        currency: "Mena",
        currentBatchNumber: "Current batch number",
        currentUfiCode: "Current UFI code",
        custom: "VlastnÃ©",
        customData: "Custom data",
        customFandeck: "VlastnÃ¡ vzorkovnica",
        customFormula: "VlastnÃ¡ receptÃºra",
        customPackage: "VlastnÃ©",
        customPackageSettings: "Nastavenie vlastnÃ½ch balenÃ­",
        customer: "ZÃ¡kaznÃ­k",
        customerVersion: "Verzia zÃ¡kaznÃ­ka",
        customers: "ZÃ¡kaznÃ­ci",
        database: "DatabÃ¡za",
        date: "DÃ¡tum",
        default: "PÃ´vodnÃ©",
        delete: "VymazaÅ¥",
        deleteImportedData: "Delete imported records",
        delta: "Delta",
        description: "Popis",
        disconnect: "OdpojiÅ¥",
        discount: "ZÄ¾ava",
        discover: "ObjaviÅ¥",
        dispense: "TÃ³novaÅ¥",
        dispensing: "TÃ³novanie",
        doNotShowAgain: "TÃºto sprÃ¡vu znovu nezobrazovaÅ¥.",
        downloadingFile: "SÃºbory sa sÅ¥ahujÃº",
        edit: "UpraviÅ¥",
        email: "E-mail",
        enabled: "PovolenÃ©",
        error: "Chyba",
        expandAll: "RozbaliÅ¥ vÅ¡etko",
        exportData: "Export dÃ¡t",
        exportPdf: "ExportovaÅ¥ PDF",
        fan: "Vzorkovnica",
        fandeck: "Vzorkovnica",
        fandeckCode: "Fandeck code",
        fandeckName: "NÃ¡zov vzorkovnice",
        fandecks: "Vzorkovnice",
        favorite: "ObÄ¾ÃºbenÃ©",
        fileTransfer: "Prenos sÃºborov",
        filling: "Plnenie",
        fillingDate: "DÃ¡tum plnenia",
        find: "NÃ¡jsÅ¥",
        finish: "DokonÄiÅ¥",
        finishedCorrection: "Finished correction",
        formula: "ReceptÃºra",
        formulas: "Formulas",
        frontdesk: "Frontdesk",
        getQrCode: "ZÃ­skaÅ¥ QR kÃ³d",
        gravimetric: "GravimetrickÃ©",
        historical: "Historical",
        history: "HistÃ³ria",
        hours: "Hod",
        id: "ID",
        images: "ObrÃ¡zky",
        in: "Do",
        index: "Index",
        insertBarcode: "ProsÃ­m, vloÅ¾te ÄiarovÃ½ kÃ³d",
        install: "InÅ¡talovaÅ¥",
        installed: "NainÅ¡talovanÃ©",
        instructions: "InÅ¡trukcie",
        internalNote: "InternÃ¡ poznÃ¡mka",
        interval: "Interval",
        ip: "IP adresa",
        itemNumber: "PoloÅ¾ka Ä.",
        itemXOfY: "Item %{x}/%{y}",
        itemsCount: "Items count",
        later: "Later",
        limit: "Limit",
        load: "NaÄÃ­taÅ¥",
        loadFormula: "NaÄÃ­taÅ¥ receptÃºru",
        localVersion: "LokÃ¡lna verzia",
        machine: "Stroj",
        manualCorrection: "Manual correction",
        manually: "RuÄne",
        margin: "MarÅ¾a",
        markup: "ObchodnÃ¡ prirÃ¡Å¾ka",
        matching: "Matching",
        matchingFormula: "Matching formula",
        maxLevel: "MaximÃ¡lna hladina",
        maxValue: "MaximÃ¡lna hodnota",
        maximum: "Maximum",
        mayTakeAWhile: "This may take a while",
        measured: "Measured",
        metamarism: "Metamarism",
        minimum: "Minimum",
        minutes: "Min",
        missingItem: "ChÃ½bajÃºca poloÅ¾ka",
        missingRequiredItems: "VÅ¡etky povinnÃ© Ãºdaje oznaÄenÃ© hviezdiÄkou musia byÅ¥ vyplnenÃ©.",
        modified: "Modified",
        modifiedAutomaticCorrection: "Target color correction",
        modifiedCustomFormula: "Modified custom formula",
        modifiedStandardFormula: "Modified standard formula",
        moduleChange: "Module change",
        more: "Viac",
        moreInfo: "Viac informÃ¡ciÃ­",
        moveDown: "PosunÃºÅ¥ dole",
        moveUp: "PosunÃºÅ¥ hore",
        myOrders: "Moje objednÃ¡vky",
        name: "Meno",
        nameTitle: "NÃ¡zov",
        new: "NovÃ©",
        next: "Äalej",
        no: "Nie",
        noColorantsAvailable: "Å½iadne koloranty nie sÃº k dispozÃ­cii",
        noFormulas: "ZatiaÄ¾ Å¾iadne receptÃºry",
        noPricesAvailable: "Å½iadne ceny nie sÃº k dispozÃ­cii",
        nominalAmount: "NominÃ¡lne mnoÅ¾stvo",
        notAvailable: "NedostupnÃ©",
        note: "PoznÃ¡mka",
        numberOfCanisters: "PoÄet kanistrov",
        numberOfItemCount: "Number of '%{item}': %{count}",
        numberOfLabels: "PoÄet Å¡tÃ­tkov",
        numberOfPackages: "PoÄet balenÃ­",
        off: "VypnÃºÅ¥",
        ok: "OK",
        on: "ZapnÃºÅ¥",
        onFocus: "S kurzorom",
        open: "OtvoriÅ¥",
        operator: "Operator",
        options: "VoÄ¾by",
        order: "Order",
        other: "InÃ©",
        otherError: "InÃ¡ chyba",
        out: "Von",
        overwrite: "Overwrite",
        package: "Balenie",
        packagePreview: "NÃ¡hÄ¾ad balenia",
        partialUpdates: "Partial updates",
        phone: "TelefÃ³n",
        pleaseWait: "Please wait",
        previous: "Previous",
        price: "Cena",
        priceGroup: "CenovÃ¡ skupina",
        print: "TlaÄ",
        printTask: "DefinÃ­cia tlaÄe",
        processingStep: "Processing %{step}",
        product: "Produkt",
        productCode: "KÃ³d produktu",
        productName: "NÃ¡zov produktu",
        products: "Produkty",
        pump1: "Pumpa 1",
        pump2: "Pumpa 2",
        purchasePrice: "NÃ¡kupnÃ¡ cena",
        purge: "Odstrek",
        qualityControl: "Quality control",
        quantity: "MnoÅ¾stvo",
        quantityQty: "QTY",
        quickTint: "RÃ½chle tÃ³novanie",
        rccIsNotAvailable: "RCC je nedostupnÃ©",
        rccIsNotConnected: "RCC nie je pripojenÃ©",
        rccNotLicensed: "RCC nie je zalicencovanÃ©",
        reconnect: "Znovu pripojiÅ¥",
        refill: "Doplnenie",
        refillManualLevelCorrection: "Manual correction",
        reformulation: "Reformulation",
        reloadTab: "Reload Tab",
        reset: "ResetovaÅ¥",
        restart: "ReÅ¡tart",
        restore: "ObnoviÅ¥",
        retint: "Retint",
        revision: "RevÃ­zia",
        safetySheet: "BezpeÄnostnÃ½ list",
        save: "UloÅ¾iÅ¥",
        saveAs: "UloÅ¾iÅ¥ ako...",
        saveToDispensingHistory: "UloÅ¾iÅ¥ do histÃ³rie",
        searchResult: "Search result",
        searching: "Searching",
        seconds: "Sek",
        select: "Select",
        selectAll: "VybraÅ¥ vÅ¡etko",
        selectChannels: "ZvoliÅ¥ okruhy",
        selectColumns: "Select columns to work with",
        selectXFirst: "Select %{item} first",
        sellPrice: "PredajnÃ¡ cena",
        settings: "Nastavenia",
        shelf: "StÃ´l",
        showItem: "Show %{item}",
        showOptions: "Show another options",
        size: "VeÄ¾kosÅ¥",
        skip: "PreskoÄiÅ¥",
        smartPurge: "MÃºdry odstrek",
        softwareRestartInSeconds: "%{software} will be automatically restarted in %{seconds} seconds",
        sortResults: "Sort results",
        spectro: "Spektrometer",
        standardFormula: "Å tandardnÃ¡ receptÃºra",
        status: "Stav",
        street: "Ulica",
        sum: "Sum",
        summary: "Zhrnutie",
        sync: "ZjednotiÅ¥",
        technicalSheet: "TechnickÃ½ list",
        templates: "Å ablÃ³ny",
        threshold: "Threshold",
        ticketing: "Ticketing",
        tintometricSystem: "Tintometric system",
        toDispenseOrders: "Na tÃ³novanie",
        top: "Vrch",
        total: "Spolu",
        totalAmount: "CelkovÃ© mnoÅ¾stvo",
        totalBaseAmount: "CelkovÃ© mnoÅ¾stvo bÃ¡ze",
        totalColorantAmount: "CelkovÃ© mnoÅ¾stvo kolorantov",
        type: "Type",
        ufiCode: "UFI kÃ³d",
        ufiThreshold: "Limit pre UFI",
        unableToSynchronize: "Unable to synchronize",
        undefined: "Undefined",
        unit: "Unit",
        units: "Jednotky",
        unknown: "Unknown",
        update: "AktualizovaÅ¥",
        updated: "AktualizovanÃ©",
        user: "PouÅ¾Ã­vateÄ¾",
        value: "Hodnota",
        vat: "DPH",
        verified: "Verified",
        version: "Verzia",
        versionId: "ID verzie",
        versionStructure: "Å truktÃºra verzie",
        volumetric: "VolumetrickÃ©",
        warning: "Varovanie",
        warningLevel: "VarovnÃ¡ hladina",
        withoutName: "(bez nÃ¡zvu)",
        workingProperly: "Working properly",
        yes: "Ãno",
        zoom: "PriblÃ­Å¾iÅ¥"
    },
    help: {
        autotasks: {
            brushMaintenance:
                "Nastavte tento Ãºkon, nech si %{name} v definovanom Äase automaticky vypÃ½ta Äistenie nÃ¡doby Å¡tetcov. Obsluha stroja musÃ­ nÃ¡dobu ruÄne vyÅaÅ¥, vyÄistiÅ¥, a nÃ¡sledne vrÃ¡tiÅ¥ spÃ¤Å¥.",
            capMaintenance:
                "Nastavte tento Ãºkon, nech si %{name} v definovanom Äase automaticky vypÃ½ta Äistenie vieÄka.. Obsluha stroja musÃ­ vieÄko ruÄne umyÅ¥ po tom, ako sa otvorÃ­.",
            cleanAll:
                "Nastavte tento Ãºkon, aby tÃ³novacÃ­ stroj v definovanom Äase automaticky vykonal akciu Äistenia vÅ¡etkÃ½ch kanistrov.",
            cleanChannels:
                "Nastavte tento Ãºkon, aby tÃ³novacÃ­ stroj v definovanom Äase automaticky vykonal akciu Äistenia jednotlivÃ½ch kanistrov.",
            computerReboot: "Nastavte tento Ãºkon, aby sa poÄÃ­taÄ v definovanom Äase automaticky reÅ¡tartoval.",
            computerShutdown: "Nastavte tento Ãºkon, aby sa poÄÃ­taÄ v definovanom Äase automaticky vypol.",
            dispenserCleaning:
                "Nastavte tento Ãºkon, nech si %{name} v definovanom Äase automaticky vypÃ½ta Äistenie tÃ³novacieho stroja. Obsluha stroja musÃ­ stroj ruÄne vyÄistiÅ¥ handriÄkou.",
            humidifierWaterLevelMaintenance:
                "Nastavte tento Ãºkon, nech si %{name} v definovanom Äase automaticky vypÃ½ta doplnenie zvlhÄovaÄa. Obsluha stroja musÃ­ zvlhÄovaÄ ruÄne skontrolovaÅ¥ a doplniÅ¥ doÅ vodu.",
            purgeAll:
                "Nastavte tento Ãºkon, aby tÃ³novacÃ­ stroj v definovanom Äase automaticky vykonal akciu odstreku vÅ¡etkÃ½ch kanistrov.",
            purgeChannels:
                "Nastavte tento Ãºkon, aby tÃ³novacÃ­ stroj v definovanom Äase automaticky vykonal akciu odstreku jednotlivÃ½ch kanistrov.",
            recirculateAll:
                "Nastavte tento Ãºkon, aby tÃ³novacÃ­ stroj v definovanom Äase automaticky vykonal akciu recirkulÃ¡cie vÅ¡etkÃ½ch kanistrov.",
            recirculateChannels:
                "Nastavte tento Ãºkon, aby tÃ³novacÃ­ stroj v definovanom Äase automaticky vykonal akciu recirkulÃ¡cie jednotlivÃ½ch kanistrov.",
            refillAll:
                "Nastavte tento Ãºkon, nech si %{name} v definovanom Äase automaticky vypÃ½ta doplnenie vÅ¡etkÃ½ch kolorantov do kanistrov. Obsluha stroja musÃ­ ruÄne doplniÅ¥ koloranty do vÅ¡etkÃ½ch kanistrov.",
            refillCanisters:
                "Nastavte tento Ãºkon, nech si %{name} v definovanom Äase automaticky vypÃ½ta doplnenie jednotlivÃ½ch kolorantov do kanistrov. Obsluha stroja musÃ­ ruÄne doplniÅ¥ koloranty do tÃ½ch kanistrov, ktorÃ© nespÄºÅajÃº stanovenÃ© kritÃ©riÃ¡.",
            smartPurgeAll:
                "Nastavte tento Ãºkon, aby tÃ³novacÃ­ stroj v definovanom Äase automaticky vykonal akciu mÃºdreho odstreku vÅ¡etkÃ½ch kanistrov. Odstrek sa vykonÃ¡ iba vtedy, ak nie sÃº splnenÃ© PravidlÃ¡ mÃºdreho ostreku.",
            smartPurgeChannels:
                "Nastavte tento Ãºkon, aby tÃ³novacÃ­ stroj v definovanom Äase automaticky vykonal akciu mÃºdreho odstreku jednotlivÃ½ch kanistrov. Odstrek sa vykonÃ¡ iba vtedy, ak nie sÃº splnenÃ© PravidlÃ¡ mÃºdreho ostreku.",
            stirAll:
                "Nastavte tento Ãºkon, aby tÃ³novacÃ­ stroj v definovanom Äase automaticky vykonal akciu premieÅ¡avania vÅ¡etkÃ½ch kanistrov.",
            stirCanisters:
                "Nastavte tento Ãºkon, aby tÃ³novacÃ­ stroj v definovanom Äase automaticky vykonal akciu premieÅ¡avania jednotlivÃ½ch kanistrov.",
            switchPlateMaintenance:
                "Nastavte tento Ãºkon, nech si %{name} v definovanom Äase automaticky vypÃ½ta vyÄistenie dosky. Obsluha stroja musÃ­ dosku ruÄne vyÅaÅ¥, vyÄistiÅ¥, a nÃ¡sledne vrÃ¡tiÅ¥ spÃ¤Å¥."
        },
        colorantBatchNumber: {
            batchNumberByPercentage:
                "The Batch number which prevails is used for printing considering its actual amount in the canister. Navigate to Canister settings to define the threshold for each canister.",
            batchNumberFromLastFilling:
                "The Batch from the last refill given by the operator is used for printing regardless the refilled amount.",
            enableBatchNumber: "With this setting on, refilled colorant batches are tracked."
        },
        connection: {
            add: "UmoÅ¾nÃ­ ruÄne pridaÅ¥ novÃ½ server, ak ho nie je moÅ¾nÃ© nÃ¡jsÅ¥ cez funckiu vyhÄ¾adania serverov.",
            clientIdentifier:
                "Nastavenie umoÅ¾nÃ­ identifikovaÅ¥ tohto klienta, ak je k jednÃ©mu serveru pripojenÃ½ch viac klientov.",
            disconnect:
                "InformÃ¡cia o momentÃ¡lne pouÅ¾Ã­vanom servere. TlaÄÃ­dlo OdpojiÅ¥ opustÃ­ sÃºÄasnÃ½ server a umoÅ¾nÃ­ pripojenie na inÃ½ dostupnÃ½ server.",
            discover: "VyhÄ¾adÃ¡ ÄalÅ¡ie servery dostupnÃ© v sÃºÄasnej sieti.",
            dropServers: "VymaÅ¾e zo zoznamu vÅ¡etky predtÃ½m objavenÃ© servery.",
            dropServersNotAvailable: "Nie je k dispozÃ­cii Å¾iaden server",
            edit: "UmoÅ¾Åuje ruÄne upraviÅ¥ uÅ¾ nÃ¡jdenÃ½ server.",
            editDisabled: "Nie je zvolenÃ½ Å¾iaden server"
        },
        continue: "SkutoÄne chcete pokraÄovaÅ¥?",
        driverSettings: {
            alfaRestApi: {
                host: "Zadajte host name poÄÃ­taÄa alebo jeho IP adresu.",
                machineType: "PlatnÃ© pre vÅ¡etky stroje Alfa. Pre Windows aj Linux."
            },
            corobDsProxy: {
                machineType:
                    "PlatnÃ© pre generÃ¡cie Slave (D200, D600..), 4G (First One) a 5G (EvoFlx). DspProxy musÃ­ byÅ¥ nainÅ¡talovanÃ©. Iba pre Windows."
            },
            corobEvoDriver: {
                machineType:
                    "PlatnÃ© pre generÃ¡ciu 5G (EvoFlx). EVOservice musÃ­ byÅ¥ nainÅ¡talovanÃ©. Pre Windows aj Linux."
            },
            corobFlex500LLD: {
                dispenserConfigurationFile: "ZvoÄ¾te konfiguraÄnÃ½ sÃºbor stroja. BeÅ¾nÃ© nastavenie prednastavenÃ©.",
                hldRootDir: "ZvoÄ¾te hlavnÃº zloÅ¾ku HLD. BeÅ¾nÃ© nastavenie prednastavenÃ©.",
                machineType:
                    "PlatnÃ© pre Corob Flex (500, 520, 540) = bÃ½valÃ½ Lenteq. HLD musÃ­ byÅ¥ nainÅ¡talovanÃ©. Iba pre Windows."
            },
            corobNextDriver: {
                machineType:
                    "PlatnÃ© pre generÃ¡cie Slave (D200, D600..), 4G (First One) a 5G (EvoFlx). NextDriver musÃ­ byÅ¥ nainÅ¡talovanÃ½ a zalicencovanÃ½. Iba pre Linux."
            },
            dromontDDrv: {
                databasePath: "Cesta k databÃ¡zovÃ©mu sÃºboru s kalibraÄnÃ½mi Ãºdajmi. BeÅ¾nÃ© nastavenie prednastavenÃ©.",
                driverPath: "Cesta k ovlÃ¡daÄu (D_DRV.exe). BeÅ¾nÃ© nastavenie prednastavenÃ©.",
                machineType:
                    "Nepriama komunikÃ¡cia so strojom pomocou nastavenÃ½ch ciest. PlatnÃ© pre generÃ¡cie V1 a V2. D_SET musÃ­ byÅ¥ nainÅ¡talovanÃ½. Pre Windows aj Linux.",
                resultPath:
                    "Cesta k sÃºboru s vÃ½sledkom, ktorÃ½ sa vytvorÃ­ po ukonÄenÃ­ akcie. BeÅ¾nÃ© nastavenie prednastavenÃ©.",
                serviceSoftwarePath: "Cesta k servisnÃ©mu softvÃ©ru Dromontu (D_SET.exe). BeÅ¾nÃ© nastavenie prednastavenÃ©."
            },
            dromontDirect: {
                machineType:
                    "Priama komunikÃ¡cia so strojom. PlatnÃ© pre generÃ¡cie V1 a V2. D_SET musÃ­ byÅ¥ nainÅ¡talovanÃ½. Pre Windows aj Linux.",
                rootDir: "ZvoÄ¾te hlavnÃº zloÅ¾ku Dromontu. BeÅ¾nÃ© nastavenie prednastavenÃ©."
            },
            dromontMisura: {
                driverPath:
                    "Cesta k ovlÃ¡daÄu (MisuraRetail.exe) sa mÃ´Å¾e lÃ­Å¡iÅ¥ podÄ¾a verzie Misura Retail. BeÅ¾nÃ© nastavenie prednastavenÃ©.",
                extensionPath: "Cesta ku komunikaÄnÃ©mu sÃºboru pre servisnÃ© akcie.",
                formulaPath: "Cesta ku komunikaÄnÃ©mu sÃºboru pre tÃ³novanie.",
                machineType: "PlatnÃ© pre generÃ¡ciu V3. Dromont Misura musÃ­ byÅ¥ nainÅ¡talovanÃ©. Iba pre Windows."
            },
            fastAndFluidIDD: {
                machineType: "PlatnÃ© pre vÅ¡etky stroje F&F. Iba pre Windows.",
                path: "PodporovanÃ© sÃº IDD2 (HA 450, HA 650, X-smart, etc.) - musÃ­ byÅ¥ zalicencovanÃ©, IDD3 (HP 500, etc.), IDD4 (HA 180, HA 480, HA 680, Xprotint, etc.)"
            },
            fastAndFluidUIDD: {
                host: "Type in the computer host name or computer IP address.",
                machineType: "PlatnÃ© pre vÅ¡etky stroje F&F. Pre Windows aj Linux.",
                password: "Type in the user password.",
                port: "Select the port number.",
                user: "Type in the user name."
            },
            heroPCPDriver: {
                machineType: "PlatnÃ© pre vÅ¡etky stroje Hero. Iba pre Windows."
            },
            italtinto: {
                machineType:
                    "PlatnÃ© pre vÅ¡etky stroje Italtinto. Wcal alebo ItaltintoCal musÃ­ byÅ¥ nainÅ¡talovanÃ©. Iba pre Windows.",
                path: "Cesta k upravenÃ©mu konfiguraÄnÃ©mu sÃºboru."
            },
            manualAdvanced: {
                machineType: "PlatnÃ© pre vÅ¡etky ruÄnÃ© stroje, podporuje funkciu kanistrov. Pre Windows aj Linux.",
                path: "Cesta ku konfiguraÄnÃ©mu sÃºboru s Ãºdajmi o stroji a kanistroch."
            },
            manualSimple: {
                machineType: "PlatnÃ© pre vÅ¡etky ruÄnÃ© stroje. Pre Windows aj Linux.",
                path: "Cesta ku konfiguraÄnÃ©mu sÃºboru s Ãºdajmi o stroji."
            },
            none: {
                machineType: "Nie je zvolenÃ½ Å¾iaden ovlÃ¡daÄ stroja."
            },
            santintColorLink3: {
                machineType: "PlatnÃ© pre vÅ¡etky typy strojov Santint. Iba pre Windows."
            },
            simulation: {
                machineType: "PlatnÃ© pre simulÃ¡ciu stroja, ak k poÄÃ­taÄu nie je zapojenÃ½ Å¾iaden skutoÄnÃ½ stroj.",
                path: "Cesta k simulaÄnÃ©mu konfiguraÄnÃ©mu sÃºboru, ktorÃ½ sa musÃ­ zhodovaÅ¥ s vloÅ¾enou databÃ¡zou."
            },
            udcp: {
                machineType: "UDCP dispenser"
            }
        },
        environment: {
            activeServerPlugins: "PrehÄ¾ad dodatoÄnÃ½ch pluginov softvÃ©ru.",
            allowAutoCloseTab:
                "Po zapntuÃ­ nastavenia sa po dokonÄenÃ­ tÃ³novania kaÅ¾dÃ¡ karta receptÃºr automaticky uzavrie .",
            allowAutomaticClientStart: "Po spustenÃ­ tohto nastavenia sa %{name} spustÃ­ automaticky po Å¡tarte poÄÃ­taÄa.",
            allowAutomaticPrint:
                "Å tÃ­tok bude vytlaÄenÃ½ automaticky. VyÅ¾aduje sa ÄalÅ¡ie nastavenie o tlaÄi pred alebo po tÃ³novanÃ­, alebo v oboch prÃ­padoch.",
            allowBuildingSitePanel: "On Formula Panel, building site panel will be available.",
            allowCustomers: "V paneli receptÃºry bude prÃ­stupnÃ¡ sekcia so zÃ¡kaznikmi.",
            allowDispensing: "V paneli receptÃºry bude aktivovanÃ© tlaÄÃ­tko TÃ³novanie. ",
            allowFileTransfer:
                "Po spustenÃ­ tohto nastavenia je dostupnÃ½ automatickÃ½ import a export dÃ¡t pomocou prenosu sÃºborov.",
            allowFormulaModificationPanel: "On Formula Panel, Modification panel will be activated.",
            allowFormulaStatusPanel: "Na panely Formula sa aktivuje stavovÃ½ panel.",
            allowLight: "%{name} bude prÃ­stupnÃ©.",
            allowOrdering: "V paneli receptÃºry bude aktivovanÃ© tlaÄÃ­tko ObjednÃ¡vka.",
            allowPricing:
                "UmoÅ¾Åuje pouÅ¾iÅ¥ panel cien na Formula panele. ViditeÄ¾nosÅ¥ cien sa nastavuje v DostupnÃ½ch cenÃ¡ch. Ceny sa nastavujÃº v NastavenÃ­ cien.",
            allowProductPreviewImage: "ObrÃ¡zok produktu sa zobrazÃ­ poÄas tÃ³novania.",
            allowQualityControl: "Quality control will be activated.",
            allowSearchCheaperColors: "Na formula panele bude dostupnÃ¡ funkcia na hÄ¾adanie lacnejÅ¡ich odtieÅov.",
            allowSoundNotification: "Pri obdrÅ¾anÃ­ objednÃ¡vky sa prehrÃ¡ zvukovÃ© upozornenie na objednÃ¡vku.",
            allowSpectro: "Spektrometer bude prÃ­stupnÃ½.",
            allowTabs: "S tÃ½mto nastavenÃ­m je moÅ¾nÃ© pracovaÅ¥ s viacerÃ½mi kartami naraz.",
            applyZoom:
                "Zoom (priblÃ­Å¾enie) zvÃ¤ÄÅ¡uje alebo zmenÅ¡uje rozlÃ­Å¡enie. PouÅ¾iteÄ¾nÃ© sÃº aj klÃ¡vesovÃ© skratky CTRL + a CTRL -.",
            automaticLogout: "Nastavte po koÄ¾kÃ½ch minÃºtach sa mÃ¡ aktivovaÅ¥ automatickÃ© odhlÃ¡senie.",
            availableDatabases: "Nastavenie umoÅ¾Åuje prepÃ­nanie medzi databÃ¡zami, ak je dostupnÃ½ch viac ako jedna.",
            backupLocalDB: "Exports the local databse. The exported file can be used as database backup.",
            barcodeTesting:
                "Prostredie na testovanie ÄiarovÃ½ch kÃ³dov slÃºÅ¾i ku kontrole sprÃ¡vnosti naskenovanÃ½ch ÄiarovÃ½ch kÃ³dov tak, Å¾e ich porovnÃ¡ s ÄiarovÃ½mi kÃ³dmi v databÃ¡ze.",
            customBanner: "Nastavte si vlastnÃ© logo alebo banner a jeho pozÃ­ciu.",
            customCurrencyFormat:
                "VlastnÃ½ formÃ¡t meny mÃ´Å¾e prepÃ­saÅ¥ pÃ´vodnÃ© nastavenie formÃ¡tu meny na zÃ¡klade zvolenÃ©ho jazyka. ",
            customDateFormat:
                "VlastnÃ½ formÃ¡t dÃ¡tumu mÃ´Å¾e prepÃ­saÅ¥ pÃ´vodnÃ© nastavenie formÃ¡tu dÃ¡tumu podÄ¾a zvolenÃ©ho jazyka.",
            customNumberFormat:
                "VlastnÃ½ formÃ¡t ÄÃ­sel mÃ´Å¾e prepÃ­saÅ¥ pÃ´vodnÃ© nastavenie formÃ¡tu ÄÃ­sel podÄ¾a zvolenÃ©ho jazyka.",
            customTimeFormat:
                "VlastnÃ½ formÃ¡t Äasu mÃ´Å¾e prepÃ­saÅ¥ pÃ´vodnÃ© nastavenie formÃ¡tu Äasu podÄ¾a zvolenÃ©ho jazyka.",
            defaultPrinter:
                "ZvolenÃ¡ tlaÄiareÅ bude pouÅ¾itÃ¡ pri tlaÄenÃ­ Å¡tÃ­tkov. ZmeniÅ¥ ju mÃ´Å¾ete v okne VoÄ¾by tlaÄiarne.",
            defaultTemplate:
                "ZvolenÃ¡ Å¡ablÃ³na bude pouÅ¾itÃ¡ pri tlaÄenÃ­ Å¡tÃ­tkov. ZmeniÅ¥ ju mÃ´Å¾ete v okne VoÄ¾by tlaÄiarne.",
            deleteImportedData: "VymaÅ¾e vloÅ¾enÃ© vlastnÃ© dÃ¡ta. Po vymazanÃ­ sa dajÃº opÃ¤Å¥ vloÅ¾iÅ¥.",
            diskSpaceNotification: "Checks the available disk space and notifies in case of insufficient space.",
            dispensingNotes: "V paneli receptÃºry budÃº prÃ­stupnÃ© poznÃ¡mky k tÃ³novaniu.",
            downloadListEmpty: "No downloads in progress",
            enableVirtualKeyboard: "V %{name}, bude dostupnÃ¡ virtuÃ¡lna klÃ¡vesnica.",
            exportLocalSettings:
                "Exportuje lokÃ¡lne nastavenia tohto poÄÃ­taÄa. SÃºbor sa dÃ¡ nÃ¡sledne importovaÅ¥ na inÃ½ poÄÃ­taÄ, aby sa na Åom aplikovali rovnakÃ© nastavenia.",
            exportStaticSql:
                "Exportuje lokÃ¡lne nastavenia poÄÃ­taÄa. ExportovanÃ½ sÃºbor mÃ´Å¾e byÅ¥ pouÅ¾itÃ½ na vytvorenie databÃ¡zy s tÃ½mto nastavenÃ­m.",
            exportTranslationKeys:
                "Exportujte najnovÅ¡ie preklady a po preloÅ¾enÃ­ ich emailom poÅ¡lite VÃ¡Å¡mu dodÃ¡vateÄ¾ovi softvÃ©ru, aby ich naimportoval.",
            favoriteButton: "KliknutÃ­m pridÃ¡te receptÃºru do obÄ¾ÃºbenÃ½ch",
            formulaNotes: "V paneli receptÃºry bude prÃ­stupnÃ¡ sekcia s poznÃ¡mkami k receptÃºre.",
            helpSettings: "InformÃ¡cie sÃº viditeÄ¾nÃ© v sekciÃ­ Pomoc v paneli rÃ½chleho prÃ­stupu.",
            importCustomData: "VloÅ¾Ã­ lokÃ¡lne vlastnÃ© dÃ¡ta na zÃ¡klade zvolenÃ©ho formÃ¡tu.",
            importExcelFile: "Import the excel file with data to be added to database.",
            importsLocalSettings: "Importuje lokÃ¡lne nastavenia exportovanÃ© z inÃ©ho poÄÃ­taÄa.",
            internalNote: "Na panele receptÃºry bude dostupnÃ¡ sekcia pre internÃ© poznÃ¡mky.",
            lockComputer:
                "Nastavenie zaistÃ­, Å¾e prostredie %{name} sa nebude daÅ¥ opustiÅ¥it, Äo umoÅ¾nÃ­ maximÃ¡lny zÃ¡Å¾itok z mÃ³du kiosku. PouÅ¾iteÄ¾nÃ© iba pre Windows.",
            maxNumberTabs: "Limit zÃ¡loÅ¾iek nastavuje koÄ¾ko zÃ¡loÅ¾iek mÃ´Å¾e byÅ¥ otvorenÃ½ch naraz.",
            memoryTabs: "Allow reopening of recently opened tabs after the software starts.",
            printAfterDispensing:
                "Nastavenie poÅ¾aduje informÃ¡ciu o tom, koÄ¾ko kÃ³piÃ­ Å¡tÃ­tkov mÃ¡ byÅ¥ vytlaÄenÃ½ch po procese tÃ³novania.",
            printAsImage:
                "TlaÄ ako obrÃ¡zok pomÃ¡ha rieÅ¡iÅ¥ problÃ©my pri beÅ¾nom spÃ´sobe tlaÄe. NepouÅ¾Ã­vajte, ak funguje beÅ¾nÃ¡ tlaÄ sprÃ¡vne. Funguje iba pre Linux.",
            printBeforeDispensing:
                "Nastavenie poÅ¾aduje informÃ¡ciu o tom, koÄ¾ko kÃ³piÃ­ Å¡tÃ­tkov mÃ¡ byÅ¥ vytlaÄenÃ½ch pred procesom tÃ³novania.",
            printEnabled: "Nastavenie umoÅ¾nÃ­ pouÅ¾iÅ¥ tlaÄiareÅ. DodatoÄnÃ© nastavenia sÃº v Nastaveniach tlaÄe.",
            printOnRequest: "V paneli receptÃºry bude aktivovanÃ© tlaÄÃ­tko TlaÄ.",
            printTaskVariable: "TlaÄ sa vykonÃ¡ iba v prÃ­pade, Å¾e v dostupnÃ½ch dÃ¡tach je danÃ¡ premennÃ¡ vyplnenÃ¡.",
            quickTintTemplate: "ZvolenÃ¡ Å¡ablÃ³na bude pouÅ¾itÃ¡ pri tlaÄenÃ­ Å¡tÃ­tkov z rÃ½chleho tÃ³novania.",
            restoreLocalSettings:
                "ObnovÃ­ lokÃ¡lne nastavenie tohto poÄÃ­taÄa. Po vymazanÃ­ vÅ¡etkÃ½ch nastavenÃ­ sa mÃ´Å¾e vytvoriÅ¥ novÃ© nastavenie.",
            runLightAtStartUp: "%{light} bude spustenÃ½ namiesto %{name}.",
            screenSaverTimeout: "Nastavuje po koÄ¾kÃ½ch minÃºtach sa aktivuje Å¡etriÄ obrazovky.",
            selectCustomDataFormat:
                "ZvoÄ¾te formÃ¡t VaÅ¡ich pÃ´vodnÃ½ch dÃ¡t, ktorÃ© chcete importovaÅ¥. KaÅ¾dÃ½ formÃ¡t mÃ´Å¾e vyÅ¾adovaÅ¥ rÃ´zne dodatoÄnÃ© sÃºbory a nastavenia.",
            setCustomHomeButton: "DomovskÃ© tlaÄÃ­tko v %{name} presmeruje na zvolenÃ½ panel.",
            setFts: "VyhÄ¾adÃ¡vanie celÃ©ho textu umoÅ¾Åuje celotextovÃ© vyhÄ¾adÃ¡vanie receptÃºr (naprÃ­klad zo stredu slova).",
            setKeyboardShortcuts: "Nie je moÅ¾nÃ© nastaviÅ¥ rovnakÃ© klÃ¡vesovÃ© skratky pre rÃ´zne akcie.",
            setNumberOfDecimalPlaces:
                "ZaokrÃºhÄ¾ovanie urÄuje koÄ¾ko desatinnÃ½ch miest sa zobrazÃ­ v mnoÅ¾stve kolorantu pouÅ¾itÃ©ho v receptÃºre.",
            setOrderSearchParameters:
                "VyhÄ¾adÃ¡vanie objednÃ¡vok definuje, ktorÃ© parametre sÃº pouÅ¾Ã­vanÃ© pri vyhÄ¾adÃ¡vanÃ­ medzi objednÃ¡vkami. PrÃ­stupnÃ© len v %{name}.",
            setOverwriteLastTab:
                "Pri vÃ½bere novej receptÃºry cez rÃ½chle vyhÄ¾adÃ¡vanie, priÄom je dosiahnutÃ½ limit kariet, sa poslednÃ¡ naÄÃ­tanÃ¡ karta prepÃ­Å¡e novo vybranou receptÃºrou.",
            setSearchPanel:
                "Nastavte, ktorÃ© poloÅ¾ky a v akom poradÃ­ majÃº byÅ¥ viditeÄ¾nÃ©, keÄ sa vyhÄ¾adÃ¡va novÃ¡ receptÃºra.",
            setVisibilityAndOrder:
                "ZvolenÃ¡ navigaÄnÃ¡ poloÅ¾ka bude viditeÄ¾nÃ¡ v paneli rÃ½chleho prÃ­stupu. NajvyÅ¡Å¡ia pozÃ­cia v nastaveniach definuje pozÃ­ciu najviac vÄ¾avo v paneli. MaximÃ¡lne povolenÃ© mnoÅ¾stvo navigaÄnÃ½ch poloÅ¾iek je 6.",
            setYourLanguage: "Pre zmenu jazyka je nevyhnutnÃ© softvÃ©r reÅ¡tartovaÅ¥.",
            settingsSearch: "VyhÄ¾adajte rÃ´zne nastavenia, ak neviete, kde ich nÃ¡jsÅ¥.",
            showNewOrderNotifications:
                "Upozornenie na objednÃ¡vku je vyskakovacie okno s oznÃ¡menÃ­m prijatia novej objednÃ¡vky.",
            sorting: "RÃ½chle tÃ³novanie mÃ´Å¾e maÅ¥ kanistre zoradenÃ© podÄ¾a nÃ¡zvov kolorantov alebo podÄ¾a ID kanistrov.",
            turnOnKioskMode: "ReÅ¾im kiosku skryje hlavnÃº liÅ¡tu.",
            windowClosingRules:
                "Nastavenie rozhoduje Äi sa okno rÃ½chleho tÃ³novania zatvorÃ­ pred alebo po zaÄatÃ­ tÃ³novacieho procesu."
        },
        formulaSettings: {
            additionalFormulaTab: "Nastavenie rozhodne, ktorÃ½ panel sa vyorbrazÃ­ pri otvorenÃ­ novej karty receptÃºry.",
            allowCustomFormulas: "VytvÃ¡ranie a vyhÄ¾adÃ¡vanie vlastnÃ½ch receptÃºr bude aktivovanÃ©.",
            allowCustomPackageSize: "V paneli receptÃºry bude aktivovanÃ¡ moÅ¾nosÅ¥ vlastnej veÄ¾kosti balenia.",
            allowEditingColorants:
                "V paneli receptÃºry bude aktivovanÃ© tlaÄÃ­tko UpraviÅ¥ kolorant (viditeÄ¾nÃ© po zvolenÃ­ farby).",
            alternativeFormulasPosition: "Defines how to access alternative formulas.",
            basePanelSize: "NastavÃ­ veÄ¾kosÅ¥ vyhÄ¾adÃ¡vacieho poÄ¾a bÃ¡ze na formula panele.",
            bippPanelSize: "NastavÃ­ veÄ¾kosÅ¥ vyhÄ¾adÃ¡vacieho poÄ¾a bÃ¡ze v balenÃ­ produktu na formula panele.",
            blendColorNameAndCode: "Nastavenie spÃ¡ja polÃ­Äka pre vyhÄ¾adÃ¡vanie pre NÃ¡zov farby a KÃ³d farby do jednÃ©ho.",
            color: "V paneli receptÃºry bude zobrazenÃ½ len nÃ¡hÄ¾ad farby.",
            colorCodePrimary: "KÃ³d farby bude vo vyhÄ¾adÃ¡vacom okne vyobrazenÃ½ ako prvÃ½.",
            colorPreviewAsImage: "Na formula panele bude nÃ¡hÄ¾ad odtieÅa dostupnÃ½ vo forme obrÃ¡zku.",
            colorPreviewResizable: "PovoÄ¾uje meniÅ¥ veÄ¾kosÅ¥ panelu nÃ¡hÄ¾adu farby.",
            colorantPanelLimit:
                "The settings sets the number of colorants that will be always visible before it hides under scroll bar.",
            colorantPanelOrderBy: "Panel receptÃºry mÃ´Å¾e maÅ¥ koloranty zoradenÃ© podÄ¾a nÃ¡zvov alebo mnoÅ¾stva.",
            customCanOption: "ZvoÄ¾te, ktorÃ© mernÃ© jednotky sa sa mÃ´Å¾u pouÅ¾iÅ¥ pre vlastnÃ© balenia na Formula panele.",
            customCanSettingsUnit:
                "ZvoÄ¾te, ktorÃ¡ mernÃ¡ jednotka mÃ¡ byÅ¥ pouÅ¾itÃ¡ ako zÃ¡kladnÃ¡ pre nastavenie vlastnÃ©ho balenia na Formula panely.",
            customFormulaForMasterProduct:
                "Defines whether the option âFormula for master productâ is displayed when saving custom formula",
            customFormulaForMasterProductDefault:
                "Defines whether the option âFormula for master productâ is checked by default",
            deleteConfirmation:
                "SpustenÃ­m tohto nastavenia aktivujete vyskakovacie okno vyÅ¾adujÃºce potvrdenie pri mazanÃ­ poloÅ¾iek.",
            dropDownCalculate:
                "The drop-down menu to select the formula you are looking for will extend to the bottom of the window.",
            fandeckGroups: "The setting enables hierarchy with fandeck groups if available in the database.",
            fandeckPanelSize: "NastavÃ­ veÄ¾kosÅ¥ vyhÄ¾adÃ¡vacieho poÄ¾a vzorkovnice na formula panele.",
            favoriteFormulasInitial: "Pri spustenÃ­ %{name} sa zobrazÃ­ panel s obÄ¾ÃºbenÃ½mi receptÃºrami.",
            formulaAutomaticNaming:
                "PozmenenÃ¡ receptÃºra sa automaticky premenuje na zÃ¡klade vykonanÃ½ch zmien kolorantov.",
            formulaPanel: "Po otvorenÃ­ novej zÃ¡loÅ¾ky sa zobrazÃ­ panel receptÃºry.",
            formulaPanelInitial: "Pri spustenÃ­ %{name} sa zobrazÃ­ panel receptÃºry.",
            formulaPanelSize: "NastavÃ­ veÄ¾kosÅ¥ vyhÄ¾adÃ¡vacieho poÄ¾a receptÃºry na formula panele.",
            formulaPropertiesPosition: "Defines how to access formula properties.",
            generateColorPreview:
                "Pri zapnutÃ­ tohto nastavenia sa automaticky vygeneruje nÃ¡hÄ¾ad farby. VÃ½slednÃ½ nÃ¡hÄ¾ad nie je presnÃ½.",
            historicalFormulasPosition: "Defines how to access historical formulas.",
            image: "V paneli receptÃºry bude vedÄ¾a nÃ¡hÄ¾adu farby zobrazenÃ½ obrÃ¡zok produktu s moÅ¾nosÅ¥ou otvorenia panelu s ÄalÅ¡Ã­mi informÃ¡ciami.",
            images: "Nastavenie definuje zdroj sÃºborov pre obrÃ¡zky.",
            infoPanelResizable: "PovoÄ¾uje meniÅ¥ veÄ¾kosÅ¥ panelu viac info.",
            initialFormulaTab: "Nastavenie rozhodne, ktorÃ½ panel sa vyobrazÃ­ pri Å¡tarte %{0}.",
            moreInfo: "V paneli receptÃºry bude vedÄ¾a nÃ¡hÄ¾adu farby a obrÃ¡zku produktu zobrazenÃ½ informaÄnÃ½ panel.",
            orderByDistance: "With this setting on, the result of color search is ordered by special distance metric.",
            productCode:
                "Toto nastavenie umoÅ¾Åuje pouÅ¾Ã­vaÅ¥ kÃ³dy produktov spolu s nÃ¡zvami produktov, ak sÃº dostupnÃ© v databÃ¡ze.",
            productFiles: "Nastavenie definuje zdroj produktovÃ½ch sÃºborov, ktorÃ© sÃº dostupnÃ© na formula panele.",
            productGroups: "Nastavenie povolÃ­ hierarchiu produktovÃ½ch skupÃ­n, ak sÃº skupiny dostupnÃ© v databÃ¡ze.",
            productPanelSize: "NastavÃ­ veÄ¾kosÅ¥ vyhÄ¾adÃ¡vacieho poÄ¾a produktu na formula panele.",
            searchNewFormula:
                "Po otvorenÃ­ novej zÃ¡loÅ¾ky sa zobrazÃ­ vyhÄ¾adÃ¡vanie novej receptÃºry (obsahuje informÃ¡cie o poslednej vytÃ³novanej receptÃºre a o obÄ¾ÃºbenÃ½ch receptÃºrach).",
            searchNewFormulaInitial:
                "Pri spustenÃ­ %{name} sa zobrazÃ­ vyhÄ¾adÃ¡vanie novej receptÃºry (obsahuje informÃ¡cie o poslednej vytÃ³novanej receptÃºre a o obÄ¾ÃºbenÃ½ch receptÃºrach).",
            searchPanelFormulaItems: "MusÃ­ byÅ¥ zvolenÃ¡ aspoÅ jedna z poloÅ¾iek recepovania.",
            searchPanelProductItems: "Smie byÅ¥ zvolenÃ¡ iba jedna poloÅ¾ka produktu.",
            searchPanelQuickSelect:
                "No need to press the load formula button. You will be redirected directly to main formula tab just after formula selection.",
            setCompetitiveColorSearch:
                "Po spustenÃ­ tohto nastavenia je k dispozÃ­cii funkcia vyhÄ¾adÃ¡vania konkurenÄnÃ½ch odtieÅov na Palete farieb na Formula panely (len pre nedostupnÃ© receptÃºry).",
            setFormulaInfoInPreview: "NÃ¡hÄ¾ad odtieÅa na panely receptÃºry bude obsahovaÅ¥ vybranÃ½ Ãºdaj.",
            setFormulaPreview:
                "Nastavenie menÃ­ pozÃ­ciu a vyobrazenie nÃ¡hÄ¾adu odtieÅa, obrÃ¡zku balenia a informaÄnÃ½ch Ãºdajov o receptÃºre.",
            setFormulaRGBPreviewVisibleInformation:
                "V paneli receptÃºry bude v nÃ¡hÄ¾ade farby vÅ¾dy zobrazenÃ½ zvolenÃ½ typ dÃ¡t.",
            setFormulaUnit:
                "Toto nastavenie rozhoduje, ktorÃ¡ mernÃ¡ jednotka receptÃºry je zobrazenÃ¡ v paneli receptÃºry ako prvÃ¡ po zvolenÃ­ farby. TaktieÅ¾ pouÅ¾iteÄ¾nÃ© v rÃ½chlom tÃ³novanÃ­.",
            setFormulaVisibilityAndOrder:
                "V paneli receptÃºry budÃº zobrazenÃ© zvolenÃ© dÃ¡ta v sekciÃ­ Viac informÃ¡ciÃ­ (pouÅ¾iteÄ¾nÃ© len ak je nastavenÃ½ nÃ¡hÄ¾ad receptÃºry v Nastaveniach receptÃºry na obrÃ¡zok alebo viac informÃ¡ciÃ­).",
            setMaxToleranceForCompetitiveColors:
                "Nastavte maximÃ¡lnu toleranciu Delta E (CIE 2000) pre vyhÄ¾adÃ¡vanie konkurenÄnÃ½ch odtieÅov.",
            setNumberOfCompetitiveColors:
                "Define how many competitive master colors should be offered after search. The defined number does not correspond to the number of results.",
            setVisibleUnit:
                "Toto nastavenie rozhoduje, ktorÃ¡ mernÃ¡ jednotka bude zobrazenÃ¡ v paneli receptÃºry po zvolenÃ­ farby. TaktieÅ¾ pouÅ¾iteÄ¾nÃ© v rÃ½chlom tÃ³novanÃ­.",
            showColorPreview: "Pri vyhÄ¾adÃ¡vanÃ­ novej receptÃºry bude vedÄ¾a nÃ¡zvu farby zobrazenÃ½ malÃ½ nÃ¡hÄ¾ad farby.",
            showSiblingProducts:
                "Defines whether the option âShow sibling productsâ is displayed when saving custom formula",
            useColorCode: "Panel receptÃºry zobrazuje kÃ³d farby."
        },
        formulaValidation: {
            batchNumberInvalid: "Canister (%{colorants}) is filled with a defective batch of colorant.",
            batchNumberWarning: "Colorant (%{colorants}) with this batch number may be damaged.",
            bellowBaseLimit: "SÃºhrn mnoÅ¾stiev kolorantov je pod limitom bÃ¡ze.",
            checkColorantBaseRules: "The setting checks if used colorants and base can be used in this combination.",
            checkMinDosableAmount:
                "MinimÃ¡lne tÃ³novateÄ¾nÃ© mnoÅ¾stvo je najmenÅ¡ie mnoÅ¾stvo kolorantu, ktorÃ© sa na odporÃºÄanie laboratÃ³ria smie tÃ³novaÅ¥.",
            checkOverfill:
                "Nastavenie kontroluje, Äi je v plechovke dostatok miesto pre koloranty hneÄ po tom, Äo sa koloranty nastavia.",
            checkTotalCntAmounts:
                "Nastavenie kontroluje, Äi nie sÃº presiahnutÃ© minimÃ¡lne a maximÃ¡lne mnoÅ¾stvÃ¡ kolorantov v balenÃ­ bÃ¡ze produktu. Tieto limity sa nastavujÃº v databÃ¡ze.",
            colorantBaseRules: "Colorant is not valid for selected base.",
            colorantMinAmount: "MnoÅ¾stvo kolorantu je pod hranicou minimÃ¡lneho vytÃ³novateÄ¾nÃ©ho mnoÅ¾stva.",
            dispensingWithErrorsEnabled:
                "Ak je nastavenie povolenÃ©, v prÃ­pade poruÅ¡enia validÃ¡cie sa objavÃ­ varovnÃ¡ hlÃ¡Å¡ka, ale aj tak bude moÅ¾nÃ© tÃ³novaÅ¥.",
            invalidBatchNumber: "Colorant has invalid or defective batch number",
            overBaseLimit: "SÃºhrn mnoÅ¾stiev kolorantov je nad maximÃ¡lnym tÃ³novateÄ¾nÃ½m mnoÅ¾stvom.",
            overfill: "Bolo zaznamenanÃ© preplnenie.",
            unifyColorantBatchForMultipleCans:
                "If allowed, an info refill to max modal will appear when amount of colorant is bigger than maximum of canister and canister is not filled on maximum level.",
            warningConfirmBtn: "PoznÃ¡m rizikÃ¡, pokraÄovaÅ¥"
        },
        help: "Podpora",
        helpLink: "Centrum pomoci",
        helper: {
            automaticallyCheckForUpdates:
                "Automaticky sa v danom Äasovom intervale skontroluje, Äi sÃº k dispozÃ­cii novÃ© aktualizÃ¡cie pre %{name} alebo pre databÃ¡zu.",
            automaticallyDownloadUpdates:
                "Ak je k dispozÃ­cii aktualizÃ¡cia, automaticky sa stiahne bez nutnosti potvrdenia.",
            automaticallyInstallNewDatabases:
                "Ak je prijatÃ¡ doposiaÄ¾ neprÃ­tomnÃ¡ databÃ¡za, nainÅ¡taluje sa ako novÃ¡ databÃ¡za. NÃ¡sledne sa mÃ´Å¾e databÃ¡za pouÅ¾Ã­vaÅ¥.",
            automaticallyInstallUpdates:
                "Ak sa stiahla aktualizÃ¡cia, automaticky sa nainÅ¡taluje bez nutnosti potvrdenia.",
            canBrowseChangeLog: "Pri aktualizÃ¡cii softvÃ©ru bude moÅ¾nÃ© vyobraziÅ¥ si oficiÃ¡lny %{name} changelog.",
            forceInstall: "The update will be installed by force.",
            installDuringNight: "AktualizÃ¡cia sa nainÅ¡taluje poÄas noci, ak je poÄÃ­taÄ spustenÃ½."
        },
        licensing: {
            collect:
                "SÃºbory sa stiahnu na zvolenÃ© miesto. Tieto sÃºbory sÃº potrebnÃ© pre dodÃ¡vateÄ¾a softvÃ©ru, aby vykonal analÃ½zu programovej chyby.",
            company: "SpoloÄnosÅ¥, ktorÃ¡ dodala licenciu.",
            computerID: "IdentifikÃ¡cia licencie, ktorÃ¡ pomÃ´Å¾e dodÃ¡vateÄ¾ovi softvÃ©ru v prÃ­pade vyÅ¾adovanej asistencie.",
            email: "EmailovÃ¡ adresa drÅ¾iteÄ¾a licencie.",
            licenseUuid: "IdentifikÃ¡cia licencie, ktorÃ¡ pomÃ´Å¾e dodÃ¡vateÄ¾ovi softvÃ©ru v prÃ­pade vyÅ¾adovanej asistencie.",
            name: "Meno drÅ¾iteÄ¾a licencie.",
            openBugreport: "ProsÃ­m, dajte nÃ¡m vedieÅ¥, ak je v programe chyba a poÅ¡lite nÃ¡m sprÃ¡vu s popisom problÃ©mu.",
            posInfoContactperson: "InformÃ¡cie o majiteÄ¾ovi predajnÃ©ho miesta, ktorÃ© sa dajÃº vytlaÄiÅ¥ na Å¡tÃ­tok.",
            posInfoMachineInformation:
                "InformÃ¡cie o stroji predajnÃ©ho miesta, ktorÃ© sa dajÃº vytlaÄiÅ¥ na Å¡tÃ­tok alebo slÃºÅ¾ia ako identifikÃ¡tor v sieti.",
            posInfoPos: "InformÃ¡cie o predajnom mieste, ktorÃ© sa dajÃº vytlaÄiÅ¥ na Å¡tÃ­tok.",
            reactivation: "OpÃ¤tovnÃ¡ aktivÃ¡cia alebo zmena sÃºÄasnej licencie.",
            refresh: "Downloads the newest license information.",
            refreshUnavailable: "License refresh unavailable because you are offline.",
            registrationContactperson: "RegistraÄnÃ© informÃ¡cie na identifikÃ¡ciu majiteÄ¾a licencie.",
            registrationMachineInformation: "RegistraÄnÃ© informÃ¡cie na identifikÃ¡ciu stroja licencie.",
            registrationPos: "RegistraÄnÃ© informÃ¡cie na identifikÃ¡ciu predajnÃ©ho miesta licencie.",
            versionScope: "ÄasovÃ½ limit licencie.",
            versionType: "Typ produktu softvÃ©ru."
        },
        machineIsBusy: "Nie je moÅ¾nÃ© resetovaÅ¥ chyby, pretoÅ¾e stroj je zaneprÃ¡zdnenÃ½.",
        machineSettings: {
            allowManualColorantAddition:
                "Ak poÅ¾adovanÃ© mnoÅ¾stvo kolorantu presahuje maximÃ¡lne tÃ³novateÄ¾nÃ© mnoÅ¾stvo, nastavenie povoÄ¾uje ruÄnÃ© pridanie kolorantu po tÃ³novanÃ­.",
            autotasks:
                "AutomatickÃ© Ãºkony sÃº akcie automatickej ÃºdrÅ¾by strojov a poÄÃ­taÄov, ktorÃ© je moÅ¾nÃ© nastaviÅ¥, aby sa vykonÃ¡vali v urÄitom Äase alebo urÄitom Äasovom intervale.",
            barcodeRefillValidation: "The setting turns on barcode validation on refill.",
            barcodeRefillValidationBaseAndColorant:
                "Barcode check is performed on canister and colorant package refilling.",
            barcodeRefillValidationColorant: "Barcode check is performed on colorant package refilling.",
            canisterBarcode:
                "ÄiarovÃ½ kÃ³d je priradenÃ½ a kanister, v ktorom sa nachÃ¡dza danÃ½ kolorant. ÄiarovÃ½ kÃ³d je potrebnÃ½ na sprÃ¡vne doplnenie kolorantu.",
            checkCanBeforeDispense: "Nastavenie je platnÃ© len pre Fast & Fluid simulation.",
            checkOverfill:
                "Nastavenie kontroluje Äi je v plechovke dostatok miesta pre kolorant pred zaÄiatkom tÃ³novania.",
            currentlySelectedMachine: "Poskytuje informÃ¡cie o momentÃ¡lne zvolenom stroji.",
            dispenseInvalidColorants:
                "Nastavenie umoÅ¾Åuje ruÄnÃ© tÃ³novanie kolorantov, ktorÃ© nie sÃº definovanÃ© v konfigurÃ¡cii stroja.",
            dispenserConfigurationBackup:
                "Stiahnite a uloÅ¾te si sÃºÄasnÃ© nastaveine stroja, aby ste si uchovali zÃ¡lohu.",
            dispensingLogic:
                "Typy logiky tÃ³novania mÃ´Å¾u zabezpeÄiÅ¥ inÃ© sprÃ¡vanie pre kaÅ¾dÃ½ kanister, keÄ sa mÃ¡ vytÃ³novaÅ¥ viac kolorantu ako je povolenÃ© alebo Å¾iadanÃ©. DodatoÄnÃ© sprÃ¡vanie sa nastavuje v NastavenÃ­ tÃ³novania.",
            enableTmc: "Nastavenie umoÅ¾Åuje posielanie dÃ¡t do TMC.",
            enableUserIdentification: "Pred povolenÃ­m tÃ³novania sa musÃ­ uÅ¾ivateÄ¾ prihlÃ¡siÅ¥.",
            machineUnit: "Jednotka stroja definuje mernÃº jednotku kolorantov v kanistroch.",
            minDispensedAmount:
                "MinimÃ¡lne tÃ³novanÃ© mnoÅ¾stvo urÄuje, koÄ¾ko kolorantu musÃ­ byÅ¥ vydanÃ©, aby sa zvÃ¡Å¾il odstrek (aby sa zabrÃ¡nilo dodatoÄnÃ©mu odstreku)",
            minimalDispenseAmount:
                "MinimÃ¡lne mnoÅ¾stvo pre tÃ³novanie je najmenÅ¡ie odporÃºÄanÃ© mnoÅ¾stvo kolorantu, ktorÃ© mÃ´Å¾e byÅ¥ tÃ³novanÃ©. Pri jeho poruÅ¡enÃ­ sa zobrazÃ­ sprÃ¡va (tÃ³novanie je vÅ¡ak stÃ¡le moÅ¾nÃ©).",
            missingAutotaskCanisters: "AspoÅ 1 kanister musÃ­ byÅ¥ zvolenÃ½.",
            missingAutotaskChannels: "AspoÅ 1 okruh musÃ­ byÅ¥ zvolenÃ½.",
            missingAutotaskChannelsValue: "Objem vÅ¡etkÃ½ch zvolenÃ½ch okruhov musÃ­ byÅ¥ vyplnenÃ©.",
            missingAutotaskCleanTime: "Äas Äistenia musÃ­ byÅ¥ vyplnenÃ½.",
            missingAutotaskName: "NÃ¡zov automatickÃ©ho Ãºkonu musÃ­ byÅ¥ vyplnenÃ½.",
            missingAutotaskRecirculation: "Äas a rÃ½chlosÅ¥ recirkulÃ¡cie musia byÅ¥ vyplnenÃ©.",
            missingAutotaskStirring: "Äas a rÃ½chlosÅ¥ mieÅ¡ania musia byÅ¥ vyplnenÃ©.",
            missingAutotaskVolume: "Objem odstreku musÃ­ byÅ¥ vyplnenÃ½.",
            placeCanSensor:
                "Nastavenie aktivuje senzor pre umiestnenie plechovky â tÃ³novanie nezaÄne pokiaÄ¾ nebude plechovka umiestnenÃ¡ poriadne.",
            placeCanSensorDelay:
                "OdporÃºÄanÃ© nastavenie spojenÃ© so senzorom umiestnenia plechovky. ZaisÅ¥uje, Å¾e tÃ³novanie vÅ¾dy zaÄne aÅ¾ po definovanom Äasovom Ãºseku, poÄas ktorÃ©ho je plechovka poriadne umiestnenÃ¡.",
            purgeVolume: "Objem odstreku urÄuje mnoÅ¾stvo kolorantu, ktorÃ© bude odstreknutÃ© poÄas mÃºdreho odstreku.",
            rccUrl: "Redlike Control Center (RCC) je zodpovednÃ© za komunikÃ¡ciu so strojom.",
            refillThreshold:
                "If the amount of colorant in the canister with the given UFI or Batch number drops below this limit, such UFI or Batch number will be discarded.",
            refillThresholdBatch:
                "If the amount of colorant in the canister with the given Batch number drops below this limit, such Batch number will be discarded.",
            refillThresholdUfi:
                "If the amount of colorant in the canister with the given UFI drops below this limit, such UFI will be discarded.",
            removeCanSensor:
                "Nastavenie aktivuje senzor pre odstrÃ¡nenie plechovky â tÃ³novanie nie je dokonÄenÃ© pokiaÄ¾ nie je plechovka odstrÃ¡nenÃ¡ zo stroja.",
            removeCanSensorDelay:
                "OdporÃºÄanÃ© nastavenie spojenÃ© so senzorom odobratia plechovky. ZaisÅ¥uje, Å¾e tÃ³novanie je dokonÄenÃ© aÅ¾ po definovanom Äasovom Ãºseku, poÄas ktorÃ©ho bola plechovka odobratÃ¡ zo stroja.",
            skipPlaceCanDialog:
                "Po zapnutÃ­ tohto nastavenia, nebude tÃ³novacÃ­ stroj pri umiestÅovanÃ­ plechovky ÄakaÅ¥, pokiaÄ¾ bude stlaÄenÃ© tlaÄÃ­tko OK, ale zaÄne proces tÃ³novania automaticky.",
            skipRemoveCanDialog:
                "Po zapnutÃ­ tohto nastavenia, nebude tÃ³novacÃ­ stroj pri odoberanÃ­ plechovky ÄakaÅ¥, pokiaÄ¾ bude stlaÄenÃ© tlaÄÃ­tko OK a proces tÃ³novania bude povaÅ¾ovanÃ½ automaticky za dokonÄenÃ½.",
            smartPurgeType:
                "Typ odstreku mÃ´Å¾e pozostÃ¡vaÅ¥ buÄ iba z tÃ³novania alebo z tÃ³novania a ÄalÅ¡ej odstrekovej akcie pri overovanÃ­ Äi je mÃºdry odstrek potrebnÃ½.",
            splitFormula:
                "Ak poÅ¾adovanÃ© mnoÅ¾stvo kolorantu presahuje maximÃ¡lne tÃ³novateÄ¾nÃ© mnoÅ¾sto, nastavenie povoÄ¾uje vytÃ³novaÅ¥ ÄasÅ¥ kolorantu,doplniÅ¥ kanister a potom pokraÄovaÅ¥ v tÃ³novanÃ­ zvyÅ¡ku.",
            tintometricSystem:
                "Tintometric system (set of available colorants) defines what colorants and formulas will be available in the application and application settings.",
            validateBarcodeBaseCan:
                "BÃ¡za mÃ´Å¾e byÅ¥ overenÃ¡ pomocou ÄiarovÃ©ho kÃ³du predtÃ½m ako je povolenÃ© tÃ³novanie. Nastavenie zaisÅ¥uje pouÅ¾itie sprÃ¡vnej bÃ¡ze.",
            validateColorantsDuringInit:
                "Nastavenie stroja sa porovnÃ¡ s databÃ¡zou pri kaÅ¾dom reÅ¡tarte RCC. Ak nastane nesÃºlad, objavÃ­ sa upozornenie."
        },
        matchingSettings: {
            matchingInformation: "On matching result panel, %{item} will be available.",
            matchingOptionsColorants: "On matching options panel, colorants panel will be available.",
            matchingOptionsColorfile: "On matching options panel, colorfile selectbox will be available.",
            matchingOptionsSortResults: "On matching options panel, sort results selectbox will be available.",
            matchingRowCount: "Defines how many results should be offered after matching."
        },
        navigation: {
            barcodeScan: "OtvorÃ­ okno s moÅ¾nosÅ¥ou ruÄnÃ©ho vloÅ¾enia ÄiarovÃ©ho kÃ³du.",
            canisterBarcodes: "OtvorÃ­ okno s prehÄ¾adom ÄiarovÃ½ch kÃ³dov kanistrov a moÅ¾nosÅ¥ou ich nastaviÅ¥.",
            canisterLevel: "OtvorÃ­ okno s prehÄ¾adom stavu kanistrov a moÅ¾nosÅ¥ou ich nastaviÅ¥.",
            canisters: "OtvorÃ­ panel s prehÄ¾adom stavu kanistrov a moÅ¾nosÅ¥ou ich nastaviÅ¥.",
            clean: "Open a window with the possibility to clean machine channels",
            colorPanel: "OtvorÃ­ panel s moÅ¾nosÅ¥ou vyhÄ¾adaÅ¥ novÃº receptÃºru v elektronickej vzorkovnici.",
            colorSearchTab: "Opens a panel with possibility to search all colors in all fandecks.",
            colorantRefillHistory: "OtvorÃ­ okno s prehÄ¾adom vykonanÃ½ch doplnenÃ­ kanistrov.",
            customFormula: "OtvorÃ­ panel s moÅ¾nosÅ¥ou vytvoriÅ¥ novÃº vlastnÃº receptÃºru.",
            customers: "OtvorÃ­ panel s prehÄ¾adom zÃ¡kaznÃ­kov s moÅ¾nosÅ¥ou ich pridaÅ¥/upraviÅ¥/vymazaÅ¥.",
            dispensingHistory: "OtvorÃ­ panel s prehÄ¾adom vykonanÃ½ch tÃ³novanÃ­.",
            favorites: "OtvorÃ­ panel s moÅ¾nosÅ¥ou voÄ¾by obÄ¾Ãºbenej receptÃºry.",
            help: "OtvorÃ­ okno s informÃ¡ciami o podpore zÃ¡kaznÃ­kov, ak ich dodÃ¡vateÄ¾ doplnil.",
            hideItems: "OtvorÃ­ okno s moÅ¾nosÅ¥ou oznaÄiÅ¥ produkty a vzorkovnice ako skrytÃ©.",
            historyOfOrders: "PlatÃ­ iba pre %{name}. OtvorÃ­ panel s prehÄ¾adom vytÃ³novanÃ½ch objednÃ¡vok.",
            machineReset: "SpustÃ­ reset stroja.",
            matching: "Opens a panel with the possibility to match new color with a spectro.",
            myOrders: "OtvorÃ­ okno s odoslanÃ½mi objednÃ¡vkami.",
            purge: "OtvorÃ­ okno s moÅ¾nosÅ¥ou nastavenia odstrekov kanistrov.",
            quickTint: "OtvorÃ­ okno s moÅ¾nosÅ¥ou vykonaÅ¥ manuÃ¡lne tÃ³novanie.",
            searchFormula: "OtvorÃ­ panel s moÅ¾nosÅ¥ou vyhÄ¾adaÅ¥ novÃº recepÃºru.",
            spectro: "OtvorÃ­ panel s moÅ¾nosÅ¥ou meraÅ¥ spektrometrom.",
            stir: "OtvorÃ­ okno s moÅ¾nosÅ¥ou nastaviÅ¥ mieÅ¡anie kanistrov.",
            ticketing: "Opens a ticketing system panel.",
            toDispense: "OtvorÃ­ okno s prijatÃ½mi objednÃ¡vkami."
        },
        noHelpForLicense:
            "Pre VaÅ¡u licenciu nie je k dispozÃ­cii Å¾iadna podpora. PoÅ¾iadajte dodÃ¡vateÄ¾a o jej doplnenie.",
        posInfo: {
            sync: "Zosynchronizuje Ãºdaje so sekciou RegistrÃ¡cia"
        },
        poweredByDeso: "PoskytovateÄ¾: %{name}",
        priceSettings: {
            VatPrice: "Hodnota DPH kolorantu v %.",
            VatPriceProduct: "Hodnota generickej DPH bude pre kaÅ¾dÃ½ produkt rovnakÃ¡. StanovenÃ© v %",
            basePurchase: "NÃ¡kupnÃ¡ cena bÃ¡ze (zahÅÅa vÃ½luÄne bÃ¡zu).",
            basePurchasePriceProduct: "NÃ¡kupna cena za balenie danej bÃ¡ze. StanovenÃ¡ vo vybranej mene.",
            baseSell: "PredajnÃ¡ cena bÃ¡ze (zahÅÅa bÃ¡zu a marÅ¾u/prirÃ¡Å¾ku).",
            baseSellFull: "CelÃ¡ predajnÃ¡ cena bÃ¡ze.",
            cntName: "Definuje, s ktorÃ½m kolorantom cena sÃºvisÃ­.",
            cntPurchase: "NÃ¡kupnÃ¡ cena kolorantov (zahÅÅa vÃ½luÄne koloranty).",
            cntPurchaseByName:
                "NÃ¡kupnÃ¡ cena kolorantov kalkulovanÃ¡ individuÃ¡lne pre kaÅ¾dy zvlÃ¡Å¡Å¥ (zahÅÅa vÃ½luÄne koloranty).",
            cntPurchasePricePerLiter: "Cena kolorantu za liter (bez marÅ¾e alebo prirÃ¡Å¾ky).",
            cntSell: "PredajnÃ¡ cena kolorantov (zahÅÅa koloranty a marÅ¾u/prirÃ¡Å¾ku).",
            cntSellByName:
                "PredajnÃ¡ cena vÅ¡etkÃ½ch kolorantov pouÅ¾itÃ½ch v produkte, kalkulovanÃ¡ individuÃ¡lne pre kaÅ¾dÃ½ zvlÃ¡Å¡Å¥ (zahÅÅa kolotanty a marÅ¾u/prirÃ¡Å¾ku).",
            cntSellFull: "CelÃ¡ predajnÃ¡ cena za koloranty.",
            cntSellFullByName: "CelÃ¡ predajnÃ¡ cena za koloranty podÄ¾a nÃ¡zvu.",
            cntSellPricePerLiter:
                "PredajnÃ¡ cena kolorantu za liter (iba cena kolorantov). Nastavuje sa vo zvolenej mene.",
            cntVat: "Hodnota DPH kolorantu stanovenÃ¡ v %.",
            colorants:
                "GenerickÃ© ceny kolorantov budÃº rovnakÃ© pre kaÅ¾dÃ½ kolorant. TÃ¡to funkcia je obzvlÃ¡Å¡Å¥ uÅ¾itoÄnÃ¡ pre nastavenie DPH.",
            colorantsPosCoeficient: "The generic colorant coeficient for POS.",
            colorantsSellPrice:
                "GenerickÃ© ceny kolorantov budÃº rovnakÃ© pre vÅ¡etkÃ½ koloranty. PredajnÃ¡ cena sa odporÃºÄa upraviÅ¥ zÄ¾avou. StanovenÃ© vo vybranej mene.",
            currencyCodeNew: "KÃ³d meny musÃ­ byÅ¥ v oficiÃ¡lnej trojpÃ­smenovej forme, naprÃ­klad EUR.",
            currencyNameNew: "NÃ¡zov meny, naprÃ­klad Euro.",
            currencyRateNew:
                "MenovÃ½ kurz voÄi hlavnej mene, naprÃ­klad 25.855 CZK for 1 â¬. Kurz musÃ­ byÅ¥ vÅ¾dy aktuÃ¡lny a pravidelne upravovanÃ½.",
            currencyRoundingNew:
                "ZaokrÃºhÄ¾ovanie nastavuje najmenÅ¡iu moÅ¾nÃº splatnÃº hodnotu meny, naprÃ­klad Euro mÃ¡ zaokrÃºhÄ¾ovanie 0,01, pretoÅ¾e najmenÅ¡ia moÅ¾nÃ¡ hodnota je 1 cent.",
            currencySymbolNew: "OficiÃ¡lny symbol meny, naprÃ­klad â¬ pre Euro.",
            defaultPrice: "Cena kolorantu nastavenÃ¡ vo zvolenej databÃ¡ze (bez DPH).",
            defaultPriceGroup: "Cena kolorantu pre cenovÃº skupinu nastavenÃº vo zvolenej databÃ¡ze (bez DPH).",
            defaultVatPrice: "DPH kolorant nastavenÃ¡ vo zvolenej databÃ¡ze.",
            discountHeader: "ZÄ¾ava odÄÃ­ta definovanÃº hodnotu od nÃ¡kupnej ceny kolorantu. StanovenÃ© v %.",
            discountHeaderProduct: "ZÄ¾ava odÄÃ­ta definovanÃº hodnotu od ceny produktu kolorantu. StanovenÃ© v %.",
            export: "Exportujte sÃºbor s momentÃ¡lne nastavenÃ½mi cenami. Po Ãºprave cien ho mÃ´Å¾ete nÃ¡sledne opÃ¤Å¥ importovaÅ¥.",
            import: "Naimportujte sprÃ¡vne naformÃ¡tovanÃ½ (exportovanÃ½) sÃºbor, aby ste vloÅ¾ili alebo upravili ceny.",
            localPrices:
                "LokÃ¡lne ceny zmenia navrhovanÃ© ceny z hlavnej databÃ¡ze a sÃº dostupnÃ© iba lokÃ¡lne na tomto jednom poÄÃ­taÄi.",
            margin: "Vyberte, ktorÃ¡ cenovÃ¡ kalkulÃ¡cia sa mÃ¡ pouÅ¾iÅ¥ pre definÃ­ciu koneÄnej dostupnej ceny. MarÅ¾a a prirÃ¡Å¾ka pripoÄÃ­ta, zatiaÄ¾ Äo zÄ¾ava odÄÃ­ta od danej predajnej ceny.",
            marginAll: "Cena za marÅ¾u/prirÃ¡Å¾ky pre viac balenÃ­ (zahÅÅa marÅ¾u/prirÃ¡Å¾ky).",
            marginHeader: "MarÅ¾a pripoÄÃ­ta definovanÃº hodnotu k nÃ¡kupnej cene kolorantu. StanovenÃ© v %.",
            marginHeaderProduct: "MarÅ¾a pripoÄÃ­ta definovanÃº hodnotu k nÃ¡kupnej cene produktu. StanovenÃ© v %.",
            marginPerPkg: "Cena za marÅ¾u/prirÃ¡Å¾ky pre jedno balenie (zahÅÅa marÅ¾u/prirÃ¡Å¾ky).",
            markupHeader: "ObchodnÃ¡ prirÃ¡Å¾ka pripoÄÃ­ta definovanÃº hodnotu k nÃ¡kupnej cene kolorantu. StanovenÃ© v %.",
            markupHeaderProduct:
                "ObchodnÃ¡ prirÃ¡Å¾ka pripoÄÃ­ta definovanÃº hodnotu k nÃ¡kupnej cene produktu. StanovenÃ© v %.",
            packagePricing: "DodatoÄnÃ½ prÃ­platok je nastavenÃ½ individuÃ¡lne pre kaÅ¾dÃº veÄ¾kosÅ¥ balenia.",
            packageSurcharge: "Ceny generickÃ½ch balenÃ­ sÃº rovnakÃ© pre kaÅ¾dÃ½ prÃ­platok za balenie.",
            priceDefinition: "Definition of pricing logic.",
            priceGroupNumber: "Price groups displays the number of the relevant price group.",
            priceGroupPricePerLiter: "Cena kolorantu pouÅ¾itÃ¡ pri vÃ½poÄte ceny cenovej skupiny.",
            priceGroups:
                "CenovÃ© skupiny zobrazujÃº ÄÃ­slo prÃ­sluÅ¡nej cenovej skupiny (hranice sÃº stanovenÃ© v databÃ¡ze alebo vo vÅ¡eobecnom urÄovanÃ­ cien).",
            priceGroupsEnabled: "CenovÃ© skupiny vyobrazujÃº ÄÃ­slo relevantnej cenovej skupiny.",
            priceGroupsGeneric:
                "CenovÃ© skupiny sÃº intervaly cien koneÄnej farby zaloÅ¾enÃ© na cenÃ¡ch kolorantov v receptÃºre.",
            productBasePackageSellPrice: "PredajnÃ¡ cena za balenie danej bÃ¡ze. Nastavuje sa vo zvolenej mene.",
            productBaseSellPrice: "PredajnÃ¡ cena bÃ¡ze na liter (iba cena bÃ¡ze). Nastavuje sa v zvolenej mene.",
            productBaseVat: "Hodnota DPH bÃ¡ze produktu pre danÃ© balenie stanovenÃ© v %.",
            productName: "Definuje, s ktorou bÃ¡zou produktu cena sÃºvisÃ­.",
            productPosCoeficient: "The generic product coeficient for POS.",
            productPricing: "Pri tÃ³novanÃ­ vlastnÃ½ch balenÃ­ je pouÅ¾Ã­vanÃ¡ nÃ¡kupnÃ¡ cena pre vÅ¡etky balenia.",
            productSize: "Definuje, s ktorÃ½m balenÃ­m danej bÃ¡ze produktu cena sÃºvisÃ­.",
            productVat: "Hodnota DPH bÃ¡ze produktu stanovenÃ¡ v %.",
            products:
                "GenerickÃ© ceny produktov sÃº rovnakÃ© pre kaÅ¾dÃ½ produkt. TÃ¡to funkcia je obzvlÃ¡Å¡Å¥ uÅ¾itoÅ¥nÃ¡ pre nastavenie DPH.",
            productsSellPrice:
                "GenerickÃ© ceny produktov budÃº rovnakÃ© pre vÅ¡etky koloranty. PredajnÃ¡ cena sa odporÃºÄa upraviÅ¥ zÄ¾avou. StanovenÃ© vo vybranej mene.",
            sellPriceAll: "PredajnÃ¡ cena viacerÃ½ch balenÃ­ (zahÅÅa bÃ¡zu, koloranty, prÃ­platok a marÅ¾u/prirÃ¡Å¾ku).",
            sellPricePerKg: "PredajnÃ¡ cena produktu za kilogram (zahÅÅa bÃ¡zu, koloranty, prÃ­platok a marÅ¾u/prirÃ¡Å¾ku).",
            sellPricePerL: "PredajnÃ¡ cena produktu za liter (zahÅÅa bÃ¡zu, koloranty, prÃ­platok a marÅ¾u/prirÃ¡Å¾ku).",
            sellPricePerPkg: "PredajnÃ¡ cena jednÃ©ho balenia (zahÅÅa bÃ¡zu, koloranty, prÃ­platok a marÅ¾u/prirÃ¡Å¾ku).",
            setPriceTypesVisibilityAndOrder:
                "ZvolenÃ© ceny budÃº zobrazenÃ© v sekciÃ­ cien v paneli receptÃºry. NajvyÅ¡Å¡ia pozÃ­cia tu, definuje pozÃ­ciu najviac vÄ¾avo v paneli.",
            surchargeAll: "Cena dodatoÄnÃ©ho poplatku za viac balenÃ­ (zahÅÅa prÃ­platok).",
            surchargePerPkg: "Cena dodatoÄnÃ©ho poplatku za jedno balenie (zahÅÅa prÃ­platok).",
            tintPurchaseAll: "NÃ¡kupnÃ¡ cena za celÃ½ tÃ³novacÃ­ proces viacerÃ½ch balenÃ­ (zahÅÅa koloranty a prÃ­platok).",
            tintPurchasePerPkg: "NÃ¡kupnÃ¡ cena za celÃ½ tÃ³novacÃ­ proces jednÃ©ho balenia (zahÅÅa koloranty a prÃ­platok).",
            tintSellFullAll: "CelÃ¡ cena tÃ³novania za vÅ¡etky balenia.",
            tintlSellFullAllPerPackage: "CelÃ¡ cena tÃ³novania na jedno balenie.",
            totalPurchaseAll: "CelkovÃ¡ nÃ¡kupnÃ¡ cena produktu pre viac balenÃ­ (zahÅÅa bÃ¡zu a koloranty).",
            totalPurchasePerKg: "CelkovÃ¡ nÃ¡kupnÃ¡ cena produktu za kilogram (zahÅÅa bÃ¡zu a koloranty).",
            totalPurchasePerL: "CelkovÃ¡ nÃ¡kupnÃ¡ cena produktu za liter (zahÅÅa bÃ¡zu a koloranty).",
            totalPurchasePerPkg: "CelkovÃ¡ cena produktu pre jedno balenie (zahÅÅa bÃ¡zu a koloranty).",
            totalSellFullAll: "CelkovÃ¡ plnÃ¡ cena za vÅ¡etky balenia.",
            totalSellFullPerKg: "CelkovÃ¡ plnÃ¡ cena na kilogram.",
            totalSellFullPerLiter: "CelkovÃ¡ plnÃ¡ cena na liter.",
            totalSellFullPerPackage: "CelkovÃ¡ plnÃ¡ cena pre jedno balenie.",
            withAndWithoutVat: "Na formula paneli sa cena vyobrazÃ­ v oboch variantÃ¡ch zÃ¡roveÅ - s aj bez DPH.",
            withVat: "Na formula paneli budÃº vÅ¡etci ceny viditeÄ¾nÃ© iba so zahrnutou DPH.",
            withoutVat: "Na formula paneli budÃº vÅ¡etci ceny viditeÄ¾nÃ© iba bez zahrnutej DPH."
        },
        qualityControlSettings: {
            colorDifference: "Color difference model for quality control.",
            deltaA: "Defines tolerance limit for delta A in quality control.",
            deltaB: "Defines tolerance limit for delta B in quality control.",
            deltaE: "Defines tolerance limit for delta E in quality control.",
            deltaL: "Defines tolerance limit for delta L in quality control.",
            deltaMetamerism: "Defines tolerance limit for metamerism delta in quality control."
        },
        registration: {
            sync: "Zosynchronizuje Ãºdaje so sekciou InformÃ¡cie o predajni"
        },
        searchingPleaseWait: "ProsÃ­m, poÄkajte, hÄ¾adÃ¡ sa najlepÅ¡ia zhoda.",
        setupSteps: {
            customData: "VlastnÃ© dÃ¡ta",
            machineType: "Typ stroja",
            userPreferences: "UÅ¾Ã­vateÄ¾skÃ© preferencie"
        },
        spectroSettings: {
            ColorixNanoUseProfiledValues:
                "Pri pouÅ¾itÃ­ profilovÃ½ch hodnÃ´t sa nameranÃ© vÃ½sledky prepoÄÃ­tajÃº, aby sa odstrÃ¡nil efekt filtrovania. PovolenÃ­m tejto moÅ¾nosti docielite univerzÃ¡lne meranie.",
            XRiteModelRM400: "Nie sÃº potrebnÃ© Å¾iadne ovlÃ¡daÄe.",
            datacolorDiagnosticTile: "Datacolor pouÅ¾Ã­va diagnostickÃº doÅ¡tiÄku.",
            datacolorSilent: "Datacolor silent",
            measureModes: "NastaviÅ¥ podporovanÃ½ rozsah odlesku.",
            model: "Model",
            simulationPath: "Cesta k simulaÄnÃ©mu sÃºboru. BeÅ¾nÃ© nastavenie prednastavenÃ©.",
            spectroType: "OficiÃ¡lny ovlÃ¡daÄ spektra musÃ­ byÅ¥ nainÅ¡talovanÃ½. Iba pre Windows.",
            spectroTypeCom:
                "OficiÃ¡lny ovlÃ¡daÄ spektra musÃ­ byÅ¥ nainÅ¡talovanÃ½. Dbajte na pouÅ¾itie sprÃ¡vneho COM portu. Pre Windows ako aj Linux.",
            spectroTypeDataColorReader:
                "PoÄÃ­taÄ musÃ­ maÅ¥ pripojenie Bluetooth. Spektro musÃ­ byÅ¥ spÃ¡rovanÃ© s poÄÃ­taÄom. VyÅ¾aduje sa Windows 10 s jesennou aktualizÃ¡ciou z roku 2018.",
            spectroTypeMinolta2XXXd:
                "OficiÃ¡lny ovlÃ¡daÄ spektra musÃ­ byÅ¥ nainÅ¡talovanÃ½. Dbajte na pouÅ¾itie sprÃ¡vneho COM portu. Pre Windows ako aj Linux.",
            spectroTypeNotSelected: "Vyberte typ VÃ¡Å¡ho spektrometra.",
            spectroTypeRM400: "Nie sÃº potrebnÃ© Å¾iadne ovlÃ¡daÄe.",
            spectroTypeSimulation:
                "Na zÃ­skanie simulaÄnÃ½ch vÃ½sledkov sÃº potrebnÃ© hodnoty LAB. Pre Windows ako aj Linux.",
            spectroTypeXRite: "Iba pre Windows."
        },
        ufiCode: {
            baseUfiCodeValidation: " NeÅ¾ sa umoÅ¾nÃ­ tÃ³novanie, musÃ­ sa validovaÅ¥ ÄiarovÃ½ kÃ³d UFI kÃ³du bÃ¡ze.",
            enableUfiCodes:
                "UFI kÃ³dy sÃº pouÅ¾Ã­vanÃ© v EÃ a poskytujÃº informÃ¡ciu o tom, akÃ½ je produkt nebezpeÄnÃ½ vzhÄ¾adom na Å¾ivotnÃ© prostredie.",
            invalidUfi: "Invalid UFI code",
            printUfiCode:
                "Ak niektorÃ½ kolorant v receptÃºre prekroÄÃ­ stanovenÃ½ limit, UFI kÃ³d sa vytlaÄÃ­ na tlaÄovÃ½ Å¡tÃ­tok.",
            printUfiCodePercentage:
                "Ak niektorÃ½ kolorant v receptÃºre prekroÄÃ­ stanovenÃ½ limit, UFI kÃ³d sa vytlaÄÃ­ na tlaÄovÃ½ Å¡tÃ­tok aj so svojim percentuÃ¡lnym zastÃºpenÃ­m.",
            ufiCodesByPercentage:
                "Na tlaÄ sa pouÅ¾ije ten UFI kÃ³d, ktorÃ©ho mnoÅ¾stvo v zÃ¡sobnÃ­ku aktuÃ¡lne prevlÃ¡da. V Nastaveniach kanistrov mÃ´Å¾ete definovaÅ¥ limit pre kaÅ¾dÃ½ kanister.",
            ufiCodesFromDatabase:
                "Na tlaÄ sa pouÅ¾ije ten UFI kÃ³d, ktorÃ½ do main databÃ¡ze vloÅ¾il administrÃ¡tor databÃ¡ze.",
            ufiCodesFromLastFilling:
                "Na tlaÄ sa pouÅ¾ije ten UFI kÃ³d, ktorÃ½ obsluha stroja stanovila pri poslednom plnenÃ­ bez ohÄ¾adu na doplnenÃ© mnoÅ¾stvo."
        },
        userManagement: {
            add: "Nastavenie pridÃ¡ novÃ©ho pouÅ¾Ã­vateÄ¾a, ktorÃ½ sa mÃ´Å¾e prihlÃ¡siÅ¥ do softvÃ©ru. PouÅ¾Ã­vateÄ¾ mÃ´Å¾e maÅ¥ priradenÃ½ ÄiarovÃ½ kÃ³d a mÃ´Å¾e sa automaticky prihlÃ¡siÅ¥ pri spustenÃ­ softvÃ©ru.",
            assignedGroups:
                "Toto definuje, do ktorej pouÅ¾Ã­vateÄ¾skej skupiny pouÅ¾Ã­vateÄ¾ patrÃ­. RÃ´zne pouÅ¾Ã­vateÄ¾skÃ© skupiny disponujÃº rÃ´znymi oprÃ¡vneniami.",
            availableGroups:
                "Toto definuje, akÃ© pouÅ¾Ã­vateÄ¾skÃ© skupiny sÃº pre pouÅ¾Ã­vateÄ¾a dostupnÃ©. RÃ´Å¾ne pouÅ¾Ã­vateÄ¾skÃ© skupiny disponujÃº rÃ´znymi oprÃ¡vneniami.",
            loggedUserDelete: "Nie je moÅ¾nÃ© vymazaÅ¥ momentÃ¡lne prihlÃ¡senÃ©ho pouÅ¾Ã­vateÄ¾a."
        },
        visit: "Alebo navÅ¡tÃ­vte",
        visitNoLicense: "Pre viac informÃ¡ciÃ­, navÅ¡tÃ­vte prosÃ­m"
    },
    helpSettings: {
        customHelpLink: "Odkaz na vlastnÃ© centrum pomoci",
        helpSettings: "Podpora",
        message: "SprÃ¡va"
    },
    helper: {
        automaticallyCheckForUpdates: "Automaticky vyhÄ¾adÃ¡vaÅ¥ aktualizÃ¡cie",
        automaticallyDownloadUpdates: "Automaticky stiahnuÅ¥ aktualizÃ¡cie",
        automaticallyInstallNewDatabases: "Automaticky inÅ¡talovaÅ¥ novÃ© databÃ¡zy",
        automaticallyInstallUpdates: "Automaticky inÅ¡talovaÅ¥ aktualizÃ¡cie",
        bugReport: "HlÃ¡senie o chybe",
        canBrowseChangeLog: "Show online %{name} changelog.",
        collect: "PrevziaÅ¥",
        collectLogFiles: "PrevziaÅ¥ logovacie sÃºbory",
        component: "Komponent",
        content: "Obsah",
        contentSize: "VeÄ¾kosÅ¥ obsahu",
        download: "StiahnuÅ¥",
        downloadLogFiles: "StiahnuÅ¥ logovacie sÃºbory",
        downloadingData: "SÅ¥ahovanie dÃ¡t",
        everyHours: "KaÅ¾dÃ½ch %{interval} hodÃ­n",
        forceInstall: "Force to update",
        installDuringNight: "PoÄas noci (%{start} - %{end}) v intervale kaÅ¾dÃ½ch %{interval} hodÃ­n",
        newVersion: "NovÃ¡ verzia",
        notConnected: "Helper nie je pripojenÃ½",
        openBugReport: "OtvoriÅ¥ okno s hlÃ¡senÃ­m o chybe",
        packageSize: "VeÄ¾kosÅ¥ plechovky",
        pleaseWait: "ProsÃ­m poÄkajte, mÃ´Å¾e to chvÃ­Ä¾ku trvaÅ¥.",
        send: "PoslaÅ¥",
        sendBugReportToCustomerService: "PoslaÅ¥ hlÃ¡senie o chybe zÃ¡kaznÃ­ckemu servisu",
        sendingReport: "Posielam",
        subject: "Predmet"
    },
    helperDialog: {
        1: "MÃ´Å¾ete vyhÄ¾adÃ¡vaÅ¥ aktualizÃ¡cie softvÃ©ru alebo databÃ¡zy.",
        2: "PokraÄovaÅ¥ v sÅ¥ahovanÃ­ aktualizaÄnÃ½ch balÃ­Äkov?",
        3: "PokraÄovaÅ¥ v inÅ¡talÃ¡ciÃ­ stiahnutÃ½ch aktualizaÄnÃ½ch balÃ­Äkov?",
        10: "VyhÄ¾adÃ¡vanie aktualizÃ¡ciÃ­ softvÃ©ru a databÃ¡z, prosÃ­m Äakajte...",
        11: "K dispozÃ­ciÃ­ je aktualizÃ¡cia pre VÃ¡Å¡ poÄÃ­taÄ. Chcete ju stiahnuÅ¥?",
        12: "Pre VÃ¡Å¡ poÄÃ­taÄ nie sÃº momentÃ¡lne k dispozÃ­ciÃ­ Å¾iadne aktualizÃ¡cie",
        14: "PoÄas vyhÄ¾adÃ¡vania aktualizÃ¡ciÃ­ sa objavila chyba %{0}",
        15: "SynchronizÃ¡cia zÃ³n databÃ¡zÃ­, prosÃ­m poÄkajte...",
        20: "SÅ¥ahovanie aktualizaÄnÃ½ch balÃ­Äkov, prosÃ­m poÄkajte...",
        21: "Overovanie stiahnutÃ©ho aktualizaÄnÃ©ho balÃ­Äka, prosÃ­m poÄkajte...",
        22: "SÅ¥ahovanie aktualizaÄnÃ©ho balÃ­Äka zlyhalo, chcete to skÃºsiÅ¥ znova?",
        23: "SÅ¥ahovanie aktualizaÄnÃ©ho balÃ­Äka zlyhalo (sÃºbor je poÅ¡kodenÃ½), chcete to skÃºsiÅ¥ znova?",
        24: "PokraÄovaÅ¥ inÅ¡talÃ¡ciou aktualizÃ¡cie?",
        25: "InÅ¡talÃ¡cia automatickÃ½ch aktualizÃ¡ciÃ­ zaÄne o %{0}",
        26: "K dispozÃ­ciÃ­ je aktualizÃ¡cia pre VÃ¡Å¡ poÄÃ­taÄ. Chcete ju stiahnuÅ¥?",
        27: "PokraÄovaÅ¥ inÅ¡talÃ¡ciou aktualizÃ¡cie?",
        40: "Zastavovanie aplikÃ¡ciÃ­ a sluÅ¾ieb, prosÃ­m poÄkajte...",
        41: "KopÃ­rovanie novÃ½ch sÃºborov, prosÃ­m poÄkajte...",
        42: "SpÃºÅ¡Å¥anie aplikÃ¡ciÃ­ a sluÅ¾ieb, prosÃ­m poÄkajte...",
        43: "DokonÄovanie aktualizÃ¡cie softvÃ©ru, prosÃ­m poÄkajte...",
        44: "VÃ¡Å¡ softvÃ©r bol ÃºspeÅ¡ne aktualizovanÃ½.",
        45: "Chcete skÃºsiÅ¥ inÅ¡talÃ¡ciu znova? V prÃ­pade, Å¾e Ã¡no, prosÃ­m uistite sa, Å¾e sa sa momentÃ¡lne nepouÅ¾Ã­vajÃº Å¾iadne softvÃ©rovÃ© komponenty.",
        46: "Pre prejavenie zmien je nutnÃ© reÅ¡tartovanie poÄÃ­taÄa, reÅ¡tart o %{0}",
        999: "Objavila sa vnÃºtornÃ¡ chyba: %{0}",
        automaticInstallation: "InÅ¡talÃ¡cia automatickÃ½ch aktualizÃ¡ciÃ­",
        btnAbort: "PreruÅ¡iÅ¥",
        btnCancel: "ZruÅ¡iÅ¥",
        btnCheckUpdate: "VyhÄ¾adaÅ¥ aktualizÃ¡cie",
        btnContinue: "PokraÄovaÅ¥",
        btnDownloadUpdate: "StiahnuÅ¥ aktualizÃ¡cie",
        btnInstallUpdate: "InÅ¡talovaÅ¥ aktualizÃ¡cie",
        btnOk: "OK",
        btnRetry: "Znova",
        btnSkip: "PreskoÄiÅ¥",
        checkingForUpdates: "VyhÄ¾adÃ¡vanie aktualizÃ¡ciÃ­",
        downloadingFailed: "SÅ¥ahovanie zlyhalo",
        downloadingPackage: "SÅ¥ahovanie aktualizaÄnÃ©ho balÃ­Äka, prosÃ­m poÄkajte...",
        finishingUpdate: "DokonÄovanie aktualizÃ¡cie",
        installingUpdate: "InÅ¡talovanie aktualizÃ¡ciÃ­",
        internalError: "VnÃºtornÃ¡ chyba",
        rebootRequired: "VyÅ¾aduje sa reÅ¡tart",
        startingComponents: "SpÃºÅ¡Å¥anie softvÃ©rovÃ½ch komponent",
        stoppingComponents: "Zastavovanie softvÃ©rovÃ½ch komponent",
        synchronizingDatabases: "Synchronizovanie zÃ³n databÃ¡z",
        updateAvailable: "DostupnÃ© aktualizÃ¡cie, zvoÄ¾te komponenty na aktualizovanie",
        updateDownloaded: "AktualizÃ¡cia bola stiahnutÃ¡",
        updateFailed: "AktualizÃ¡cia zlyhala",
        updateInstalled: "AktualizÃ¡cia bola nainÅ¡talovanÃ¡",
        verificationFailed: "Overenie aktualizaÄnÃ©ho balÃ­Äka zlyhalo",
        verifyingPackage: "Overovanie stiahnutÃ©ho aktualizaÄnÃ©ho balÃ­Äka",
        yourSoftwareIsUpToDate: "VÃ¡Å¡ softvÃ©r je aktuÃ¡lny",
        yourSoftwareVersion: "Verzia VÃ¡Å¡ho softvÃ©ru: %{0}"
    },
    importData: {
        abortImportingData: "ZruÅ¡iÅ¥ import",
        aborted: "Import bol zruÅ¡enÃ½.",
        backupLocalDB: "Backup local database",
        confirmRestore: "Naozaj chcete obnoviÅ¥ vÅ¡etky lokÃ¡lne nastavenia?",
        dataMissing: "Import sa nezdaril, pretoÅ¾e sÃºbor neobsahoval Å¾iadne Ãºdaje.",
        deleteImportedData: "VymazaÅ¥ importovanÃ© dÃ¡ta",
        encodingFile: "KÃ³dovanie sÃºboru",
        exportLocalSettings: "Export lokÃ¡lnych nastavenÃ­",
        exportStaticSql: "Export sÃºboru static SQL",
        fileDamaged: "Import sa nezdaril, pretoÅ¾e sÃºbor sa zdÃ¡ byÅ¥ poÅ¡kodenÃ½.",
        fileMissing: "Import sa nezdaril, pretoÅ¾e sÃºbor neexistuje.",
        format: "FormÃ¡t",
        formatPath: "Cesta formÃ¡tu",
        headerMissing: "Import sa nezdaril, pretoÅ¾e sÃºbor neobsahuje nÃ¡zvy stÄºpcov.",
        import: "Import",
        importAborted: "Import zruÅ¡enÃ½",
        importAborting: "Import sa ruÅ¡Ã­",
        importFailed: "Import sa nezdaril kvÃ´li neoÄakÃ¡vanej chybe.",
        importLocalSettings: "Import lokÃ¡lnych nastavenÃ­",
        importPrices: "ImportovaÅ¥ ceny",
        imported: "ÃspeÅ¡ne importovanÃ©",
        importedWithErrors: "Importing has finished with errors. Error lines have been skipped.",
        importing: "Importuje sa",
        noFormatAvailable: "Nie je dostupnÃ½ Å¾iadny formÃ¡t",
        processing: "SpracovÃ¡va sa",
        processingCustomFormulas: "SpracovÃ¡vanie vlastnÃ½ch receptÃºr",
        processingCustomers: "SpracovÃ¡vanie zÃ¡kaznÃ­kov",
        productsFile: "SÃºbor produktov",
        restoreLocalSettings: "Obnova lokÃ¡lnych nastavenÃ­",
        underProgress: "Import prebieha.",
        unknownFormat: "Import sa nezdaril, pretoÅ¾e sÃºbor je v nepodporovanom formÃ¡te.",
        userFormulasFile: "SÃºbor pouÅ¾Ã­vateÄ¾skÃ½ch vzorkovnÃ­c"
    },
    infoType: {
        baseDensity: "Hustota bÃ¡zy",
        baseMass: "HmotnosÅ¥ bÃ¡zy",
        baseUfiCode: "UFI kÃ³d bÃ¡Å¾e",
        baseVolume: "Objem bÃ¡zy",
        batchNumbersTable: "Batch numbers table",
        bfsGrade: "Hodnota BFS",
        colorLab: "Lab odtieÅa",
        colorRgb: "RGB odtieÅa",
        colorRgbHex: "RGB Hex odtieÅa",
        colorXyz: "Xyz odtieÅa",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantMass: "HmotnosÅ¥ kolorantu",
        colorantUfiCodes: "UFI kÃ³dy kolorantov",
        colorantVolume: "Objem kolorantu",
        formulaDate: "DÃ¡tum receptÃºry",
        formulaDatetime: "Formula datetime",
        formulaMoreInfo: "Viac info o receptÃºre",
        formulaMoreInfoInternal: "Viac internÃ©ho info o receptÃºre",
        formulaMoreInfoPrint: "Viac info o receptÃºre pre tlaÄ",
        hbw: "Hodnota HBW",
        isPackageGravimetric: "Balenie je gravimetrickÃ©",
        maxColorantMass: "MaximÃ¡lna povolenÃ¡ hmotnosÅ¥ kolorantu",
        maxColorantVolume: "MaximÃ¡lny povolenÃ½ objem kolorantu",
        nominalMass: "NominÃ¡lna hmotnosÅ¥ balenia",
        nominalVolume: "NominÃ¡lny objem balenia",
        overfillDetected: "RozpoznanÃ© preplnenie",
        totalPaintDensity: "Total paint density",
        totalPaintMass: "CelkovÃ¡ hmotnosÅ¥ farby",
        totalPaintVolume: "CelkovÃ½ objem farby",
        ufiCodesTable: "TabuÄ¾ka UFI kÃ³dov",
        verifiedFormula: "OverenÃ¡ receptÃºra",
        yValue: "Hodnota Y"
    },
    initialTab: {
        favoriteFormulas: "ObÄ¾ÃºbenÃ© receptÃºry",
        lastDispensedFormulas: "PoslednÃ© tÃ³novanÃ© receptÃºry",
        searchNewFormula: "HÄ¾adaÅ¥ novÃº receptÃºru"
    },
    invalidBatchNumbersModal: {
        header: "Check colorants Batch number",
        info: "At least one canister is filled with (possibly) defective batch of colorant. Please do not use this batch. Empty the canister using Quick tint.",
        unknownStatus: "Unknown Batch status"
    },
    keyWords: {
        action: "akcia",
        add: "pridaÅ¥",
        addition: "doplnenie",
        additional: "doplÅujÃºci",
        address: "adresa",
        admin: "admin",
        advanced: "pokroÄilÃ©",
        after: "po",
        afterDispensing: "po tÃ³novanÃ­",
        alfa: "Alfa",
        all: "vÅ¡etko",
        allow: "povoliÅ¥",
        alphabetically: "abecedne",
        amount: "mnoÅ¾stvo",
        api: "api",
        ask: "spÃ½taÅ¥ sa",
        autocap: "vieÄko",
        autotask: "automatickÃ½ Ãºkon",
        availablePrice: "prÃ­stupnÃ¡ cena",
        backup: "zÃ¡loha",
        banner: "banner",
        barcode: "ÄiarovÃ½ kÃ³d",
        barcodes: "ÄiarovÃ© kÃ³dy",
        base: "bÃ¡za",
        before: "pred",
        begin: "zaÄaÅ¥",
        bfs: "bfs",
        bottom: "spodok",
        brand: "znaÄka",
        brush: "Å¡tetec",
        bug: "chyba",
        button: "tlaÄidlo",
        buy: "kÃºpna",
        cC3: "CC3",
        cM: "CM",
        calibration: "kalibrÃ¡cia",
        can: "plechovka",
        canHandling: "prÃ¡ca s plechovkou",
        canister: "kanister",
        canisterFilling: "doplnenie kanistra",
        canisterLevels: "hladiny kanistrov",
        canisters: "Kanistre",
        cap: "vieÄko",
        center: "centrum",
        centre: "centrum",
        change: "zmeniÅ¥",
        changelog: "changelog",
        channels: "kanÃ¡ly",
        check: "kontrola",
        chunk: "ÄasÅ¥",
        chunks: "Äasti",
        city: "mesto",
        clean: "ÄistiÅ¥",
        cleaning: "Äistenie",
        clientIdentifier: "identifikÃ¡tor klienta",
        close: "zatvoriÅ¥",
        closest: "najbliÅ¾Å¡Ã­",
        code: "kÃ³d",
        collect: "prevziaÅ¥",
        color: "farba",
        colorLink3: "ColorLink3",
        colorPanel: "farebnÃ¡ paleta",
        colorReader: "ColorReader",
        colorant: "kolorant",
        colorantConsumption: "spotreba kolorantov",
        colorantPrice: "cena kolorantu",
        colorants: "koloranty",
        colorix: "Colorix",
        colour: "odtieÅ",
        communication: "komunikÃ¡cia",
        compare: "porovnaÅ¥",
        competitive: "konkurenÄnÃ©",
        computer: "poÄÃ­taÄ",
        config: "konfigurÃ¡cia",
        configuration: "nastavenie",
        confirm: "potvrdiÅ¥",
        confirmation: "potvrdenie",
        connection: "spojenie",
        contactPerson: "kontaktnÃ¡ osoba",
        control: "kontrola",
        copies: "kÃ³pie",
        corob: "Corob",
        cost: "nÃ¡kupnÃ½",
        country: "Å¡tÃ¡t",
        create: "vytvoriÅ¥",
        currency: "mena",
        current: "sÃºÄasnÃ½",
        custom: "vlastnÃ©",
        customers: "zÃ¡kaznÃ­ci",
        daily: "denne",
        dark: "Dark",
        data: "Ãºdaje",
        database: "databÃ¡za",
        datacolor: "Datacolor",
        date: "dÃ¡tum",
        decimals: "desatinnÃ© ÄÃ­sla",
        default: "pÃ´vodnÃ© nastavenie",
        delay: "zdrÅ¾anie",
        delete: "vymazaÅ¥",
        deletion: "zmazanie",
        deltaE: "delta e",
        device: "zariadenie",
        devices: "zariadenia",
        diagnosticTile: "diagnostickÃ¡ doÅ¡tiÄka",
        dialog: "dialÃ³g",
        direct: "priame",
        disconnect: "odpojiÅ¥",
        discount: "zÄ¾ava",
        dispense: "tÃ³novaÅ¥",
        dispenser: "tÃ³novacÃ­ stroj",
        dispensing: "tÃ³novanie",
        down: "dole",
        download: "stiahnuÅ¥",
        driver: "ovlÃ¡daÄ",
        dromont: "Dromont",
        dspProxy: "DspProxy",
        edit: "upraviÅ¥",
        editor: "editor",
        email: "email",
        error: "porucha",
        evoDriver: "EvoDriver",
        evoService: "EvoService",
        excel: "excel",
        expiration: "vyprÅ¡anie",
        export: "export",
        eyeOne: "Eye-One",
        fF: "F&F",
        fandeck: "vzorkovnica",
        fastFluid: "Fast & Fluid",
        file: "sÃºbor",
        fill: "doplniÅ¥",
        fillToMax: "doplniÅ¥ do maxima",
        find: "nÃ¡jsÅ¥",
        first: "first",
        flex: "Flex",
        folder: "zloÅ¾ka",
        formula: "ReceptÃºra",
        formulas: "ReceptÃºry",
        from: "z",
        fts5: "fts5",
        fullScreen: "celÃ¡ obrazovka",
        fullText: "celÃ½ text",
        fulltext: "plnotextovÃ©",
        g: "g",
        genericPricing: "vÅ¡eobecnÃ© ceny",
        hLD: "HLD",
        hard: "hard",
        hbw: "hbw",
        help: "nÃ¡poveda",
        helpCenter: "pomocnÃ© centrum",
        hero: "Hero",
        history: "histÃ³ria",
        home: "domov",
        host: "host",
        humidifier: "zvlhÄovaÄ",
        iDD: "IDD",
        identification: "identifikÃ¡cia",
        image: "obrÃ¡zok",
        impGallon: "imp. gallon",
        impQuart: "imp. quart",
        import: "import",
        individually: "jednotlivo",
        info: "info",
        information: "informÃ¡cia",
        initial: "prvotnÃ©",
        initialization: "inicializÃ¡cia",
        initialize: "inicializovaÅ¥",
        insert: "vloÅ¾iÅ¥",
        install: "inÅ¡talovaÅ¥",
        intellyPurge: "inteligentnÃ½ odstrek",
        invalid: "nesprÃ¡vne",
        ipAddress: "ip adresa",
        italtinto: "Italtinto",
        items: "poloÅ¾ky",
        keyboard: "klÃ¡vesnica",
        kg: "kg",
        kiosk: "kiosk",
        kioskMode: "kioskovÃ½ mÃ³d",
        l: "l",
        lLD: "LLD",
        lab: "lab",
        label: "Å¡tÃ­tok",
        labels: "Å¡tÃ­tky",
        language: "jazyk",
        largo: "largo",
        last: "poslednÃ©",
        lenteq: "Lenteq",
        levels: "Ãºrovne",
        license: "licencia",
        light: "Light",
        limit: "limit",
        link: "link",
        linux: "Linux",
        load: "naÄÃ­taÅ¥",
        lock: "uzamknÃºÅ¥",
        logFiles: "log sÃºbory",
        logic: "logika",
        logo: "logo",
        lower: "niÅ¾Å¡ie",
        machine: "stroj",
        machineConfiguration: "nastavenie stroja",
        machineManagement: "sprÃ¡va stroja",
        machineName: "nÃ¡zov stroja",
        main: "main",
        maintenance: "ÃºdrÅ¾ba",
        manual: "ruÄnÃ½",
        manualAddition: "ruÄnÃ© doplnenie",
        manualDispensing: "ruÄnÃ© tÃ³novanie",
        manualScan: "ruÄnÃ½ sken",
        margins: "marÅ¾e",
        markups: "obchodnÃ© prirÃ¡Å¾ky",
        mass: "hmotnosÅ¥",
        match: "zhoda",
        measure: "meraÅ¥",
        measurement: "meranie",
        measurementUnits: "mernÃ© jednotky",
        melody: "melÃ³dia",
        message: "sprÃ¡va",
        minimal: "minimÃ¡lne",
        minolta: "Minolta",
        minus: "mÃ­nus",
        minutes: "minÃºty",
        misura: "Misura",
        ml: "ml",
        mode: "mÃ³d",
        model: "model",
        modification: "modifikÃ¡cia",
        modify: "modifikovaÅ¥",
        monthly: "mesaÄne",
        moreInfo: "viac info",
        movableTable: "hybnÃ½ stÃ´l",
        move: "pohnÃºÅ¥",
        music: "hudba",
        myOrders: "moje objednÃ¡vky",
        name: "nÃ¡zov",
        naming: "pomenovanie",
        nano: "Nano",
        navigation: "navigÃ¡cia",
        new: "novÃ©",
        nextDriver: "NextDriver",
        night: "noc",
        nixPro: "Nix Pro",
        notes: "poznÃ¡mky",
        notification: "upozornenie",
        number: "ÄÃ­slo",
        off: "vypnutÃ©",
        open: "otvoriÅ¥",
        order: "objednaÅ¥",
        ordering: "objednÃ¡vka",
        overfill: "preplnenie",
        overview: "prehÄ¾ad",
        overwrite: "prepÃ­saÅ¥",
        own: "vlastnÃ©",
        pCPDriver: "PCPDriver",
        package: "balenie",
        packagePrice: "cena balenia",
        packages: "balenia",
        panels: "panely",
        parameter: "parameter",
        path: "cesta",
        pc: "pc",
        phone: "telefÃ³n",
        phoneNumber: "telefÃ³nne ÄÃ­slo",
        picture: "fotka",
        place: "plmiestoace",
        placement: "umiestnenie",
        plug: "plug",
        plugger: "plugger",
        plugging: "plugging",
        plugin: "plugin",
        plus: "plus",
        pointOfSale: "predajnÃ© miesto",
        popUp: "vyskakovacie okno",
        pos: "predajÅa",
        present: "momentÃ¡lne",
        preview: "prehÄ¾ad",
        price: "cena",
        priceExport: "export cien",
        priceGroup: "cenovÃ¡ skupina",
        priceImport: "import cien",
        prices: "ceny",
        pricing: "naceÅovanie",
        primaryCurrency: "hlavnÃ¡ mena",
        print: "tlaÄiÅ¥",
        printer: "tlaÄiareÅ",
        printing: "tlaÄ",
        problem: "problÃ©m",
        product: "produkt",
        productPrice: "cena produktu",
        profiledValues: "profilovÃ© hodnoty",
        punch: "punch",
        puncher: "puncher",
        punching: "punching",
        purge: "odstrek",
        purgeType: "typ odstreku",
        purgeVolume: "objem odstreku",
        quality: "kvalita",
        quick: "rÃ½chlo",
        quickTint: "rÃ½chle tÃ³novanie",
        rM: "RM",
        raise: "zvÃ½Å¡iÅ¥",
        rcc: "rcc",
        reader: "ÄÃ­taÄka",
        reboot: "reboot",
        receive: "prijaÅ¥",
        recirculate: "recirkulovaÅ¥",
        recirculation: "recirkulÃ¡cia",
        redlike: "Redlike",
        refill: "doplnenie",
        registration: "registrÃ¡cia",
        regular: "beÅ¾nÃ©",
        removal: "odstrÃ¡nenie",
        remove: "odstrÃ¡niÅ¥",
        report: "hlÃ¡senie",
        reset: "reset",
        resolution: "rozlÃ­Å¡enie",
        restart: "reÅ¡tart",
        rgb: "rgb",
        rights: "prÃ¡va",
        rounding: "zaokrÃºhÄ¾ovanie",
        rules: "pravidlÃ¡",
        sanTint: "SanTint",
        save: "uloÅ¾iÅ¥",
        scale: "Å¡kÃ¡lovaÅ¥",
        scan: "sken",
        scope: "rozsah",
        screen: "obrazovka",
        screensaver: "Å¡etriÄ obrazovky",
        search: "hÄ¾adaÅ¥",
        secondaryCurrency: "sekundÃ¡rna mena",
        select: "zvoliÅ¥",
        selectedFormula: "Selected formula",
        sell: "predajnÃ¡",
        sensor: "senzor",
        serialNumber: "sÃ©riovÃ© ÄÃ­slo",
        server: "server",
        servers: "servery",
        service: "sluÅ¾ba",
        serviceAction: "servisnÃ½ Ãºkon",
        serviceActions: "servisnÃ© Ãºkony",
        serviceSoftware: "servisnÃ½ softvÃ©r",
        serviceWindow: "servisnÃ© okno",
        settings: "nastavenia",
        shelf: "poliÄka",
        shortcuts: "skratky",
        shot: "shot",
        show: "ukÃ¡zaÅ¥",
        shutDown: "vypnÃºÅ¥",
        shutdown: "vypnutie",
        silent: "Silent",
        simple: "jednoduchÃ©",
        simulation: "simulÃ¡cia",
        size: "veÄ¾kosÅ¥",
        skip: "preskoÄiÅ¥",
        smartPurge: "mÃºdry odstrek",
        software: "softvÃ©r",
        softwareSupplier: "dodÃ¡vateÄ¾ softvÃ©ru",
        sort: "poradie",
        sound: "zvuk",
        spectro: "spektro",
        spectrophotometer: "spektrofotometer",
        speed: "rÃ½chlosÅ¥",
        split: "rozdeliÅ¥",
        start: "zaÄatie",
        startup: "startup",
        statistics: "Å¡tatistiky",
        status: "stav",
        stir: "mieÅ¡aÅ¥",
        stirring: "mieÅ¡anie",
        street: "ulica",
        support: "podpora",
        surcharge: "prÃ­platok",
        tab: "karta",
        tabs: "karty",
        task: "Ãºloha",
        template: "Å¡ablÃ³na",
        testing: "testovanie",
        time: "Äas",
        tintingManagementCenter: "tinting management center",
        to: "do",
        toDispense: "na tÃ³novanie",
        tolerance: "tolerancia",
        top: "vrch",
        total: "celkom",
        translation: "preklad",
        turnOff: "vypnÃºÅ¥",
        turntable: "otoÄnÃ½ stÃ´l",
        type: "typ",
        uIDD: "UIDD",
        uSGallon: "U.S gallon",
        uSQuart: "U.S quart",
        unit: "jednotka",
        up: "hore",
        update: "aktualizÃ¡cia",
        url: "url",
        user: "pouÅ¾Ã­vateÄ¾",
        userGroups: "pouÅ¾Ã­vateÄ¾skÃ© skupiny",
        v1: "v1",
        v2: "v2",
        v3: "v3",
        vAT: "DPH",
        validate: "validovaÅ¥",
        validation: "validÃ¡cia",
        version: "verzia",
        virtual: "virtuÃ¡lna",
        volume: "objem",
        weekly: "tÃ½Å¾denne",
        window: "okno",
        windows: "Windows",
        with: "s",
        without: "bez",
        xRite: "X-Rite",
        xrite: "Xrite",
        yValue: "hodnota y",
        zipCode: "poÅ¡tovÃ© smerovÃ© ÄÃ­slo",
        zoom: "priblÃ­Å¾enie"
    },
    languages: {
        bg: "Ð±ÑÌÐ»Ð³Ð°ÑÑÐºÐ¸",
        cs: "ÄeÅ¡tina",
        da: "Danish",
        de: "Deutsch",
        el: "ÎÎ»Î»Î·Î½Î¹ÎºÎ¬",
        en: "English",
        es: "EspaÃ±ol",
        fr: "FranÃ§ais",
        hr: "Hrvatski",
        hu: "Magyar",
        id: "Bahasa Indonesia",
        is: "Ãsland",
        it: "Italiano",
        lt: "Lithuanian",
        lv: "Latvian",
        ms: "Melayu",
        nl: "Nederland",
        no: "Norway",
        pl: "Polski",
        pt: "PortuguÃªs",
        ro: "Romana",
        ru: "Ð ÑÑÑÐºÐ¸Ð¹",
        sk: "SlovenÄina",
        sr: "Srpski",
        sv: "Sverige",
        zh: "Chinese"
    },
    license: {
        activateLicense: "AktivovaÅ¥ licenciu",
        activateNewLicense: "AktivovaÅ¥ novÃº licenciu",
        checkLicenseKey: "SkontrolovaÅ¥ licenÄnÃ½ kÄ¾ÃºÄ",
        companyId: "ID spoloÄnosti",
        contactPerson: "KontaktnÃ¡ osoba",
        copy: "KopÃ­rovaÅ¥",
        country: "Krajina",
        emptyCity: "Mesto je povinnÃ¡ informÃ¡cia",
        emptyCountry: "Å tÃ¡t je povinnÃ¡ informÃ¡cia",
        emptyName: "NÃ¡zov predajne je povinnÃ¡ informÃ¡cia",
        enterIdentificationKeys: "Zadajte identifikaÄnÃ© kÄ¾ÃºÄe",
        expirationDate: "DÃ¡tum expirÃ¡cie: %{dateTime}",
        fillRegistration: "Zadajte registraÄnÃ© Ãºdaje",
        insertLicense: "Pre offline aktivÃ¡ciu zadajte vygenerovanÃ½ kÄ¾ÃºÄ",
        invalidEmail: "Email nie je platnÃ½",
        invalidPhone: "TelefÃ³nne ÄÃ­slo nie je platnÃ©",
        itemsMarkedasterisk: "(poloÅ¾ky oznaÄenÃ© hviezdiÄkou musia byÅ¥ vyplnenÃ©)",
        lastUpdate: "Last change %{dateTime}",
        leasedLicense: "PrenajatÃ¡ licencia",
        licenseActivated: "Licencia uÅ¾ bola aktivovanÃ¡",
        licenseStatus: "Stav licencie",
        licenseWillExpire: "VaÅ¡a licencia vyprÅ¡Ã­ o %{dayCount} dnÃ­",
        licenseWillExpireOneDay: "VaÅ¡a licencia vyprÅ¡Ã­ o %{dayCount} deÅ",
        machineInformation: "InformÃ¡cie o stroji",
        noLicenseAvailable: "Nie je k dispozÃ­cii Å¾iadna licencia",
        noProductsForKey: "Pre zadanÃ© identifikaÄnÃ© Ãºdaje nie sÃº k dispozÃ­cii Å¾iadne produkty.",
        pointOfSale: "PredajÅa",
        producer: "VÃ½robca",
        reactivate: "ReaktivovaÅ¥",
        reactivateLicense: "Reactivate license",
        region: "RegiÃ³n",
        registerLicense: "SkopÃ­rujte si, prosÃ­m, aktivaÄnÃº poÅ¾iadavku a presuÅte sa na nasledujÃºci odkaz:",
        registrationForm: "RegistraÄnÃ½ formulÃ¡r",
        selectProduct: "Vyberte produkt",
        serialNumber: "SÃ©riovÃ© ÄÃ­slo",
        skipNewLicense: "Ak chcete aktivovaÅ¥ novÃº licenciu neskÃ´r, kliknite na PreskoÄiÅ¥.",
        unlimitedLicense: "NeobmedzenÃ¡ licencia",
        userId: "ID pouÅ¾Ã­vateÄ¾a",
        uuid: "UUID licencie",
        versionDetails: "Detaily verzie",
        versionScope: "Rozsah verzie",
        versionType: "Typ verzie",
        zip: "PSÄ"
    },
    login: {
        authenticate: "Authenticate",
        logIn: "PrihlÃ¡siÅ¥ sa",
        loginAs: "PrihlÃ¡siÅ¥ sa ako inÃ½ pouÅ¾Ã­vateÄ¾",
        messages: {
            incorrectUsername: "PouÅ¾Ã­vateÄ¾skÃ© meno alebo heslo je nesprÃ¡vne."
        },
        password: "Heslo",
        username: "PouÅ¾Ã­vateÄ¾skÃ© meno"
    },
    machineActionHistory: {
        actionHistory: "HistÃ³ria akciÃ­"
    },
    machineErrors: {
        channel: "Okruh",
        code: "KÃ³d",
        machineErrors: "Chyby stroja",
        noMachineErrors: "MomentÃ¡lne nie sÃº na stroji Å¾iadne chyby",
        resetErrors: "Reset chyby"
    },
    machineSettings: {
        action: "Ãkon",
        addAutotask: "PridaÅ¥ automatickÃ½ Ãºkon",
        autoCanisterIn: "Automaticky vloÅ¾iÅ¥ kanister",
        autoCanisterOut: "Automaticky vyÅaÅ¥ kanister",
        automaticRefill: "AutomatickÃ© plnenie",
        autotaskSettings: "Nastavenie automatickÃ½ch Ãºkonov",
        backupConfiguration: "ZÃ¡loha nastavenÃ­ tÃ³novacieho stroja",
        brushMaintenance: "ÃdrÅ¾ba Å¡tetcov",
        capMaintenance: "ÃdrÅ¾ba vieÄka",
        checkCanisterBeforeDispense: "SkontrolovaÅ¥ kanister pred tÃ³novanÃ­m",
        checkColorantBaseRules: "Check colorant base rules",
        checkMinDosableAmount: "SkontrolovaÅ¥ minimÃ¡lne tÃ³novateÄ¾nÃ© mnoÅ¾stvo kolorantov",
        checkOverfill: "SkontrolovaÅ¥ preplnenie plechovky",
        checkTotalCntAmounts: "SkontrolovaÅ¥ celkovÃ© mnoÅ¾stvo kolorantov v bÃ¡ze",
        cleanAll: "ÄistiÅ¥ vÅ¡etko",
        computerReboot: "ReÅ¡tart poÄÃ­taÄa",
        computerShutdown: "Vypnutie poÄÃ­taÄa",
        connectMachine: "PripojiÅ¥ stroj",
        days: "Dni",
        daysOfMonth: "Dni v mesiaci",
        devices: "Zariadenia",
        disabled: "ZakÃ¡zanÃ©",
        dispenseAndPurge: "TÃ³novanie a odstrek",
        dispenseOnly: "Iba tÃ³novanie",
        dispenserCleaning: "Äistenie tÃ³novacieho stroja",
        dispensingWithErrorsEnabled: "PovoliÅ¥ tÃ³novanie napriek validaÄnÃ½m chybÃ¡m",
        editAutotask: "UpraviÅ¥ automatickÃ½ Ãºkon",
        firstRun: "First run",
        hours: "Hodiny",
        humidifier: "ZvlhÄovaÄ",
        humidifierWaterLevelMaintenance: "ÃdrÅ¾ba Ãºrovne vody zvlhÄovaÄa",
        machineConfigurationNoCanisters: "KonfigurÃ¡cia stroja neobsahuje Å¾iadne kanistre.",
        machineName: "NÃ¡zov stroja",
        machineSettings: "Nastavenie stroja",
        manualPuncher: "RuÄnÃ½ dierovaÄ",
        minDispensedAmount: "MinimÃ¡lne vydanÃ© mnoÅ¾stvo",
        minutes: "MinÃºty",
        nextRun: "NasledujÃºce spustenie",
        noAutotasksSet: "Nie sÃº nastavenÃ© Å¾iadne automatickÃ© Ãºkony.",
        noDataAvailable: "Nie sÃº k dispozÃ­cii Å¾iadne Ãºdaje.",
        noMachine: "Nie je pripojenÃ½ Å¾iaden stroj",
        onStart: "Pri spustenÃ­",
        plugger: "Å puntovaÄ",
        postpone: "OdloÅ¾iÅ¥",
        puncher: "DierovaÄ",
        purgeAll: "Odstreky vÅ¡etkÃ½ch",
        purgeOnly: "Iba odstrek",
        recirculateAll: "RecirkulovaÅ¥ vÅ¡etko",
        recirculateChannels: "RecirkulovaÅ¥ okruhy",
        recirculationSpeed: "RÃ½chlosÅ¥ recirkulÃ¡cie",
        recirculationTime: "Trvanie recirkulÃ¡cie",
        refillAll: "DoplniÅ¥ vÅ¡etky",
        refillCanisters: "DoplniÅ¥ kanistre",
        runAt: "SpustiÅ¥ o",
        runDefinedDaysAt: "V definovanÃ© dni",
        runEvery: "SpustiÅ¥ kaÅ¾dÃ½ch",
        runInDays: "SpustiÅ¥ v tieto dni",
        serialNum: "SÃ©riovÃ© ÄÃ­slo",
        settingsMachine: "Nastavenie stroja",
        smartPurgeAll: "MÃºdry odstrek pre vÅ¡etky",
        smartPurgeChannels: "MÃºdry odstrek pre okruhy",
        smartPurgeRules: "PravidlÃ¡ mÃºdreho odstreku",
        startType: "Typ spustenia",
        stirAll: "PremieÅ¡aÅ¥ vÅ¡etko",
        stirCanisters: "PremieÅ¡aÅ¥ kanistre",
        stirringSpeed: "RÃ½chlosÅ¥ premieÅ¡avania",
        stirringTime: "Trvanie premieÅ¡avania",
        switchPlateMaintenance: "ÃdrÅ¾ba dosky",
        theCurrentlySelectedMachine: "MomentÃ¡lne vybranÃ½ stroj",
        threshold: "Prah",
        turntable: "PohyblivÃ½ stÃ´l",
        unifyColorantBatchForMultipleCans: "Unify colorant batch for multiple cans dispensings",
        volume: "Objem",
        weekdays: "Dni v tÃ½Å¾dni"
    },
    mainTab: {
        acceptedFormula: "SkontrolovanÃ¡ receptÃºra",
        addBuildingSite: "Add building site",
        addToFavorites: "PridaÅ¥ do obÄ¾ÃºbenÃ½ch",
        alternativeFormulas: "Alternative formulas",
        alternativeValidFormulas: "Alternative valid formulas",
        buildingSiteSpecification: "Building site specification",
        colorantsAreInvalid: "Jeden alebo viacero kolorantov je neplatnÃ½ch",
        dispensedPackages: "VytÃ³novanÃ© balenia",
        dispensingInProgress: "TÃ³novÃ¡nie prÃ¡ve prebieha",
        dispensingIsAborted: "TÃ³novanie preruÅ¡enÃ©",
        dispensingIsNotAvailable: "TÃ³novÃ¡nie nie je dostupnÃ©",
        dispensingProgress: "%{done} z %{all}",
        editColorant: "UpraviÅ¥ kolorant",
        editNote: "UpraviÅ¥ poznÃ¡mku",
        findCompetitiveColor: "Try to find the competitive color",
        forceDispensing: "VynÃºtenie tÃ³novania",
        formulaInvalidColorants: "ReceptÃºra obsahuje neplatnÃ© koloranty: %{colorants}",
        formulaOutOfDate: "Formula may be out of date",
        formulaProperties: "Formula properties",
        hiddenFandecks: "SkrytÃ© vzorkovnice",
        hiddenProducts: "SkrytÃ© produkty",
        historicalFormulas: "HistorickÃ© receptÃºry",
        lowerDeltaNumber: "Lower delta number more accurate match",
        machineError: "Chyba na stroji",
        machineIsBusy: "Stroj je zaneprÃ¡zdnenÃ½",
        machineNotConnected: "Stroj nie je pripojenÃ½",
        manualColorantAddition: "RuÄnÃ© pridanie kolorantu",
        modifiedFormula: "ReceptÃºra bola zmenenÃ¡.",
        modifiedFormulaInLab: "Formula modified in laboratory",
        newColorAfterScaling: "NovÃ¡ farba po Å¡kÃ¡lovanÃ­",
        newRgbNotAccuratelyMeasured: "NovÃ© RGB nie je presne zmeranÃ©, je iba orientaÄnÃ©.",
        noBaseAvailable: "Nie je dostupnÃ¡ Å¾iadna bÃ¡za",
        noBuildingSiteAvailable: "No building site info is available",
        noColorantForCorrection: "No additional colorants for correction selected",
        noColorants: "Å½iadne koloranty",
        noCustomer: "Å½iaden zÃ¡kaznÃ­k",
        noCustomers: "Nie je dostupnÃ½ Å¾iaden zÃ¡kaznÃ­k",
        noDispenseNotesAvailable: "Nie sÃº dostupnÃ© Å¾iadne poznÃ¡mky k tÃ³novaniu",
        noFormulaAvailable: "You have selected a combination with no formula!",
        noFormulaSelected: "Nie je zvolenÃ¡ Å¾iadna receptÃºra",
        noInternalNotesAvailable: "Nie sÃº dostupnÃ© Å¾iadne internÃ© poznÃ¡mky",
        noNotesAvailable: "Nie sÃº dostupnÃ© Å¾iadne poznÃ¡mky",
        noPackageAvailable: "No package is available",
        noPackageSelected: "Nie je zvolenÃ© Å¾iadne balenie",
        noProductAvailable: "No product is available",
        noResultsFound: "Neboli nÃ¡jdenÃ© Å¾iadne vÃ½sledky",
        openLocalFile: "OtvoriÅ¥ z lokÃ¡lnej databÃ¡ze",
        openOnlineFile: "OtvoriÅ¥ z internetu",
        order: "ObjednÃ¡vka",
        orderingIsNotAvailable: "Tvorba objednÃ¡vok nie je povolenÃ¡",
        originalColor: "PÃ´vodnÃ¡ farba",
        overAvailableLevel: "Nad dostupnÃº hladinu",
        package: "Balenie",
        packageIsRequired: "VyÅ¾aduje sa balenie",
        packaging: "Balenie",
        partialUpdateReload: "Partial updates may have affected this formula. Reload this tab to see an updated data.",
        printIsNotAvailable: "TlaÄ nie je k dispozÃ­cii",
        productFiles: "ProduktovÃ© sÃºbory",
        productFilesViewer: "PrehliadaÄ produktovÃ½ch sÃºborov",
        productNotAvailable: "Product '%{productName}' is not available.",
        properties: "Properties",
        regularPrice: "BeÅ¾nÃ¡ cena",
        resetFormulaData: "NovÃ¡ receptÃºra",
        rgbOnlyIndicative: "RGB je iba orientaÄnÃ©!",
        saveAsCustom: "UloÅ¾iÅ¥ ako",
        saveToStatsIsNotAvailable: "UloÅ¾enie histÃ³rie nie je dostupnÃ©",
        searchForCheaper: "VyhÄ¾adaÅ¥ lacnejÅ¡ie",
        selectFromCompetitive: "You can select color from the competitive colors.",
        specialPrice: "Å peciÃ¡lna cena",
        specialPriceVip: "Å peciÃ¡lna cena VIP",
        splitFormula: "RozdeliÅ¥ receptÃºru",
        withVAT: "s DPH",
        withoutVAT: "bez DPH"
    },
    marginSettings: {
        allBases: "vÅ¡etky bÃ¡zy",
        allProducts: "vÅ¡etky produkty",
        editMargin: "UpraviÅ¥ marÅ¾u",
        marginAndDiscountWarning: "Na pouÅ¾itie marÅ¾e a zÄ¾avy sa musÃ­ nastaviÅ¥ cenovÃ¡ kalkulÃ¡cia.",
        marginSettings: "Nastavenie marÅ¾e",
        marginsFor: "MarÅ¾a pre",
        markupColorants: "ObchodnÃ¡ pÅirÃ¡Å¾ka na kolorant",
        sizeOfPackage: "VeÄ¾kosÅ¥ balenia",
        valueBase: "Hodnota bÃ¡ze",
        valueColorant: "Hodnota kolorantu"
    },
    matching: {
        actualColor: "Actual color",
        allCorrections: "All corrections",
        allTillItems: "All till the items",
        auto: "Auto",
        autoSelectAll: "Auto all",
        canStartCorrection: "Then you can start correction.",
        canStartMatching: "Then you can start matching.",
        cannotBeUsed: "Matching cannot be used.",
        changeProductAndColorants: "Try change product or colorants",
        checkConfig: "Please check the matching configuration.",
        colorCorrection: "Color correction",
        colorIsIndicative: "Color preview is only indicative.",
        colorNotAccurate: "Color may not be accurately displayed, it always depends on your monitor settings.",
        colorantInDispensedFormula: "Colorants in dispensed formula",
        confirmDispensing: "Confirm dispensing",
        connectionProblem: "Connection problem",
        correctionHistory: "Correction history",
        correctionRunning: "Correction is running",
        draftFormula: "Draft formula",
        exclude: "Exclude",
        excludeAll: "Exclude all",
        include: "Include",
        includeAll: "Include all",
        invalidProduct: "It is not possible to do the matching for product %{productName}",
        itemOnly: "Item only",
        manualColorCorrection: "Manual color correction",
        matchFormula: "Match formula",
        matchingInformation: "Matching information",
        matchingResult: "Matching result",
        matchingRunning: "Matching is running",
        matchingSearchOptions: "Matching search options",
        measurement: "Measurement",
        noCorrection: "No correction found",
        noSpectralCurveProvided:
            "The connected device cannot be used for matching because it doesn't provide spectral curve",
        notAvailableForMatching: "Not available for matching",
        originalFormula: "Original formula",
        reformulate: "Reformulate",
        reformulationRunning: "Reformulation is running",
        resultColor: "Result color",
        saveAsCustomFormula: "Save as custom formula",
        searchInProgress: "Search in progress, please wait",
        selectColorfile: "Please select colorfile.",
        selectRequiredItems: "Please select product, base, colorants and package.",
        selectedResult: "Selected result",
        spectralDataNotAvailable: "Spectral data is not available",
        startCorrection: "Start correction",
        startMatching: "Start matching",
        targetColor: "Target color",
        unsavedDraft: "Unsaved draft",
        unsavedDraftWarning: "Once you are satisfied with formula â do not forget to save your result.",
        usedForMatching: "Used for matching"
    },
    modal: {
        changeColorantUnit: "ZmeniÅ¥ jednotku kolorantov",
        payAttention: "Pozor!"
    },
    module: {
        productGroups: "Product groups"
    },
    navigation: {
        globalSearch: {
            fandeckFilter: "Filter vzorkovnÃ­c",
            formulasOverLimit: "Okolo %{count} vÃ½sledkov. ProsÃ­m, zadejte viac znakov.",
            foundFormulas: "%{count} nÃ¡jdenÃ½ch receptÃºr",
            help: "NÃ¡poveda:",
            helpText:
                "Zadejte naprÃ­klad '%{filter}' k nÃ¡jdeniu receptury zaÄÃ­najÃºcej sa na '%{formula}', produktu zaÄÃ­najÃºceho sa na '%{product}' a vzorkovnice '%{fandeck}'.",
            productFilter: "Filter produktov",
            searchInFormulas: "HÄ¾adaÅ¥ v receptÃºrach",
            typeMore: "ProsÃ­m, zadejte viac znakov"
        },
        menu: {
            actionHistory: "HistÃ³ria udalostÃ­",
            additionalFormulaTab: "DodatoÄnÃ¡ karta receptÃºry",
            advancedSettings: "PokroÄilÃ© nastavenia",
            autotaskSettings: "Nastavenie automatickÃ½ch Ãºkonov",
            availableDatabases: "DostupnÃ© databÃ¡zy",
            availablePrices: "DostupnÃ© ceny",
            bugReport: "HlÃ¡senie o chybe",
            canisterBarcodes: "ÄiarovÃ© kÃ³dy kanistrov",
            canisterDispensingLogic: "Logika tÃ³novania",
            canisterFilling: "Plnenie kanistrov",
            canisterSettings: "Nastavenie kanistrov",
            clientServerSettings: "Nastavenie klienta/serveru",
            closing: "ZatvÃ¡ranie",
            color: "Farba",
            colorModification: "ModifikÃ¡cia farby",
            colorPanel: "Nastavenie farebnej palety",
            colorRepresentation: "ReprezentÃ¡cia farby a Ãºdaje",
            colorSearch: "HÄ¾adanie farby",
            colorant: "Kolorant",
            colorantConsumption: "Spotreba kolorantov",
            colorantPricing: "Ceny za koloranty",
            colorantRefillHistory: "HistÃ³ria doplÅovania kolorantov",
            competitiveSearch: "HÄ¾adanie v konkurenÄnÃ½ch vzorkovniciach",
            connections: "Spojenie",
            currency: "Nastavenie mien",
            customData: "VlastnÃ© dÃ¡ta",
            database: "DatabÃ¡za",
            databaseCheck: "Kontrola databÃ¡ze",
            databaseConnection: "Pripojenie databÃ¡zy",
            defaultValues: "PÃ´vodne hodnoty",
            devices: "Zariadenia",
            dispensingHistory: "HistÃ³ria tÃ³novania",
            dispensingSettings: "Nastavenie tÃ³novania",
            driverSettings: "Nastavenie ovlÃ¡daÄa",
            environment: "Prostredie",
            environmentConfiguration: "Nastavenie prostredia",
            environmentalSettings: "Nastavenie prostredia",
            favorites: "ObÄ¾ÃºbenÃ©",
            fileTransfer: "DESO File Transfer",
            formatting: "FormÃ¡tovanie",
            formula: "Formula",
            formulaData: "Ãdaje k receptÃºre",
            formulaModification: "Formula modification",
            formulaPanels: "Panely receptÃºry",
            formulaSettings: "Nastavenia receptÃºry",
            formulaUnit: "Jednotka receptÃºry",
            generalSearch: "VÅ¡eobecnÃ© vyhÄ¾adÃ¡vanie",
            globalSettingsSearch: "VyhÄ¾adÃ¡vanie nastavenÃ­",
            helpItems: "Nastavenia podpory",
            importAndExport: "Import a export",
            importAndExportData: "Import a export dÃ¡t",
            importCustomData: "Import vlastnÃ½ch dÃ¡t",
            initialFormulaTab: "PoÄiatoÄnÃ¡ karta receptÃºry",
            interfaceSettings: "Nastavenie rozhrania",
            keyboardShortcuts: "KlÃ¡vesovÃ© skratky",
            language: "Jazyk",
            languageSettings: "Nastavenie jazyka",
            layout: "VzhÄ¾ad",
            license: "Licencia",
            licenseData: "Ãdaje o licencii",
            licenseIdentification: "IdentifikÃ¡cia licencie",
            licenseStatus: "Stav licencie",
            licenseSupplier: "PoskytovateÄ¾ licencie",
            licenseVersion: "Verzia licencie",
            localData: "LokÃ¡lne dÃ¡ta",
            machine: "Stroj",
            machineActions: "ServisnÃ© udalosti",
            machineAndDevices: "Stroj a zariadenia",
            machineManagement: "SprÃ¡va stroja",
            machineSettings: "Nastavenie stroja",
            mainSettings: "HlavnÃ© nastavenia",
            maintenance: "ÃdrÅ¾ba",
            marginAndDiscount: "MarÅ¾a a zÄ¾ava",
            matchingSearchResult: "Matching search result",
            matchingSettings: "Matching Settings",
            navigationItems: "NavigaÄnÃ© poloÅ¾ky",
            newFormulaWindow: "NovÃ© okno receptÃºry",
            orderSearch: "Nastavenie vyhÄ¾adÃ¡vania",
            orderSettings: "Nastavenie objednÃ¡vok",
            packageSurcharge: "PrÃ­platok za balenie",
            popUps: "Vyskakovacie oknÃ¡",
            posInfo: "InformÃ¡cie o predajni",
            price: "Nastavenie cien",
            priceManagement: "SprÃ¡va cien",
            priceSettings: "Nastavenie cien",
            pricingOptions: "MoÅ¾nosti cien",
            printSettings: "TlaÄ",
            productPricing: "Ceny za produkty",
            qualityControlSettings: "Quality Control Settings",
            quickTint: "RÃ½chle tÃ³novanie",
            rccConfig: "RCC konfigurÃ¡cia",
            rccConnection: "RCC pripojenie",
            rccSettings: "RCC nastavenie",
            refillSettings: "Refill Settings",
            refillingLogic: "Logika doplÅovania",
            registration: "RegistrÃ¡cia",
            searchSettings: "Nastavenie vyhÄ¾adÃ¡vania",
            serverPlugins: "Plugin zo servera",
            serviceActions: "ServisnÃ© Ãºkony",
            settings: "Nastavenia",
            simplifiers: "PomocnÃ­ci",
            singleActions: "JednorÃ¡zovÃ© Ãºkony",
            smartPurgeRules: "PravidlÃ¡ mÃºdreho odstreku",
            softwareOptions: "MoÅ¾nosti softvÃ©ru",
            spectroSettings: "Nastavenie spektrometra",
            statistics: "Å tatistika",
            switchToFrontdesk: "PrepnÃºÅ¥ na frontdesk",
            switchToFullRedlike: "PrepnÃºÅ¥ do %{name}",
            switchToLight: "PrepnÃºÅ¥ do %{name}",
            switchToMachine: "PrepnÃºÅ¥ na stroj",
            tabs: "Karty a vyskakovacie oknÃ¡",
            testBarcodes: "Test ÄiarovÃ½ch kÃ³dov",
            updateOptions: "MoÅ¾nosti aktualizÃ¡ciÃ­",
            userManagemenet: "SprÃ¡va pouÅ¾Ã­vateÄ¾ov",
            visibleUnits: "ViditeÄ¾nÃ© jednotky"
        },
        navBar: {
            barcode: "ÄiarovÃ½ kÃ³d",
            help: "Podpora",
            hideItems: "SkryÅ¥ produkty/vzorkovnice"
        },
        notificationPanel: {
            noNotifications: "Å½iadne novÃ© upozornenia"
        },
        tabBar: {
            closeActive: "ZatvoriÅ¥ aktÃ­vne",
            closeAll: "ZatvoriÅ¥ vÅ¡etko",
            closeAllExceptActive: "ZatvoriÅ¥ vÅ¡etko okrem aktÃ­vnej",
            customFormula: "Custom Formula",
            dispensingHistory: "HistÃ³ria tÃ³novania",
            favorites: "ObÄ¾ÃºbenÃ©",
            formulaSearch: "Formula search",
            rewriteSettings: "Re-write local settings"
        }
    },
    ordering: {
        assign: "PriradiÅ¥",
        assignment: "Priradenie",
        createdDate: "DÃ¡tum vytvorenia",
        finishDispensing: "DokonÄiÅ¥ tÃ³novanie",
        foundInOrders: "NÃ¡jdenÃ© v objednÃ¡vkach",
        inactiveDatabase: "ReceptÃºra je z neaktÃ­vnej alebo neznÃ¡mej databÃ¡zy %{0}",
        inactiveUnknownDatabase: "ReceptÃºra je z neaktÃ­vnej alebo neznÃ¡mej databÃ¡zy",
        newOrderReceived: "Prijali ste novÃº objednÃ¡vku!",
        noOrderSelected: "Nebola vybranÃ¡ Å¾iadna objednÃ¡vka",
        release: "UvoÄ¾niÅ¥",
        status: {
            accepted: "PrijatÃ¡",
            canceled: "ZruÅ¡enÃ¡",
            created: "VytvorenÃ¡",
            done: "HotovÃ¡",
            partlyDone: "ÄiastoÄne hotovÃ¡",
            preparing: "Pripravuje sa",
            unknown: "NeznÃ¡me"
        }
    },
    partialUpdates: {
        applying: "Applying partial updates",
        cantBeUsedForYourDbVersion: "Updates can't be used for this database. Please update via Helper.",
        newVersionWillBeInstalled: "It will install the new version including all available partial updates.",
        noPartialUpdatesAvailable: "No partial updates available",
        outOfDate: "out of date!",
        partialUpdates: "Partial updates",
        partialUpdatesArePreparing: "Partial updates are preparing",
        partialUpdatesAvailable: "Partial updates available!",
        preparedUpdatesMessage: "The following partial updates are prepared to be applied",
        remindMeLater: "Remind me later (after %{time} minutes)",
        swOutOfDate: "The current version of the software is",
        updateAutomatically: "If you do not response, update will start automatically in: %{time} s",
        updateToNewVersion: "Update to the newest version",
        updateWillTakeMoreTime: "The update will take more time.",
        updatesApplied: "Partial updates were successfully applied.",
        updating: "Updating"
    },
    posInfo: {
        address: "Adresa",
        contactName: "KontaktnÃ© meno",
        contactPerson: "KontaktnÃ¡ osoba",
        identification: "IdentifikÃ¡cia",
        machineInformation: "InformÃ¡cie o stroji",
        pos: "PredajÅa",
        secondAddress: "DruhÃ¡ adresa",
        shopIdentification: "IdentifikÃ¡cia predajne",
        shopName: "NÃ¡zov obchodu",
        url: "Url",
        zipCode: "PSÄ"
    },
    priceTypeList: {
        priceBasePurchase: "NÃ¡kupnÃ¡ cena bÃ¡zy",
        priceBaseSell: "PredajnÃ¡ cena bÃ¡zy",
        priceBaseSellFull: "PlnÃ¡ predajnÃ¡ cena bÃ¡zy",
        priceCntPurchase: "NÃ¡kupnÃ¡ cena kolorantov",
        priceCntPurchaseByColorantName: "NÃ¡kupnÃ¡ cena za kolorant %{0}",
        priceCntPurchaseByName: "NÃ¡kupnÃ¡ cena kolorantov podÄ¾a mena",
        priceCntSell: "PredajnÃ¡ cena kolorantov",
        priceCntSellByColorantName: "PredajnÃ¡ cena za kolorant %{0}",
        priceCntSellByName: "PredajnÃ¡ cena kolorantov podÄ¾a mena",
        priceCntSellFull: "PlnÃ¡ predajnÃ¡ cena kolorantov",
        priceCntSellFullByColorantName: "PlnÃ¡ predajnÃ¡ cena za kolorant %{0}",
        priceCntSellFullByName: "PlnÃ¡ predajnÃ¡ cena kolorantov podÄ¾a mena",
        priceGroupBarcode: "ÄiarovÃ½ kÃ³d cenovej skupiny",
        priceMarginAll: "MarÅ¾a vÅ¡etkÃ½ch balenÃ­",
        priceMarginPerPkg: "MarÅ¾a jednÃ©ho balenia",
        priceSellPriceAll: "PredajnÃ¡ cena vÅ¡etkÃ½ch balenÃ­",
        priceSellPricePerKg: "PredajnÃ¡ cena za kilogram",
        priceSellPricePerL: "PredajnÃ¡ cena za liter",
        priceSellPricePerPkg: "PredajnÃ¡ cena jednÃ©ho balenia",
        priceSurchargeAll: "PrÃ­platok za vÅ¡etky balenia",
        priceSurchargePerPkg: "PrÃ­platok za jedno balenie",
        priceTintPurchaseAll: "Cena tÃ³novania vÅ¡etkÃ½ch balenÃ­",
        priceTintPurchasePerPkg: "Cena tÃ³novania jednÃ©ho balenia",
        priceTintSellFullAll:
            "CelkovÃ¡ plnÃ¡ predajnÃ¡ cena za celÃ½ tÃ³novacÃ­ proces viacerÃ½ch balenÃ­ (zahÅÅa koloranty a prÃ­platok).",
        priceTintSellFullAllPerPackage:
            "CelkovÃ¡ plnÃ¡ predajnÃ¡ cena za celÃ½ tÃ³novacÃ­ proces jednÃ©ho balenia (zahÅÅa koloranty a prÃ­platok).",
        priceTotalPurchaseAll: "CelkovÃ¡ nÃ¡kupnÃ¡ cena za vÅ¡etky balenia",
        priceTotalPurchasePerKg: "CelkovÃ¡ nÃ¡kupnÃ¡ cena za kilogram",
        priceTotalPurchasePerL: "CelkovÃ¡ nÃ¡kupnÃ¡ cena za liter",
        priceTotalPurchasePerPkg: "CelkovÃ¡ nÃ¡kupnÃ¡ cena za jedno balenie",
        priceTotalSellFullAll: "CelkovÃ¡ plnÃ¡ predajnÃ¡ cena za vÅ¡etky balenia",
        priceTotalSellFullPerKg: "CelkovÃ¡ plnÃ¡ predajnÃ¡ cena za kilogram",
        priceTotalSellFullPerLiter: "CelkovÃ¡ plnÃ¡ predajnÃ¡ cena za liter",
        priceTotalSellFullPerPackage: "CelkovÃ¡ plnÃ¡ predajnÃ¡ cena za balenie"
    },
    pricing: {
        allBases: "VÅ¡etky bÃ¡zy",
        allPackages: "VÅ¡etky balenia",
        backup: "Backup",
        basesOfProduct: "BÃ¡ze produktu %{productName}",
        colorantPricing: "Ceny za koloranty",
        export: "Export",
        import: "Import",
        packagePricing: "Ceny za balenia",
        packageSurcharge: "PrÃ­platok za balenie",
        packages: "Balenie",
        packagesOfProduct: "Balenia produktu %{productName}",
        posCoeficient: "POS coeficient",
        priceGroupPricePerLiter: "Cena cenovej skupiny za liter",
        priceGroups: "CenovÃ© skupiny",
        pricePerLiter: "Cena za liter",
        productPricing: "Ceny za produkty",
        purchasePrice: "NÃ¡kupnÃ¡ cena",
        purchasePricePerLiter: "NÃ¡kupnÃ¡ cena za liter",
        sellPrice: "PredajnÃ¡ cena",
        surcharge: "PrÃ­platok"
    },
    print: {
        adminRightsRequired: "Na Ãºpravu alebo tvorbu novej Å¡ablÃ³ny sÃº potrebnÃ© prÃ¡va admina.",
        allowAutomaticPrint: "PovoliÅ¥ automatickÃº tlaÄ",
        allowPrintAfterDispensing: "PovoliÅ¥ tlaÄ po tÃ³novanÃ­",
        allowPrintBeforeDispensing: "PovoliÅ¥ tlaÄ pred tÃ³novanÃ­m",
        automaticPrint: "AutomatickÃ¡ tlaÄ",
        choosePrinter: "TlaÄiareÅ",
        chooseSettings: "UpraviÅ¥ nastavenia",
        chooseTemplate: "Vyberte Å¡ablÃ³nu",
        copies: "KÃ³pie",
        createTemplate: "VytvoriÅ¥ Å¡ablÃ³nu",
        createTemplateHint: "Vytvorte Ãºplne novÃº Å¡ablÃ³nu. UloÅ¾te ju do prieÄinka templates a reÅ¡tartujte RCC.",
        defaultPrinter: "TlaÄiareÅ",
        defaultSettings: "PÃ´vodnÃ© nastavenia",
        defaultTemplate: "PrednastavenÃ¡ Å¡ablÃ³na",
        editTemplate: "UpraviÅ¥ Å¡ablÃ³nu",
        editTemplateHint: "UpraviÅ¥ %{name}. Zmeny sa prejavia po reÅ¡tarte RCC.",
        noEditTemplate: "Niet Å¡ablÃ³ny na Ãºpravu",
        noPrinterSelected: "Nie je zvolenÃ¡ Å¾iadna tlaÄiareÅ",
        noPrintersAvailable: "Nie sÃº dostupnÃ© Å¾iadne tlaÄiarne",
        noTemplateSelected: "Nie je zvolenÃ¡ Å¾iadna Å¡ablÃ³na",
        noTemplatesAvailable: "Nie sÃº dostupnÃ© Å¾iadne Å¡ablÃ³ny",
        numberOfCopies: "PoÄet kÃ³piÃ­",
        openTemplateEditor: "OtvoriÅ¥ editor Å¡ablÃ³n",
        printAfterDispensing: "TlaÄ po tÃ³novanÃ­",
        printAsImage: "VytlaÄiÅ¥ ako obrÃ¡zok",
        printBeforeDispensing: "TlaÄ pred tÃ³novanÃ­m",
        printOnRequest: "TlaÄ na vyÅ¾iadanie",
        printOptions: "MoÅ¾nosti tlaÄe",
        printPagesAfterDispensing: "PoÄet kÃ³piÃ­ po tÃ³novanÃ­ plechovky",
        printPagesBeforeDispensing: "PoÄet kÃ³piÃ­ pred tÃ³novanÃ­m plechovky",
        printPreview: "NÃ¡hÄ¾ad tlaÄe",
        printSettings: "Nastavenie tlaÄe",
        printTaskLinkVariable: "Prepojenie na premennÃº",
        printVariable: "TlaÄovÃ¡ premennÃ¡",
        printerName: "NÃ¡zov tlaÄiarne",
        printerOptions: "VoÄ¾by tlaÄiarne",
        printerSettings: "Nastavenie tlaÄiarne",
        quickTintTemplate: "Å ablÃ³na rÃ½chleho tÃ³novania",
        setDefaultPrinter: "NastaviÅ¥ predvolenÃº tlaÄiareÅ",
        setDefaultTemplate: "NastaviÅ¥ predvolenÃº Å¡ablÃ³nu",
        setQuickTintTemplate: "NastaviÅ¥ Å¡ablÃ³nu rÃ½chleho tÃ³novania",
        showPreviewDialogBeforePrint: "ZobraziÅ¥ pred tlaÄou okno s nÃ¡hÄ¾adom",
        template: "Å ablÃ³na",
        templateName: "NÃ¡zov Å¡ablÃ³ny",
        templateSettings: "Nastavenie Å¡ablÃ³n"
    },
    printTemplate: {
        baseCode: "KÃ³d bÃ¡zy",
        baseName: "NÃ¡zov bÃ¡zy",
        bfs: "BFS",
        colorantType: "Colorant type",
        customerCity: "Mesto zÃ¡kaznÃ­ka",
        customerEmail: "E-mail zÃ¡kaznÃ­ka",
        customerName: "Meno zÃ¡kaznÃ­ka",
        customerPhone: "TelefÃ³n zÃ¡kaznÃ­ka",
        customerStreet: "Ulica zÃ¡kaznÃ­ka",
        customerZipCode: "PSÄ zÃ¡kaznÃ­ka",
        destinationOfUse: "Destination of use",
        infoBfsGrade: "Hodnota BFS",
        orderQrCode: "QR kÃ³d",
        packageOrderCount: "Poradie balenÃ­",
        posAddress: "Adresa predajne",
        posAddressSecond: "Adresa predajne 2",
        posCity: "Mesto predajne",
        posContact: "Kontakt na predajÅu",
        posEmail: "E-mail predajne",
        posPhone: "TelefÃ³n predajne",
        posUrl: "Url predajne",
        posZipCode: "PSÄ predajne",
        priceBasePurchaseWithTax: "NÃ¡kupnÃ¡ cena bÃ¡ze s DPH",
        priceBaseSellWithTax: "PredajnÃ¡ cena bÃ¡ze s DPH",
        priceCntPurchaseWithTax: "NÃ¡kupnÃ¡ cena kolorantov s DPH",
        priceCntTotalSellWithTax: "PredajnÃ¡ cena kolorantov s DPH",
        priceMarginAllWithTax: "MarÅ¾a za vÅ¡etky balenia s DPH",
        priceMarginPerPkgWithTax: "MarÅ¾a za jedno balenie s DPH",
        priceSellPriceAllWithTax: "PredajnÃ¡ cena za vÅ¡etky balenia s DPH",
        priceSellPricePerKgWithTax: "PredajnÃ¡ cena za kilogram s DPH",
        priceSellPricePerLWithTax: "PredajnÃ¡ cena za liter s DPH",
        priceSellPricePerPkgWithTax: "PredajnÃ¡ cena za jedno balenie s DPH",
        priceSurchargeAllWithTax: "PrÃ­platok za vÅ¡etky balenia s DPH",
        priceSurchargePerPkgWithTax: "PrÃ­platok za jedno balenie s DPH",
        priceTintPurchaseAllWithTax: "Cena tÃ³novania vÅ¡etkÃ½ch balenÃ­ s DPH",
        priceTintPurchasePerPkgWithTax: "Cena tÃ³novania jednÃ©ho balenia s DPH",
        priceTotalPurchaseAllWithTax: "CelkovÃ¡ nÃ¡kupnÃ¡ cena za vÅ¡etky balenia s DPH",
        priceTotalPurchasePerKgWithTax: "CelkovÃ¡ nÃ¡kupnÃ¡ cena za kilogram s DPH",
        priceTotalPurchasePerLWithTax: "CelkovÃ¡ nÃ¡kupnÃ¡ cena za liter s DPH",
        priceTotalPurchasePerPkgWithTax: "CelkovÃ¡ nÃ¡kupnÃ¡ cena za jedno balenie s DPH",
        productAltName: "Produkt",
        recipeInline: "ReceptÃºra"
    },
    products: {
        bases: "BÃ¡za",
        numberOfProducts: "PoÄet produktov",
        packagesFor: "Balenie pre",
        sizeOfPackage: "VeÄ¾kosÅ¥ balenia"
    },
    purgeModal: {
        purgeAll: "OdstreknÃºÅ¥ vÅ¡etko",
        purgeAllChannels: "Odstrek vÅ¡etkÃ½ch okruhov",
        purgeVolume: "Objem odstreku",
        startPurge: "ZaÄaÅ¥ s odstrekom"
    },
    qualityControl: {
        darker: "Darker",
        dispensedMeasuredFormula: "Dispensed (measured) formula",
        lighter: "Lighter",
        measureDispensedFormula: "Measure dispensed formula to calculate delta E",
        moreBlue: "More blue",
        moreGreen: "More green",
        moreRed: "More red",
        moreYellow: "More yellow",
        pleaseContinueToFormulaCorrection: "Please continue to formula correction",
        qualityControlFailed: "Quality control failed!",
        qualityControlPassed: "Quality control passed"
    },
    quickTint: {
        dispensingInProgress: "TÃ³novanie prÃ¡ve prebieha",
        dispensingIsNotAvailable: "TÃ³novanie nie je dostupnÃ©",
        machineNotConnected: "Stroj nie je pripojenÃ½",
        noColorantsSelected: "Nie sÃº zvolenÃ© Å¾iadne koloranty",
        noPrinterAvailable: "Nie je moÅ¾nÃ© tlaÄiÅ¥, pretoÅ¾e k dispozÃ­cii nie je Å¾iadna tlaÄiareÅ.",
        noTemplateAvailable: "Nie je moÅ¾nÃ© tlaÄiÅ¥, pretoÅ¾e k dispozÃ­cii nie je Å¾iaden tlaÄovÃ½ Å¡tÃ­tok.",
        overMaxCanisterSize: "MnoÅ¾stvo jednÃ©ho alebo viacerÃ½ch kolorantov je nad svojim maximom"
    },
    quickTintSettings: {
        alphabetically: "PodÄ¾a abecedy",
        byCanister: "PodÄ¾a kanistrov",
        closeAfterDispensing: "ZatvoriÅ¥ po tÃ³novanÃ­",
        closeBeforeDispensing: "ZatvoriÅ¥ pred tÃ³novanÃ­m",
        quickTintSettings: "Nastavenie rÃ½chleho tÃ³novania",
        sorting: "Usporiadanie",
        windowClosingRules: "PravidlÃ¡ pre zatvÃ¡ranie okien"
    },
    rccButtons: {
        abort: "ZruÅ¡iÅ¥",
        all: "VÅ¡etko",
        cancel: "ZruÅ¡iÅ¥",
        continue: "PokraÄovaÅ¥",
        help: "Pomoc",
        ignore: "IgnorovaÅ¥",
        no: "Nie",
        noToAll: "Nie pre vÅ¡etko",
        ok: "OK",
        postpone: "OdloÅ¾iÅ¥",
        resume: "PokraÄovaÅ¥",
        retry: "Znovu",
        skip: "PreskoÄiÅ¥",
        yes: "Ãno",
        yesToAll: "Ãno pre vÅ¡etko"
    },
    rccDialog: {
        98: "ProsÃ­m, overte bÃ¡zu %{0} ÄiarovÃ½m kÃ³dom.",
        99: "ProsÃ­m, vloÅ¾te bÃ¡zu %{0} a potvrÄte (kliknite na OK)",
        100: "Stroj je v chybovom stave, resetovaÅ¥ chyby?",
        101: "Stroj je v chybovom stave, nie je moÅ¾nÃ© pokraÄovaÅ¥",
        102: "Reset sa nepodaril, nie je moÅ¾nÃ© pokraÄovaÅ¥",
        103: "ReceptÃºra obsahuje neplatnÃ½ kolorant: %{0}",
        104: "ReceptÃºra obsahuje neplatnÃ© koloranty: %{0}",
        105: "Kolorant: %{0} je pod varovnou ÃºrovÅou",
        106: "Koloranty: %{0} sÃº pod varovnou ÃºrovÅou",
        107: "Kolorant: %{0} je pod kritickou ÃºrovÅou",
        108: "Koloranty: %{0} sÃº pod kritickou ÃºrovÅou",
        109: "VloÅ¾te plechovku",
        110: "VloÅ¾te plechovku: %{0} pre receptÃºru: %{1}",
        111: "Odoberte plechovku",
        112: "DierovaÅ¥ kanister?",
        113: "Resetovanie chyby, Äakajte prosÃ­m",
        114: "PosÃºvanie stola, Äakajte prosÃ­m",
        115: "Dierovanie kanistra, Äakajte prosÃ­m",
        116: "TÃ³novanie receptÃºry %{0}, Äakajte prosÃ­m|Balenie: %{1} z %{2}|Produkt: %{3}|BÃ¡za: %{4}|VeÄ¾kosÅ¥ plechovky: %{5}",
        117: "TÃ³novanie receptÃºry %{0}, Äakajte prosÃ­m|Balenie: %{1} z %{2}|Produkt: %{3}|BÃ¡za: %{4}|VeÄ¾kosÅ¥ plechovky: %{5}",
        118: "TÃ³novanie, Äakajte prosÃ­m|Balenie: %{0} z %{1}",
        119: "TÃ³novanie, Äakajte prosÃ­m|Balenie: %{0} z %{1}",
        120: "TÃ³novanie sa ruÅ¡Ã­, Äakajte prosÃ­m",
        121: "Overte kanister pomocou ÄiarovÃ©ho kÃ³du",
        122: "Overte plechovku bÃ¡zy pomocou ÄiarovÃ©ho kÃ³du|Produkt: %{0}|BÃ¡za: %{1}|VeÄ¾kosÅ¥ plechovky: %{2}",
        123: "TÃ³novanie bolo zruÅ¡enÃ©, Å¾elÃ¡te si tÃ³novanie obnoviÅ¥?",
        124: "Objavila sa chyba na stroji %{0} : %{1}. Å½elÃ¡te si obnoviÅ¥ tÃ³novanie?",
        125: "ProsÃ­m, uistite sa, Å¾e plechovka je skutoÄne vloÅ¾enÃ¡",
        126: "ProsÃ­m, uistite sa, Å¾e je vloÅ¾enÃ¡ novÃ¡ plechovka. TÃ³novanie prebehne od zaÄiatku",
        127: "Kolorant: %{0} je pod minimÃ¡lnym mnoÅ¾stvom pre tÃ³novanie. Å½elÃ¡te si pokraÄovaÅ¥ bez ohÄ¾adu na toto varovanie?",
        128: "Koloranty: %{0} jsou pod minimÃ¡lnym mnoÅ¾stvom pre tÃ³novanie. Å½elÃ¡te si pokraÄovaÅ¥ bez ohÄ¾adu na toto varovanie?",
        129: "ZvolenÃ¡ receptÃºra presahuje maximÃ¡lne moÅ¾nÃ© mnoÅ¾stvo kolorantov, celkovÃ© mnoÅ¾stvo kolorantov : %{0} %{1}, maximÃ¡lne moÅ¾nÃ© mnoÅ¾stvo kolorantov: %{2} %{3}. Å½elÃ¡te si pokraÄovaÅ¥ navzdory tomuto varovaniu?",
        130: "Stroj je v chybovom stave, resetovat chyby?",
        131: "Stroj je v chybovom stave, nie je moÅ¾nÃ© pokraÄovaÅ¥",
        132: "Reset se nepodaril, nie je moÅ¾nÃ© pokraÄovaÅ¥",
        133: "ReceptÃºra odstreku je prÃ¡zdna, nie je moÅ¾nÃ© pokraÄovaÅ¥",
        134: "ReceptÃºra odstreku obsahuje poloÅ¾ky, ktorÃ© nemÃ´Å¾u byÅ¥ odstreknutÃ©, chcete pokraÄovaÅ¥?",
        135: "VloÅ¾te plechovku pre odstrek",
        136: "Odoberte plechovku pre odstrek",
        137: "Chyby sa resetujÃº, Äakajte prosÃ­m",
        138: "PosÃºvanie stola, Äakajte prosÃ­m",
        139: "Prebieha odstrek, Äakajte prosÃ­m",
        140: "Prebieha odstrek, Äakajte prosÃ­m",
        141: "RuÅ¡Ã­ sa odstrek, Äakajte prosÃ­m",
        142: "Plechovka pre odstrek chÃ½ba, skontrolujte, Äi je vloÅ¾enÃ¡ sprÃ¡vne",
        143: "ReceptÃºra odstreku obsahuje poloÅ¾ky, ktorÃ© nemÃ´Å¾u byÅ¥ odstreknutÃ©, chcete pokraÄovaÅ¥?",
        144: "VloÅ¾te plechovku pre odstrek",
        145: "Pripravuje sa, Äakajte prosÃ­m",
        146: "UkonÄuje sa, Äakajte prosÃ­m",
        150: "Äistenie, Äakajte prosÃ­m",
        151: "Äistenie, Äakajte prosÃ­m",
        152: "Äistenie sa ruÅ¡Ã­, Äakajte prosÃ­m",
        160: "PremieÅ¡avanie, Äakajte prosÃ­m",
        161: "PremieÅ¡avanie, Äakajte prosÃ­m",
        162: "PremieÅ¡avanie sa ruÅ¡Ã­, Äakajte prosÃ­m",
        170: "MieÅ¡anie, Äakajte prosÃ­m",
        171: "MieÅ¡anie, Äakajte prosÃ­m",
        172: "MieÅ¡anie sa ruÅ¡Ã­, Äakajte prosÃ­m",
        180: "Zahajuje sa spojenie so strojom, Äakajte prosÃ­m",
        181: "Spojenie so strojom nemohlo byÅ¥ nadviazanÃ© %{0}: %{1}}",
        182: "Spojenie so strojom nemohlo byÅ¥ nadviazanÃ©. Pre viac informÃ¡ciÃ­ skontrolujte sÃºbory s logmi.",
        183: "V stroji chÃ½ba kolorant: %{0}, ktorÃ½ je definovanÃ½ v databÃ¡ze.",
        184: "V stroji chÃ½bajÃº koloranty: %{0}, ktorÃ© sÃº definovanÃ© v databÃ¡ze.",
        185: "UkonÄuje sa spojenie so strojom, Äakajte prosÃ­m",
        190: "Zatvorte vÅ¡etky servisnÃ© oknÃ¡, aby ste mohli pokraÄovaÅ¥",
        200: "Resetovanie, Äakajte prosÃ­m",
        201: "TvrdÃ© resetovanie, Äakajte prosÃ­m",
        202: "Zahajuje sa spojenie, Äakajte prosÃ­m",
        203: "Resetovanie chyb, Äakajte prosÃ­m",
        205: "VieÄko zvlhÄovaÄa trysky sa otvÃ¡ra, Äakajte prosÃ­m",
        206: "VieÄko zvlhÄovaÄa trysky sa zatvÃ¡ra, Äakajte prosÃ­m",
        207: "VieÄko zvlhÄovaÄa trysky v pohybe, Äakajte prosÃ­m",
        210: "Dierovanie, Äakajte prosÃ­m",
        211: "Å puntovanie, Äakajte prosÃ­m",
        215: "StÃ´l sa zdvÃ­ha, Äakajte prosÃ­m",
        216: "StÃ´l klesÃ¡, Äakajte prosÃ­m",
        217: "StÃ´l v pohybe, Äakajte prosÃ­m",
        220: "StÃ´l sa natÃ¡Äa na pozÃ­ciu pre doplnenie: %{0}, Äakajte prosÃ­m",
        221: "StÃ´l sa vracia do pÃ´vodnej pozÃ­cie, Äakajte prosÃ­m",
        222: "StÃ´l sa natÃ¡Äa, Äakajte prosÃ­m",
        230: "Stroj je zaneprÃ¡zdnenÃ½, Äakajte prosÃ­m",
        240: "Doplnenie kanistra %{0}",
        241: "ProsÃ­m, doplÅte kanister %{0}",
        242: "Polohovanie kanistra: %{0} (%{1}) na pozÃ­ciu pre doplnenie",
        243: "ProsÃ­m doplÅte kanister %{0} za pouÅ¾itia ÄiarovÃ©ho kÃ³du",
        244: "ProsÃ­m doplÅte kanister %{0} za pouÅ¾itia ÄiarovÃ©ho kÃ³du",
        250: "OdstrÃ¡Åte nÃ¡dobu na Å¡tetce, vyÄistite ju a naplÅte ju vodou podÄ¾a pokynov",
        251: "VrÃ¡Å¥te nÃ¡dobu na Å¡tetce spÃ¤t",
        254: "VieÄko zvlhÄovaÄa trysky sa otvÃ¡ra",
        255: "VyÄistite vieÄko zvlhÄovaÄa trysky podÄ¾a pokynov",
        256: "PotvrÄte, Å¾e Äistenie skonÄilo a vieÄko zvlhÄovaÄa trysky je spÃ¤Å¥ na svojom mieste",
        257: "VieÄko zvlhÄovaÄa trysky sa zatvÃ¡ra",
        260: "OdstrÃ¡Åte doÅ¡tiÄku a vyÄistite ju",
        261: "VrÃ¡Å¥te doÅ¡tiÄku spÃ¤Å¥",
        265: "VyÄistite stroj handriÄkou a odstrÃ¡Åte vÅ¡etko rozliate farbivo alebo inÃ© tekutiny",
        266: "Po dokonÄenÃ­ potvrÄte",
        270: "NaplÅte nÃ¡dobu zvlhÄovaÄa vodou a po dokonÄenÃ­ potvrÄte",
        271: "NaplÅte nÃ¡dobu zvlhÄovaÄa vodou a po dokonÄenÃ­ potvrÄte",
        272: "Hladina vody je stÃ¡le nÃ­zkÃ¡, skontrolujte ju znovu",
        273: "Hladina vody je stÃ¡le nÃ­zkÃ¡, skontrolujte ju znovu",
        274: "Skontrolujte hladinu vody v nÃ¡dobe zvlhÄovaÄa a ak treba, doplÅte ju",
        275: "Äakajte, prosÃ­m",
        280: "PoÄÃ­taÄ sa reÅ¡tartuje",
        281: "PoÄÃ­taÄ sa vypÃ­na",
        300: "ChÃ½ba plechovka s bÃ¡zou, skontrolujte, Äi je vloÅ¾enÃ¡ sprÃ¡vne",
        301: "Pripravuje sa, Äakajte prosÃ­m",
        302: "DokonÄuje sa, Äakajte prosÃ­m",
        303: "ReceptÃºra sa nemÃ´Å¾e vytÃ³novaÅ¥, lebo obsahuje kolorant %{0}, ktorÃ½ presahuje maximÃ¡lne tÃ³novateÄ¾nÃ© mnoÅ¾stvo z kanistra",
        304: "ReceptÃºra sa nemÃ´Å¾e vytÃ³novaÅ¥, lebo obsahuje kolorant %{0}, ktorÃ½ presahuje maximÃ¡lne tÃ³novateÄ¾nÃ© mnoÅ¾stvo z kanistrov",
        305: "Kolorant %{0} sa nemÃ´Å¾u vytÃ³novaÅ¥ naraz, chcete receptÃºru rozdeliÅ¥?",
        306: "Koloranty %{0} sa nemÃ´Å¾u vytÃ³novaÅ¥ naraz, chcete receptÃºru rozdeliÅ¥?",
        307: "Stroj nevytÃ³nuje kolorant %{0}, chcete pokraÄovaÅ¥ a pridaÅ¥ ho ruÄne?",
        308: "Stroj nevytÃ³nuje koloranty: %{0}, chcete pokraÄovaÅ¥ a pridaÅ¥ ich ruÄne?",
        309: "VybranÃ¡ receptÃºra je prÃ¡zdna, pouÅ¾ite plechovku bÃ¡zy ako takej",
        310: "NevytÃ³nuje sa Å¾iaden kolorant, pripravte plechovku bÃ¡zy na ruÄnÃ© doplnenie kolorantu",
        311: "OdstrÃ¡Åte plechovku bÃ¡zy a pripravte ju na ruÄnÃ© doplnenie kolorantu",
        312: "PridaÅ¥ ruÄne %{0} %{1} kolorantu: %{2}, po prevedenÃ­ potvrÄte",
        313: "TÃ³novaÅ¥ receptÃºru ruÄne",
        314: "VybranÃ¡ receptÃºra poruÅ¡uje pravidlo o preplnenÃ­, celkovÃ© mnoÅ¾stvo kolorantov: %{0} %{1}, maximÃ¡lne povolenÃ© mnoÅ¾stvo kolorantov: %{2} %{3}. Chcete pokraÄovaÅ¥ napriek tomuto varovaniu?",
        315: "Naskenujte alebo napÃ­Å¡te UFI kÃ³d balenia bÃ¡ze",
        316: "Naskenujte alebo napÃ­Å¡te UFI kÃ³d balenia bÃ¡ze|Produkt: %{0}|BÃ¡za: %{1}|Balenie: %{2}",
        317: "Prepare colorant: %{0} for manual addition, confirm when done",
        318: "Prepare colorants: %{0} for manual addition, confirm when done",
        319: "Add manually colorant: %{0}, confirm when done",
        320: "Add manually colorants: %{0}, confirm when done",
        400: "ZaÄne Ãºkon automatickÃ½ch odstrekov",
        401: "ZaÄne Ãºkon automatickÃ½ch odstrekov",
        405: "NÃ¡doba na Å¡tetce vyÅ¾aduje ÃºdrÅ¾bu",
        406: "NÃ¡doba na Å¡tetce vyÅ¾aduje ÃºdrÅ¾bu",
        410: "ZaÄne automatickÃ¡ ÃºdrÅ¾ba vieÄka",
        411: "ZaÄne automatickÃ¡ ÃºdrÅ¾ba vieÄka",
        415: "DoÅ¡tiÄka musÃ­ byÅ¥ vyÄistenÃ¡",
        416: "DoÅ¡tiÄka musÃ­ byÅ¥ vyÄistenÃ¡",
        420: "TÃ³novacÃ­ stroj musÃ­ byÅ¥ vyÄistenÃ½",
        421: "TÃ³novacÃ­ stroj musÃ­ byÅ¥ vyÄistenÃ½",
        425: "ZaÄne doplÅovanie kanistrov",
        426: "ZaÄne doplÅovanie kanistrov",
        430: "ReÅ¡tart poÄÃ­taÄa bol naplÃ¡novanÃ½",
        431: "ReÅ¡tart poÄÃ­taÄa bol naplÃ¡novanÃ½",
        435: "Vypnutie poÄÃ­taÄa bolo naplÃ¡novanÃ©",
        436: "Vypnutie poÄÃ­taÄa bolo naplÃ¡novanÃ©",
        440: "Umytie stroja bolo naplÃ¡novanÃ©",
        441: "Umytie stroja bolo naplÃ¡novanÃ©",
        445: "RecirkulÃ¡cia stroja bola naplÃ¡novanÃ¡",
        446: "RecirkulÃ¡cia stroja bola naplÃ¡novanÃ¡",
        450: "MieÅ¡anie stroja bolo naplÃ¡novanÃ©",
        451: "MieÅ¡anie stroja bolo naplÃ¡novanÃ©",
        990: "Objavila sa chyba v stroji %{0}: %{1} Chcete skÃºsiÅ¥ znovu?",
        991: "Objavila sa internÃ¡ chyba: %{0}",
        200000001: "VloÅ¾te plechovku",
        200000002: "Odoberte plechovku",
        200000003: "MnoÅ¾stvo %{0} pod minimÃ¡lnym mnoÅ¾stvom tÃ³novania, pokraÄovaÅ¥ na vlastnÃ© riziko?",
        200000004: "DoplniÅ¥ %{0}"
    },
    rccDriverSettings: {
        databasePath: "Cesta k databÃ¡ze",
        dispenser: "TÃ³novacÃ­ stroj",
        dispenserConfigurationFile: "KonfiguraÄnÃ½ sÃºbor stroja",
        driverPath: "Cesta k ovlÃ¡daÄu",
        extensionPath: "Cesta k sÃºboru s rozÅ¡Ã­renÃ­m",
        folder: "ZloÅ¾ka",
        formulaPath: "Cesta k sÃºboru s receptÃºrami",
        host: "Host",
        iddPath: "Cesta ku konfiguraÄnÃ©mu sÃºboru pre IDD",
        italtintoPath: "Cesta ku konfiguraÄnÃ©mu sÃºboru pre Italtinto",
        lldPath: "Cesta k LLD",
        machineType: "Typ stroja",
        noMachineAvailable: "Nie je k dispozÃ­cii Å¾iaden stroj",
        protocolVersion: "Verzia protokolu",
        rccDriverSettings: "Nastavenie ovlÃ¡daÄa",
        resultPath: "VÃ½slednÃ¡ cesta",
        save: "UloÅ¾iÅ¥ nastavenie",
        saveSettingsWarning: "Varovanie! Zmeny v tejto sekcii mÃ´Å¾u spÃ´sobiÅ¥ nefunkÄnosÅ¥ stroja.",
        serviceSwPath: "Cesta k servisnÃ©mu softvÃ©ru",
        simulationPath: "Cesta k simulaÄnÃ©mu sÃºboru"
    },
    rccMachineSettings: {
        allowManualColorantAddition: "PovoliÅ¥ ruÄnÃ© pridÃ¡vanie kolorantov",
        ask: "SpÃ½taÅ¥ sa",
        canHandlingOptions: "MoÅ¾nosti prÃ¡ce s plechovkou",
        checkCanBeforeDispense: "SkontrolovaÅ¥ plechovku pred tÃ³novanÃ­m",
        checkOverfill: "SkontrolovaÅ¥ preplnenie",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantPackageValidation: "Iba validÃ¡cia balenia kolorantu",
        disable: "ZakÃ¡zaÅ¥",
        dispenseInvalidColorants: "TÃ³novanie nezadanÃ½ch kolorantov",
        dispensingOptions: "MoÅ¾nosti tÃ³novania",
        enable: "PovoliÅ¥",
        enableUserIdentification: "IdentifikÃ¡cia uÅ¾Ã­vateÄ¾a",
        fullValidation: "PlnÃ¡ validÃ¡cia",
        machineAccuracyWarning: "Varovanie presnosti stroja",
        machineOptions: "VoÄ¾by stroja",
        machineUnit: "PouÅ¾iÅ¥ jednotku",
        minimalDispenseAmount: "MinimÃ¡lne mnoÅ¾stvo pro tÃ³novanie",
        placeCanSensor: "AutomatickÃ© potvrdenie vloÅ¾enia plechovky",
        placeCanSensorDelay: "SkontrolovaÅ¥ vloÅ¾enie plechovky po",
        rccMachineSettings: "Nastavenie stroja",
        refillBarcodeValidation: "Refill barcode validation",
        refillBarcodeValidationCanisterAndColorant: "Validate Canister and Colorant package",
        refillBarcodeValidationColorant: "Validate only colorant package",
        refillSettings: "Refill settings",
        removeCanSensor: "AutomatickÃ© potvrdenie odobratia plechovky",
        removeCanSensorDelay: "SkontrolovaÅ¥ odobratie plechovky",
        save: "UloÅ¾iÅ¥ nastavenia",
        sec: "sek.",
        skipPlaceCanDialog: "PreskoÄiÅ¥ dialÃ³g umiestnenia plechovky",
        skipRemoveCanDialog: "PreskoÄiÅ¥ dialÃ³g odobratia plechovky",
        splitFormula: "RozdeliÅ¥ receptÃºru",
        tmcEnabled: "PovoliÅ¥ TMC",
        ufiCode: "UFI code",
        validateBarcodeBaseCan: "OveriÅ¥ ÄiarovÃ½ kÃ³d plechovky",
        validateBarcodeRefill: "OveriÅ¥ ÄiarovÃ½ kÃ³d pred plnenÃ­m",
        validateColorantsDuringInit: "OveriÅ¥ koloranty pri zahÃ¡jenÃ­ spojenia"
    },
    rccPanel: {
        actionsRunningOnDispenser: "Na stroji prÃ¡ve prebiehajÃº Ãºlohy",
        addLevel: "PRIDAÅ¤ HLADINU",
        addManually: "PridaÅ¥ ruÄne",
        barcodeNotSet: "Kanister %{colorantName} (%{canisterName}) nemÃ¡ priradenÃ½ ÄiarovÃ½ kÃ³d.",
        cancel: "ZRUÅ IÅ¤",
        dispenseFormula: "TÃ³nuje sa receptÃºra",
        dispenserIdle: "Stroj je neÄinnÃ½",
        dispenserIsBusy: "Stroj je zaneprÃ¡zdnenÃ½",
        dispenserIsIdle: "Stroj je neÄinnÃ½",
        dispenserIsReady: "Stroj je pripravenÃ½ na ÄalÅ¡ie Ãºkony",
        dispensingFormula: "TÃ³novanie receptÃºry",
        errorCode: "KÃ³d chyby",
        explanation: "Vysvetlenie",
        fillToMax: "DoplniÅ¥ do maxima",
        finished: "UkonÄenÃ©",
        inProgress: "Prebieha",
        machineIsReady: "Stroj je pripravenÃ½",
        moveToFill: "PosunÃºÅ¥ na doplnenie",
        noMachineDialog: "Nie je pripojenÃ½ Å¾iaden stroj",
        of: "z",
        packageSize: "VeÄ¾kosÅ¥ balenia",
        placeBaseCan: "VloÅ¾te plechovku bÃ¡zy",
        pleaseCheckYourMachineConnection: "ProsÃ­m, skontrolujte pripojenie VÃ¡Å¡ho stroja",
        pleaseRefill: "ProsÃ­m doplniÅ¥",
        solution: "RieÅ¡enie",
        subErrors: "VedÄ¾ajÅ¡ie chyby",
        timeToEnd: "Äas do konca",
        tintingFormula: "TÃ³nuje sa receptÃºra",
        tintingPleaseWait: "TÃ³novanie, Äakajte prosÃ­m",
        validateBaseCan: "Overte plechovku bÃ¡zy",
        waiting: "ÄakÃ¡"
    },
    rccSettigns: {
        rccSettigns: "RCC nastavenie",
        rccUrl: "RCC url"
    },
    rccSpectroDialog: {
        100: "Pripojuje sa k VÃ¡Å¡mu zariadeniu pomocou Bluetooth. Uistite sa, Å¾e mÃ¡te spustenÃ© Bluetooth a VaÅ¡e zariadenie je zapnutÃ©.",
        101: "Zariadenie nebolo rozpoznanÃ©. Å½elÃ¡te si rozpoznaÅ¥ znova?",
        110: "Uistite sa, Å¾e je Nano pripojenÃ© a uskutoÄnite zahÃ¡jenie stlaÄenÃ­m tlaÄÃ­tka na VaÅ¡om zariadenÃ­.",
        111: "Nano nebolo rozpoznanÃ©. Å½elÃ¡te si rozpoznaÅ¥ znova?",
        112: "Odpojte Nano, poÄkajte 10 sekÃºnd, potom ho znova pripojte a pokraÄujte.",
        120: "PripÃ¡janie k zariadenu, Äakajte prosÃ­m",
        121: "Zariadenie nebolo nÃ¡jdenÃ©. Chcete to skÃºsiÅ¥ znovu?",
        200: "PoloÅ¾te zariadenie na Äiernu kalibraÄnÃº doÅ¡tiÄku a stlaÄte tlaÄÃ­tko na VaÅ¡om zariadenÃ­.",
        201: "PoloÅ¾te zariadenie na Äiernu kalibraÄnÃº doÅ¡tiÄku a pokraÄujte.",
        202: "PoloÅ¾te zariadenie na Äiernu kalibraÄnÃº doÅ¡tiÄku a stlaÄte tlaÄÃ­tko na VaÅ¡om zariadenÃ­.",
        205: "PoloÅ¾te zariadenie na bielu kalibraÄnÃº doÅ¡tiÄku a stlaÄte tlaÄÃ­tko na VaÅ¡om zariadenÃ­.",
        206: "PoloÅ¾te zariadenie na bielu kalibraÄnÃº doÅ¡tiÄku a pokraÄujte.",
        207: "PoloÅ¾te zariadenie na bielu kalibraÄnÃº doÅ¡tiÄku a stlaÄte tlaÄÃ­tko na VaÅ¡om zariadenÃ­.",
        210: "PoloÅ¾te zariadenie na diagnostickÃº doÅ¡tiÄku a pokraÄujte alebo stlaÄte tlaÄÃ­tko na VaÅ¡om zariadenÃ­.",
        211: "PoloÅ¾te zariadenie na diagnostickÃº doÅ¡tiÄku a pokraÄujte.",
        212: "PoloÅ¾te zariadenie na diagnostickÃº doÅ¡tiÄku a stlaÄte tlaÄÃ­tko na VaÅ¡om zariadenÃ­.",
        215: "Zatvorte kryt zariadenia a pokraÄujte alebo stlaÄte tlaÄÃ­tko na VaÅ¡om zariadenÃ­.",
        216: "Zatvorte kryt zariadenia a pokraÄujte.",
        217: "Zatvorte kryt zariadenia a stlaÄte tlaÄÃ­tko na VaÅ¡om zariadenÃ­.",
        220: "PoloÅ¾te zariadenie na zero doÅ¡tiÄku a pokraÄujte alebo stlaÄte tlaÄÃ­tko na VaÅ¡om zariadenÃ­.",
        221: "PoloÅ¾te zariadenie na zero doÅ¡tiÄku a pokraÄujte.",
        222: "PoloÅ¾te zariadenie na zero doÅ¡tiÄku a stlaÄte tlaÄÃ­tko na VaÅ¡om zariadenÃ­.",
        224: "Umiestnite inÅ¡trument na kalibraÄnÃº podloÅ¾ku a pokraÄujte alebo stlaÄte tlaÄidlo na zariadenÃ­",
        225: "Umiestnite inÅ¡trument na kalibraÄnÃº podloÅ¾ku a pokraÄujte",
        226: "Umiestnite inÅ¡trument na kalibraÄnÃº podloÅ¾ku stlaÄte tlaÄidlo na zariadenÃ­",
        227: "Umiestnite inÅ¡trument na kalibraÄnÃº podloÅ¾ku stlaÄte tlaÄidlo na zariadenÃ­",
        295: "DokonÄite kalibrÃ¡ciu v okne ovlÃ¡daÄa",
        296: "Zariadenie nie je pripojenÃ©, chcete ho pripojiÅ¥?",
        297: "PrÃ­prava na kalibrÃ¡ciu, Äakajte prosÃ­m",
        298: "Kalibruje sa, Äakajte prosÃ­m",
        299: "DokonÄovanie kalibrÃ¡cie, Äakajte prosÃ­m",
        300: "Umiestnite zariadenie nad vzorku a pokraÄujte alebo stlaÄte tlaÄÃ­tko na VaÅ¡om zariadenÃ­.",
        301: "Umiestnite zariadenie nad vzorku a pokraÄujte.",
        302: "Umiestnite zariadenie nad vzorku a pokraÄujte stlaÄenÃ­m tlaÄÃ­tka na VaÅ¡om zariadenÃ­.",
        303: "Zariadenie nie je nakalibrovanÃ©, chcete pokraÄovaÅ¥ s kalibrÃ¡ciou?",
        304: "Zariadenie nie je pripojenÃ©, chcete ho pripojiÅ¥?",
        390: "ZvoÄ¾te reÅ¾im merania",
        395: "DokonÄite meranie v okne ovlÃ¡daÄa",
        397: "Pripravuje sa meranie, Äakajte prosÃ­m",
        398: "Prebieha meranie, Äakajte prosÃ­m",
        399: "DokonÄuje sa meranie, Äakajte prosÃ­m",
        498: "SÅ¥ahujÃº sa merania, Äakajte prosÃ­m",
        499: "SÅ¥ahujÃº sa vÅ¡etky merania, Äakajte prosÃ­m",
        900: "Objavila sa chyba nÃ¡stroja %{0} : %{1} Chcete skÃºsiÅ¥ znova?",
        901: "Objavila sa internÃ¡ chyba: %{0}"
    },
    rccSpectroSettings: {
        DatacolorColorReader:
            "PoÄÃ­taÄ musÃ­ maÅ¥ pripojenie Bluetooth. Spektrometer musÃ­ byÅ¥ spÃ¡rovanÃ½ s poÄÃ­taÄom. VyÅ¾aduje sa Windows 10 s jesennÃ½m updatom 2018.",
        DatacolorSilent:
            "Pri pouÅ¾itia Silent mode sa ukazujÃº oknÃ¡ Datacoloru priamo v %{name}. V tÃ½chto oknÃ¡ch sa nedajÃº zmeniÅ¥ parametre spektrometra.",
        DatacolorUseDiagnosticTile: "PouÅ¾itie diagnostickej doÅ¡tiÄky zlepÅ¡Ã­ kvalitu merania.",
        comPort: "Com Port",
        diagnosticTile: "Datacolor s diagnostickou doÅ¡tiÄku",
        measureModes: "ReÅ¾imy merania",
        measureModesOrder: "Poradie reÅ¾imov merania",
        model: "Model",
        noSpectroAvailable: "Nie je k dispozÃ­cii Å¾iaden spektrometer",
        rccSpectroSettings: "Nastavenie spektrometra",
        save: "UloÅ¾iÅ¥ nastavenia",
        silent: "Datacolor Silent",
        simulationPath: "Cesta k simulaÄnÃ½m sÃºborom",
        spectroType: "Typ spektrometra",
        useProfiledValues: "PouÅ¾ite profilovanÃ© hodnoty"
    },
    recirculateChannels: {
        recirculateAllChannels: "RecirkulovaÅ¥ vÅ¡etky okruhy",
        recirculateChannels: "RecirkulovaÅ¥ okruhy",
        recirculatingSpeed: "RÃ½chlosÅ¥ recirkulÃ¡cie",
        recirculatingTime: "Trvanie recirkulÃ¡cie",
        startRecirculating: "ZahÃ¡jiÅ¥ recirkulÃ¡ciu"
    },
    redlikeLight: {
        finishPreviousSteps: "ProsÃ­m, dokonÄite predchÃ¡dzajÃºci krok",
        searchBySpectro: "HÄ¾adaÅ¥ spektrometrom",
        searchFormula: "HÄ¾adaÅ¥ receptÃºry",
        selectBase: "ZvoliÅ¥ bÃ¡zu",
        selectColor: "Vyberte odtieÅ",
        selectCustomer: "Vyberte zÃ¡kaznÃ­ka",
        selectFandeck: "Vyberte vzorkovnicu",
        selectPackage: "Vyberte balenie",
        selectProduct: "Vyberte produkt",
        startSelectFandeck: "ZaÄnite vyhÄ¾adanÃ­m vzorkovnice",
        startSelectProduct: "ZaÄnite vyhÄ¾adanÃ­m produktu",
        stepByStepProgress: "Postupujte krok za krokom",
        typeHereToSearch: "Tu vyhÄ¾adajte",
        typeToFilter: "Tu vyhÄ¾adajte"
    },
    restartModal: {
        computerNeedsRestart: "PoÄÃ­taÄ sa musÃ­ reÅ¡tartovaÅ¥!",
        notCompletelyTranslated:
            "Zmena jazyka si vyÅ¾aduje reÅ¡tart programu. Bez reÅ¡tartu nemusia byÅ¥ niektorÃ© Äasti programu Ãºplne preloÅ¾enÃ©.",
        restartIsRequired: "Po vykonanÃ­ zmien je nutnÃ½ reÅ¡tart programu.",
        softwareNeedsRestart: "%{name} vyÅ¾aduje reÅ¡tart!"
    },
    searchPanel: {
        basePlaceholder: "alebo napÃ­Å¡te nÃ¡zov bÃ¡ze",
        baseStartPlaceholder: "ZaÄnite pÃ­sanÃ­m nÃ¡zvu bÃ¡ze",
        colorCodeNamePlaceholder: "alebo napÃ­Å¡te kÃ³d/nÃ¡zov farby",
        colorCodeNameStartPlaceholder: "ZaÄnite pÃ­saÅ¥ kÃ³d/nÃ¡zov farby",
        colorCodePlaceholder: "alebo napÃ­Å¡te kÃ³d farby",
        colorCodeStartPlaceholder: "ZaÄnite pÃ­saÅ¥ kÃ³d farby",
        colorNameCodePlaceholder: "alebo napÃ­Å¡te nÃ¡zov/kÃ³d farby",
        colorNameCodeStartPlaceholder: "ZaÄnite pÃ­saÅ¥ nÃ¡zov/kÃ³d farby",
        colorNamePlaceholder: "alebo napÃ­Å¡te nÃ¡zov farby",
        colorNameStartPlaceholder: "ZaÄnite pÃ­saÅ¥ nÃ¡zov farby",
        colorPreviewIsNotAvailable: "Color preview is not available. Select a fandeck to see relevant color preview.",
        fandeckPlaceholder: "alebo napÃ­Å¡te nÃ¡zov vzorkovnice",
        fandeckStartPlaceholder: "ZaÄnite pÃ­saÅ¥ nÃ¡zov vzorkovnice",
        formulaByColor: "ReceptÃºra podÄ¾a farby",
        noResultsFound: "Neboli nÃ¡jdenÃ© Å¾iadne vÃ½sledky",
        packagePlaceholder: "alebo napÃ­Å¡te nÃ¡zov balenia",
        packageStartPlaceholder: "ZaÄnite pÃ­sanÃ­m nÃ¡zvu balenia",
        productPlaceholder: "alebo napÃ­Å¡te nÃ¡zov produktu",
        productStartPlaceholder: "ZaÄnite pÃ­saÅ¥ nÃ¡zov produktu",
        standard: "Å tandard",
        typeFandeckToFilter: "PÃ­sanÃ­m vyfiltrujete vzorkovnice",
        typeProductToFilter: "PÃ­sanÃ­m vyfiltrujete produkty"
    },
    sendOrderModal: {
        customNote: "VlastnÃ¡ poznÃ¡mka",
        noCompatibleServers: "Vo VaÅ¡ej sieti nie sÃº Å¾iadne kompatibilnÃ© servery",
        orderOverview: "PrehÄ¾ad objednÃ¡vky",
        selectTargetMachine: "ZvoliÅ¥ cieÄ¾ovÃ½ stroj",
        sendOrder: "OdoslaÅ¥ objednÃ¡vku",
        sendOrderTo: "VaÅ¡a objednÃ¡vka bude odoslanÃ¡ na %{serverName}",
        targetMachine: "CieÄ¾ovÃ½ stroj"
    },
    server: {
        computerId: "ID poÄÃ­taÄa",
        ip: "IP",
        selectServer: "Vyberte, prosÃ­m, jeden z dostupnÃ½ch serverov",
        server: "Server"
    },
    serverDialog: {
        1: "There is an error in the brand definition for your license. Please check with your provider.",
        2: "Could not process data for %{0}: %{1}",
        3: "Invalid network path.",
        4: "Invalid path type (only %{0} and %{1} types are supported)",
        5: "Error writing tinting file.",
        6: "Tinting file was created successfully.",
        7: "Could not find colorant with name: '%{0}' on row '%{1}'",
        8: "Could not find package with name: '%{0}' on row '%{1}'",
        9: "Could not find base in product with product name: '%{0}' and base name: '%{1}' on row '%{2}'",
        10: "Could not find base in product package with product name: '%{0}', base name: '%{1}' and package name: '%{2}' on row '%{3}'",
        11: "Could not parse price value: '%{0}' on row '%{1}' in sheet '%{2}'",
        12: "Preparing bases data, please wait",
        13: "Preparing bases in products data, please wait",
        14: "Preparing base packages data, please wait",
        15: "Preparing colors data, please wait",
        16: "Preparing colors in fandecks data, please wait",
        17: "Preparing fandecks data, please wait",
        18: "Preparing data for global search, please wait",
        19: "Preparing products data, please wait",
        30: "Partial updates can't be applied on database '%{0}'. Update your software to the latest version. Minimal required version is '%{1}'.",
        31: "Partial updates can't be applied on database '%{0}'. Database versions doesn't match. Contact your technical support.",
        32: "Partial updates can't be applied on database '%{0}'. Database structure version doesn't match. Contact your technical support.",
        33: "Partial updates can't be applied on database '%{0}'. The update is corrupted. Contact your technical support.",
        34: "Unknown error occurred during partial update. If this error repeats contact your technical support.",
        35: "No partial updates available. Please check your internet connection or contact your technical support.",
        36: "Prepared partial updates for database '%{0}' are for newer version of Redlike. Update your Redlike to the latest version. Minimal required version is '%{1}'.",
        37: "Partial updates can't be prepared. There is not enough space on the drive. Minimal required space is 20 GB.",
        38: "Partial updates can't be applied on database '%{0}'. The update is invalid. Contact your technical support.",
        39: "Partial updates can't be applied on database '%{0}'. The update can't be downloaded. Contact your technical support.",
        40: "Partial updates can't be applied on database '%{0}'. Downloaded file is corrupted. Contact your technical support."
    },
    serverPlugins: {
        activeServerPlugins: "AktÃ­vne pluginy serveru",
        currentlyActive: "MomentÃ¡lne aktÃ­vne pluginy",
        plugin: "Plugin",
        pluginName: "NÃ¡zov pluginu",
        statusActive: "AktÃ­vny",
        statusInactive: "NeaktÃ­vny"
    },
    serviceActionsSettings: {
        canisterLevel: "Ãrovne kanistrov",
        capClose: "ZatvoriÅ¥",
        capMiddle: "Stred",
        capOpen: "OtvoriÅ¥",
        cleanAllChannels: "VyÄistiÅ¥ vÅ¡etky kanÃ¡ly",
        cleanChannels: "VyÄistiÅ¥ kanÃ¡ly",
        computer: "PoÄÃ­taÄ",
        computerReboot: "ReÅ¡tartovaÅ¥ poÄÃ­taÄ",
        computerShutdown: "VypnÃºÅ¥ poÄÃ­taÄ",
        connectMachine: "PripojiÅ¥ stroj",
        general: "HlavnÃ©",
        initialize: "ZahÃ¡jiÅ¥",
        noMachineIsConnected: "Nie je pripojenÃ½ Å¾iaden stroj",
        plug: "Å puntovaÅ¥",
        plugger: "Å puntovaÄ",
        punch: "DierovaÅ¥",
        puncher: "DierovaÄ",
        purgeChannels: "Odstrek kanistrov",
        recirculate: "RecirkulÃ¡cia",
        recirculateAllChannels: "RecirkulovaÅ¥ vÅ¡etky okruhy",
        recirculateChannels: "RecirkulovaÅ¥ okruhy",
        serviceActions: "ServisnÃ© akcie",
        setCanisterLevel: "NastaviÅ¥ Ãºrovne kanistrov",
        shelfDown: "PosunÃºÅ¥ stÃ´l dole",
        shelfUp: "PosunÃºÅ¥ stÃ´l hore",
        showServiceWindow: "UkÃ¡zaÅ¥ servisnÃ© okno",
        smartPurgeAllChannels: "MÃºdry odstrek vÅ¡etkÃ½ch okruhov",
        smartPurgeChannels: "MÃºdry odstrek okruhov",
        startErrorReset: "SpustiÅ¥ reÅ¡tartovanie chyby",
        startHardReset: "SpustiÅ¥ hard reset",
        startReset: "SpustiÅ¥ reset",
        stirAllCanisters: "PremieÅ¡aÅ¥ vÅ¡etky kanistre",
        stirCanisters: "PremieÅ¡aÅ¥ kanistre",
        stirCanistersMore: "PremieÅ¡aÅ¥ kanistre"
    },
    spectroMode: {
        eggshell: "Eggshell",
        flat: "Flat",
        gloss: "Gloss",
        matt: "Matt",
        matte: "Matte",
        pearl: "Pearl",
        satin: "Satin",
        selectGlossLevel: "Compare the color sample to the gloss scale and select gloss level",
        semiGloss: "Semi-Gloss"
    },
    spectroTab: {
        bestMatch: "The best match",
        calibrate: "KalibrovaÅ¥",
        calibrateInstrument: "Kalibrovanie zariadenia",
        connectDevice: "PripojiÅ¥ zariadenie",
        connectedTo: "PripojenÃ© k",
        connectingDevice: "VaÅ¡e zariadenie sa pripÃ¡ja",
        deselectAll: "OdznaÄiÅ¥ vÅ¡etko",
        deviceCalibrated: "Your device has been calibrated and you can start measuring",
        deviceIsNotCalibrated: "VaÅ¡e zariadenie nie je kalibrovanÃ©",
        eraseResult: "VymazaÅ¥ vÃ½sledok",
        filter: "Filter",
        foundInFormulas: "NÃ¡jdenÃ© v receptÃºrach",
        inactiveSpectro: "The Spectro function is inactive for selected brand.",
        instrumentCalibration: "VaÅ¡e zariadenie sa musÃ­ nakalibrovaÅ¥.",
        manualInput: "RuÄnÃ½ vstup",
        measure: "MeraÅ¥",
        measurementResult: "VÃ½sledok merania",
        noFilters: "Å½iadne dostupnÃ© filtre",
        noFormulas: "Neboli nÃ¡jdenÃ© Å¾iadne receptÃºry",
        noSelectedSpectro: "Nie je zvolenÃ½ Å¾iaden spektrometer",
        notSelected: "NevybranÃ©",
        pressConnectButton: "Uistite sa, Å¾e je VaÅ¡e zariadenie pripojenÃ© a stlaÄte tlaÄÃ­tko pripojiÅ¥",
        searchFormulas: "HÄ¾adaÅ¥ receptÃºry",
        selectSpectro: "ZvoÄ¾te spektrometer",
        showDetails: "ZobraziÅ¥ detaily",
        skipCalibration: "PreskoÄiÅ¥ kalibrÃ¡ciu",
        spectroIsConnected: "Spektrometer je pripojenÃ½",
        spectroIsReady: "Spektrometer je pripravenÃ½",
        spectroReady: "Zariadenie je pripravenÃ©",
        startCalibrateNow: "ZaÄaÅ¥ kalibrÃ¡ciu teraz",
        startMeasureText: "VaÅ¡e zariadenie je kalibrovanÃ© a mÃ´Å¾ete zaÄaÅ¥ meraÅ¥",
        tolerance: "Delta E (CIE 2000)",
        toleranceOfDevitation: "Delta E (CIE 2000) tolerancia"
    },
    statisticsTab: {
        allRecords: "All records",
        customPackageName: "VlastnÃ© %{1} %{2}",
        deleteSelectedRecords: "VymazaÅ¥ vybranÃ© zÃ¡znamy",
        exportHistory: "Export histÃ³rie",
        finishFormula: "DokonÄiÅ¥ receptÃºru",
        foundInFormulas: "NÃ¡jdenÃ© v receptÃºrach",
        hideHiddenRecords: "NeukazovaÅ¥ skrytÃ© zÃ¡znamy",
        hideSelectedRecord: "SkryÅ¥ vybranÃ½ zÃ¡znam",
        historicalFormula: "HistorickÃ¡ receptÃºra",
        onlyFiltered: "Only filtered",
        restoreSelectedRecord: "ObnoviÅ¥ vybranÃ½ zÃ¡znam",
        showAllRecords: "UkÃ¡zaÅ¥ vÅ¡etky zÃ¡znamy",
        standardFormula: "Standard formula",
        unknownFormula: "NeznÃ¡ma receptÃ¤ra"
    },
    stirCanisters: {
        selectCanisters: "VÃ½ber kanistrov",
        startStirring: "ZaÄaÅ¥ premieÅ¡avanie",
        stirAllCanisters: "PremieÅ¡aÅ¥ vÅ¡etky kanistre",
        stirCanisters: "PremieÅ¡aÅ¥ kanistre",
        stirringSpeed: "RÃ½chlosÅ¥ premieÅ¡avania",
        stirringTime: "Trvanie premieÅ¡avania"
    },
    stock: {
        addColorant: "Add colorant...",
        addColorantPackagesToStock: "Add colorant packages to stock",
        addPackagesToStock: "Add packages to stock",
        addedToStock: "Added to stock",
        allDatabases: "All databases",
        checkStockPackageInventory: "If you used package from stock, please check if your stock inventory is valid.",
        clearAllItems: "Clear all items",
        colorantInventory: "Colorant inventory",
        colorantsStockInventory: "Colorants stock inventory",
        confirmSendingOrder: "Confirm sending order",
        consumptionPrediction: "Consumption prediction for the next %{weeks} weeks",
        createOrder: "Create order (%{sum})",
        expirationDate: "Expiration date",
        inDelivery: "In delivery",
        manualOrder: "Manual order",
        manualOrderProgress: "Step %{step}/%{total}",
        noPackagesFoundInStockForColorant: "There are no packages in stock for this colorant.",
        onStock: "In stock",
        orderSummary: "Order summary",
        prediction: "Prediction",
        removePackageFromStock: "Remove %{colorantName} package from stock",
        removePackageNameFromStock: "Would you like to remove one %{packageName} package from stock?",
        scanBarcodeOrSelectColorant: "Scan barcode from package or select colorant",
        selectPackageToRemove: "Select package to remove",
        sendConfirmed: "Send confirmed",
        setAmountsByPrediction: "Set amounts by prediction",
        sortByColorantName: "Sort by colorant name",
        sortByOrderNeed: "Sort by need to order",
        sortByStockLevel: "Sort by stock level",
        toOrder: "To order"
    },
    testBarcode: {
        noItemAssigned: "K ÄiarovÃ©mu kÃ³du nie je priradenÃ¡ Å¾iadna poloÅ¾ka %{code}",
        pleaseScanBarcode: "ProsÃ­m, naskenujte ÄiarovÃ½ kÃ³d bÃ¡zy, produktu, balenia alebo inej poloÅ¾ky",
        testBarcodes: "Test ÄiarovÃ½ch kÃ³dov"
    },
    ticketing: {
        answer: "Answer",
        answered: "Answered",
        chooseType: "Choose type",
        closeRequest: "Close request",
        comment: "Comment",
        create: "Create",
        createNewTicket: "Create new ticket",
        formulaAttached: "The requested formula is attached to the answer. Click the %{loadFormula} button to open it.",
        formulaClaim: "Formula claim",
        formulaRequest: "Formula request",
        formulaUnrealizable: "The requested formula is unrealizable.",
        newTicket: "New ticket",
        noPosInfoFound: "POS information (name, city) not found",
        noTicketSelected: "No ticket selected",
        openTicket: "Open ticket",
        posName: "POS name",
        posted: "Posted",
        request: "Request",
        requestDate: "Request date",
        requestId: "Request ID",
        resolvedBy: "Resolved by",
        responseDate: "Response date",
        saveToCustomFormula: "Save to custom formula",
        sending: "Sending",
        service: "Service",
        successfulCreation: "Ticket successfully created. Sending...",
        ticketAnswered: "A ticket has been answered.",
        ticketDelivered: "A ticket has been delivered.",
        ticketId: "Ticket ID",
        ticketType: "Ticket type",
        waitingForAnswer: "Waiting for answer"
    },
    tutorial: {
        last: "PoslednÃ©",
        next: "ÄalÅ¡ie"
    },
    ufiCodeModal: {
        currentStatus: "SÃºÄasnÃ½ stav",
        detailedInfoForColorant: "DetailnÃ© informÃ¡cie o kolorante %{colorantName}",
        userSetUfiCode: "PouÅ¾Ã­vateÄ¾ nastavil UFI kÃ³d, sÃºÄasnÃ¡ hodnota"
    },
    ufiCodeSettings: {
        baseUfiCodeValidation: "ValidÃ¡cia UFI kÃ³du bÃ¡ze",
        confirmColorantRefilling: "Potvrdenie doplnenia kolorantu",
        enableUfiCodes: "PovoliÅ¥ UFI kÃ³dy",
        printUfiCode: "TlaÄiÅ¥, ak je mnoÅ¾stvo kolorantu cez",
        printUfiCodePercentage: "TlaÄiÅ¥ percentÃ¡, ak je mnoÅ¾stvo kolorantu cez",
        scanOrTypeUfiCode: "Naskenujte alebo napÃ­Å¡te UFI kÃ³d",
        scanOrTypeUfiCodeOfBase: "Naskenujte alebo napÃ­Å¡te UFI kÃ³d bÃ¡ze",
        ufiCodesByPercentage: "PouÅ¾iÅ¥ UFI kÃ³dy podÄ¾a percentuÃ¡lneho zastÃºpenia",
        ufiCodesFromDatabase: "PouÅ¾iÅ¥ UFI kÃ³dy z databÃ¡ze",
        ufiCodesFromLastFilling: "PouÅ¾iÅ¥ UFI kÃ³dy z poslednÃ©ho plnenia"
    },
    userSettings: {
        addUser: "PridaÅ¥ pouÅ¾Ã­vateÄ¾a",
        assignedUserGroups: "PriradenÃ© skupiny pouÅ¾Ã­vateÄ¾ov",
        availableUserGroups: "DostupnÃ© skupiny pouÅ¾Ã­vateÄ¾ov",
        barcode: "ÄiarovÃ½ kÃ³d",
        confirmNewPassword: "PotvrdiÅ¥ novÃ© heslo",
        editPassword: "UpraviÅ¥ heslo",
        editUser: "UpraviÅ¥ pouÅ¾Ã­vateÄ¾a",
        enableAutoLogin: "PovoliÅ¥ automatickÃ© prihlasovanie",
        newPassword: "NovÃ© heslo",
        noChange: "Nebola vykonanÃ¡ Å¾iadna zmena",
        oldPassword: "StarÃ© heslo",
        password: "Heslo",
        passwordsDoNotMatch: "HeslÃ¡ sa nezhodujÃº",
        restoreUser: "Tento pouÅ¾Ã­vateÄ¾ bol zmazanÃ½. Chcete ho obnoviÅ¥?",
        userGroup: "User Group",
        userGroups: "Skupiny pouÅ¾Ã­vateÄ¾ov",
        userManagement: "SprÃ¡va uÅ¾Ã­vateÄ¾ov",
        userSettings: "Nastavenia pouÅ¾Ã­vateÄ¾a",
        username: "PouÅ¾Ã­vateÄ¾skÃ© meno",
        usernameIsMissing: "ChÃ½ba pouÅ¾Ã­vateÄ¾skÃ© meno."
    },
    warningMissingDataModal: {
        continue: "Same data is missing, do you want continue?",
        notFoundBase:
            "This product base is not available. Confirm and be careful to get compatible product base from shelf or cancel this order.",
        notFoundProduct:
            "This product is not available. Confirm and be careful to get compatible product from shelf or cancel this order."
    },
    weekdays: {
        friday: "Piatok",
        monday: "Pondelok",
        saturday: "Sobota",
        sunday: "NedeÄ¾a",
        thursday: "Å tvrtok",
        tuesday: "Utorok",
        wednesday: "Streda"
    },
    welcome: {
        availableDatabase: "Server sa nemÃ´Å¾e pripojiÅ¥ k databÃ¡ze. ProsÃ­m, skontrolujte nastavenie databÃ¡zy.",
        availableDatabaseLocalError: "Nastala chyba poÄas pripÃ¡jania sa k local databÃ¡ze (zlÃ½ sÃºbor, nesprÃ¡vne heslo)",
        availableDatabaseLocalMissing: "LokÃ¡lna databÃ¡za chÃ½ba",
        availableDatabaseLocalUpdate: "LokÃ¡lna databÃ¡za musÃ­ byÅ¥ aktualizovanÃ¡ na novÅ¡iu verziu",
        availableDatabaseMainAndLocalError:
            "Nastala chyba poÄas pripÃ¡jania sa k hlavnej aj lokÃ¡lnej databÃ¡ze (zlÃ© sÃºbory, nesprÃ¡vne heslo)",
        availableDatabaseMainAndLocalMissing: "ChÃ½bajÃº hlavnÃ¡ aj lokÃ¡lna databÃ¡za",
        availableDatabaseMainAndLocalUpdate: "Obe databÃ¡zy (hlavnÃ¡ i lokÃ¡lna) musia byÅ¥ aktualizovanÃ© na novÅ¡iu verziu",
        availableDatabaseMainError: "Nastala chyba poÄas pripÃ¡jania sa k main databÃ¡ze (zlÃ½ sÃºbor, nesprÃ¡vne heslo)",
        availableDatabaseMainMissing: "Main databÃ¡za chÃ½ba",
        availableDatabaseMainPartialUpdate: "Main database needs to be updated to the newer version via partial update",
        availableDatabaseMainPartialUpdateAndLocalUpdate:
            "Main database needs to be updated to the newer version via partial update and local database needs to be updated to the newer version",
        availableDatabaseMainUpdate: "Main databÃ¡za musÃ­ byÅ¥ aktualizovanÃ¡ na novÅ¡iu verziu",
        closing: "Program se zatvÃ¡ra",
        compatibility:
            "ProsÃ­m, skontrolujte verziu VaÅ¡eho serveru. Klient je kompatibilnÃ½ iba so serverom %{0} alebo vyÅ¡Å¡Ã­m.",
        compatibilityCheck: "Prebieha kontrola kompatibility",
        compatibilityDatabase:
            "VaÅ¡a databÃ¡za nie je kompatibilnÃ¡ so serverom. ProsÃ­m, skontrolujte nastavenie databÃ¡zy.",
        connectingServer: "Prebieha pripÃ¡janie k serveru %{ip}",
        databaseCompatibility: "VaÅ¡a databÃ¡za nie je kompatibilnÃ¡ so sÃºÄasnou verziou softwaru.",
        databasesCompatibility: "VaÅ¡e databÃ¡zy nie sÃº kompatibilnÃ© so sÃºÄasnou verziou softwaru.",
        licenseVerification: "Prebieha overovanie licencie",
        loading: "NaÄÃ­tavanie",
        lostConnection: "Spojenie so serverom bolo stratenÃ©",
        moduleMessage:
            "ProsÃ­m, venujte pozornosÅ¥ vÃ½beru modulu, dodatoÄnÃ¡ zmena modulu bude dostupnÃ¡ iba pre niektorÃ½ch pouÅ¾Ã­vateÄ¾ov.",
        refresh: "ObnoviÅ¥",
        restoring: "Obnova spojenia",
        selectModule: "ProsÃ­m, vyberte jeden z dostupnÃ½ch modulov.",
        stopUpdate: "ZruÅ¡iÅ¥ aktualizÃ¡ciu",
        updateDatabase: "AktualizovaÅ¥ databÃ¡zu",
        updatingDatabase: "DatabÃ¡za sa aktualizuje",
        updatingDatabases: "DatabÃ¡zy sa aktualizujÃº",
        updatingWarning: "Å truktÃºra databÃ¡zy sa aktualizuje na novÅ¡iu verziu, Äakajte, prosÃ­m.",
        updatingWarningInfo: "NezatvÃ¡rajte toto okno, inak sa aktualizÃ¡cia spustÃ­ odznova."
    }
};
